import {Component, OnInit, Inject, ViewChild, OnChanges, Directive, HostListener, Input} from '@angular/core';
import {FormControl, FormBuilder, FormGroup, Validators, FormGroupDirective, NgForm, NgModel} from '@angular/forms';
import {
    ErrorStateMatcher,
    MatSnackBar,
    MatDialog,
    MatDialogRef,
    MAT_DIALOG_DATA,
    MatCheckboxChange,
    MatCheckbox,
    MatChipInputEvent
} from '@angular/material';
import {Item} from '../item';
import {ConfService} from '../conf.service';
import {ActivatedRoute, Router} from '@angular/router';
import {KongService} from '../kong.service';
import {MatExpansionModule} from '@angular/material/expansion';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import {HttpClient} from '@angular/common/http';
import {MatStepper} from '@angular/material/stepper';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {CloudInfraManagerComponent} from '../settings/cloud-infra-manager/cloud-infra-manager.component';
import {EnvironmentManagerComponent} from '../settings/environment-manager/environment-manager.component';
import {EmailtemplateService} from '../emailtemplate.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {DatabaseManagerComponent} from '../settings/database-manager/database-manager.component';

import {StepperSelectionEvent} from '@angular/cdk/stepper';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {AppComponent} from '../app.component';
import {Loggedin} from '../authFilter/platformCentralAuth';
import {environment} from '../../environments/environment.prod';
import * as CryptoJS from 'crypto-js';
import {DialogModelSuccess} from '../shared/dialog/dialog-success/model';
import {DialogSuccessComponent} from '../shared/dialog/dialog-success/dialog-success.component';
import {DialogProgressComponent} from '../shared/dialog/dialog-progress/dialog-progress.component';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import {DatabasesListenerService} from '../databases-listener.service';
import {EnvironmentCreatorService} from '../environment-creator.service';
import {SignupProgressDataService} from './signup-progress/signup-progress-data.service';
import { AuthService } from '../user/auth.service';
import {PlatformAesService} from '../user/platform-aes.service';

@Directive({
    selector: 'mat-vertical-stepper'
})
export class MatVerticalStepperScrollerDirective {

    constructor(private stepper: MatStepper) {
    }

    @HostListener('selectionChange', ['$event'])
    selectionChanged(selection: StepperSelectionEvent) {
        const stepId = this.stepper._getStepLabelId(selection.selectedIndex - 1);
        const stepElement = document.getElementById(stepId);
        if (stepElement) {
            setTimeout(() => {
                stepElement.scrollIntoView({block: 'start', inline: 'nearest', behavior: 'smooth'});
            }, 250);
        }
    }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
}

declare let $;

// const incr = 5;
const incr = 20;

export interface DatabaseData {
    database_name: string;
    database_type: string;
    username: string;
    password: string;
    host: string;
    port: string;
    dbName: string;
    connectionString: string;
}

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css'],
    viewProviders: [MatExpansionModule],
    providers: [{
        provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
    }]
})
export class SignupComponent implements OnInit, OnChanges {

    @ViewChild('myCheckbox') private myCheckbox: MatCheckbox;
    @ViewChild('myCheckbox1') private myCheckbox1: MatCheckbox;
    @ViewChild('stepper') stepper: MatStepper;
    @ViewChild(CloudInfraManagerComponent) cloudInfraManager: CloudInfraManagerComponent;
    @ViewChild(EnvironmentManagerComponent) environmentManager: EnvironmentManagerComponent;
    @ViewChild(DatabaseManagerComponent) databaseManager: DatabaseManagerComponent;


    partner = '';

    isLinear = true;
    firstFormGroup: FormGroup;
    orgFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    requirementsGroup: FormGroup;
    orgCloudGroup: FormGroup;
    orgSiteGroup: FormGroup;
    orgEnvironmentGroup: FormGroup;
    orgDataStorageGroup: FormGroup;
    orgAPIGroup: FormGroup;
    orgCloudDevGroup: FormGroup;
    summaryGroup: FormGroup;
    time = 0;
    patchId: any;
    patchPayload: any;
    orgName: string;
    ciSelected = 'aws';
    progress2Start = true;
    progress3Start = true;
    progress4Start = true;
    progress5Start = true;
    progressStart = false;
    progressStart2 = false;
    progressStart3 = false;
    progressStart4 = false;
    progressStart5 = false;
    progressStart6 = false;
    progressStart7 = false;
    progressOver = false;
    progressOver2 = false;
    progressOver3 = false;
    progressOver4 = false;
    progressOver5 = false;
    progressOver6 = false;
    progressOver7 = false;
    partnerCheck = true;
    organizationBlock = false;
    showProgressInSummary = false;
    hide = true;
    confirmHide = true;
    columns: any;
    siteName: string;
    languageSelected = 'en';
    regions: any;
    regionSelected = 'us-east-1';
    pageLoading = true;

    content: boolean;
    email: string;
    phoneNumber: string;
    token: string;
    couponName: string;
    listCoupons: any;
    errorMessage: string;
    item: Item = {} as Item;
    progress = 0;
    confirmPassword: string;
    shortCodeInfo = '\n' +
        'Please use maximum of 14 characters.' +
        'Don\'t use space in between short code.' +
        'No Special Characters allowed.';
    startProgress = false;

    progressMessage: string;

    validation = false;
    partnerExistsValidation = false;
    passwordCheck = false;
    validationMessage: string;
    databaseTypes = [
        {'displayName': 'MongoDB', 'image': './assets/img/partnerOnboarding/mongoDB.png', 'value': 'mongodb'},
        {'displayName': 'DynamoDB', 'image': './assets/img/partnerOnboarding/dynamoDB.png', 'value': 'dynamodb'},
        {'displayName': 'PostgreSQL', 'image': './assets/img/partnerOnboarding/postgreySQL.png', 'value': 'postgresql'},
        {'displayName': 'MySQL', 'image': './assets/img/partnerOnboarding/mySQL.png', 'value': 'mysql'},
        {'displayName': 'MS SQL Server', 'image': './assets/img/partnerOnboarding/msSQL.jpg', 'value': 'sqlserver'},
        {'displayName': 'AuroraDB', 'image': './assets/img/partnerOnboarding/aurora.png', 'value': 'aurora'},
        {'displayName': 'CosmosDB', 'image': './assets/img/partnerOnboarding/cosmosDB.png', 'value': 'cosmos'}

        // { 'displayName': 'I want to use my Database', 'value': 'private' }
    ];
    languages: any;
    selectLanguages = [
        {'displayName': 'English', 'value': 'en'},
        {'displayName': 'Tamil', 'value': 'tamil'}
    ];
    cloudInfrastructure = [
        {'displayName': 'Amazon AWS', 'value': 'aws'},
        {'displayName': 'Microsoft Azure', 'value': 'azure'},
        {'displayName': 'Google Cloud Platform', 'value': 'gcm'}
    ];
    apiInfrastructure = [
        {'displayName': 'Pre-configured API Gateway Manager', 'value': 'default'},
        {'displayName': 'Kong', 'value': 'kong'},
        {'displayName': 'Google Apigee', 'value': 'apigee'}
    ];
    organizationSize = [
        {'displayName': 'I haven’t started selling yet - <5', 'value': '<5'},
        {'displayName': 'Just starting out - 5-10', 'value': '5-10'},
        {'displayName': 'Building a business - 10-100', 'value': '10-100'},
        {'displayName': 'Established business - 100-1000', 'value': '100-1000'},
        {'displayName': 'Enterprise>1000', 'value': '>1000'}
    ];
    APIsRequired = [
        {'displayName': '<10', 'value': '<10'},
        {'displayName': '10-50', 'value': '10-50'},
        {'displayName': '50-100', 'value': '50-100'},
        {'displayName': '>100', 'value': '>100'}
    ];
    hits = [
        {'displayName': '<1', 'value': '<1'},
        {'displayName': '1-5', 'value': '1-5'},
        {'displayName': '5-10', 'value': '5-10'},
        {'displayName': '>10', 'value': '>10'},
    ];

    // {'displayName': 'Oracle', 'value': 'oracle'},
    databaseSelected = 'mongodb';
    orgSize: string;
    reqAPIs: string;
    apiSelected = 'default';
    expectedHits: string;
    consumerCreated: any;
    appClient: any;
    appClientId: string;
    partnerExists: any;
    databasesPayload = [];
    databaseConnectionObject: any;
    showDefaultView = true;
    isPasswordsValid = false;
    passwordValidationStatement = '';
    siteValidationStatement = '';

    vaults = [
        {'name': 'Default', 'logo': './assets/img/partnerOnboarding/api.png', 'description': 'apiplatform\'s encryption mechanism'},
        {
            'name': 'AWS Secrets Manager',
            'logo': './assets/img/partnerOnboarding/awsSecretsMng.png',
            'description': 'Secure your password through AWS Secrets manager'
        },
        {
            'name': 'Hashicorp Vault',
            'logo': './assets/img/partnerOnboarding/hashiCorpVault.jpg',
            'description': 'Secure your password in Hashicorp\'s vault'
        },
    ];

    organizationTypes = [
        {
            'displayName': 'Startup/SMB',
            'type': 'StartUp',
            'image': './assets/img/partnerOnboarding/startup.png',
            'description': 'We are an early stage startup, small or medium business.'
        },
        {
            'displayName': 'Enterprise',
            'type': 'Enterprise',
            'image': './assets/img/partnerOnboarding/enterprise.jpg',
            'description': 'We are an enterprise.'
        },
        // {
        //     'displayName': 'Freelance Developer',
        //     'type': 'Freelance Developer',
        //     'image': './assets/img/partnerOnboarding/freelance.png',
        //     'description': 'I\'m a freelance developer.'
        // },
        {
            'displayName': 'Individual',
            'type': 'Individual',
            'image': './assets/img/partnerOnboarding/prodManager.png',
            'description': 'I\'m an individual developer, who wants to prototype an application.'
        }
    ];

    requirementsStrategy = [
        {
            'type': 'StartUp',
            'listOfAssistance': [
                {
                    'assistance': 'Application Development',
                },
                {
                    'assistance': 'Raise fund',
                },
                {
                    'assistance': 'Co-Develop',
                }
            ]
        },
        {
            'type': 'Enterprise',
            'listOfAssistance': [
                {
                    'assistance': 'Application Development',
                },
            ]
        },
        {
            'type': 'Freelance Developer',
            'listOfAssistance': [
                {
                    'assistance': 'Application Development',
                }
            ]
        },
        {
            'type': 'Product Manager',
            'listOfAssistance': [
                {
                    'assistance': 'Application Development',
                }
            ]
        }
    ];

    listOfUsages = [
        {
            itemName: 'Create and Launch Applications from scratch',
            isSelected: false,
            image: './assets/img/partnerOnboarding/create.jpg',
            key: 'Create'
        },
        {
            itemName: 'Modernize existing services and Transform legacy applications',
            isSelected: false,
            image: './assets/img/partnerOnboarding/transform.jpg',
            key: 'Transform'
        },
        {
            itemName: 'Integrate your application with third party services and APIs',
            isSelected: false,
            image: './assets/img/partnerOnboarding/integrate.png',
            key: 'Integrate'
        },
        {
            itemName: 'Secure access of services and manage application lifecycle',
            isSelected: false,
            image: './assets/img/partnerOnboarding/manage.png',
            key: 'Manage'
        }
    ];

    organizationPotential = [
        {
            potential: 'I need assisted services by apiplatform.io',
            key: 'Need Assistance'
        },
        {
            potential: 'I am well equipped to be on my own',
            key: 'Well Equipped'
        }
    ];

    assistanceByApiplatform = [
        {
            assistance: 'Development Support'
        },
        {
            assistance: 'Training Support'
        },
        {
            assistance: 'Technology Consulting'
        }
    ];

    cloudInfraList = [

        {
            cloudProvider: 'AWS',
            image: './assets/img/vault/awssecretsmanager.png',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications in AWS'
        },
        {
            cloudProvider: 'Azure',
            image: './assets/img/partnerOnboarding/azure.png',
            region: 'Central US',
            description: 'Host your applications in Azure'
        },
        {
            cloudProvider: 'GCP',
            image: './assets/img/vault/awssecretsmanager.png',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications in GCP'
        },
        {
            cloudProvider: 'On Premise',
            image: './assets/img/vault/awssecretsmanager.png',
            region: 'US-East (N.Virginia)',
            description: 'Host your applications on your premises'
        },
    ];

    environments = [
        {
            environment: 'Production',
            image: './assets/img/partnerOnboarding/production.jpg',
            description: 'Production Environment'
        },
        {
            environment: 'Development',
            image: './assets/img/partnerOnboarding/development.jpg',
            description: 'Development Environment'
        },
        {
            environment: 'QA',
            image: './assets/img/partnerOnboarding/QA.png',
            description: 'QA Environment'
        },
        {
            environment: 'Staging',
            image: './assets/img/partnerOnboarding/staging.jpg',
            description: 'Staging Environment'
        },
    ];

    APIGateways = [
        {
            gateway: 'apiplatform',
            image: './assets/img/partnerOnboarding/api.png',
            description: 'Default',
            value: 'default'
        },
        {
            gateway: 'Kong',
            image: './assets/img/kong.png',
            description: 'Kong',
            value: 'kong'
        },
        {
            gateway: 'Google',
            image: './assets/img/partnerOnboarding/apigee.png',
            description: 'APIGEE',
            value: 'apigee'
        },
        {
            gateway: 'Microsoft',
            image: './assets/img/partnerOnboarding/azure.png',
            description: 'Azure',
            value: 'azure'
        },
        {
            gateway: 'Amazon',
            image: './assets/img/partnerOnboarding/awsGateway.png',
            description: 'AWS API Gateway',
            value: 'aws'
        }
    ];

    installationType = [
        {
            installation: 'Proceed with standard installation',
            key: 'standard'
        },
        {
            installation: 'I want to customize my own infrastructure',
            key: 'custom'
        }
    ];

    devExUtilities = [
        {
            'displayName': 'DevEx Portal',
            'image': './assets/img/partnerOnboarding/portal.png',
            'description': 'Manage your content and testability for your APIs'
        },
        {
            'displayName': 'API Tester',
            'image': './assets/img/partnerOnboarding/tester.jpg',
            'description': 'Test your APIs and register them as well'
        },
        {
            'displayName': 'API Documentor',
            'image': './assets/img/partnerOnboarding/document.jpg',
            'description': 'Declaratively create your documentation for APIs'
        },
        {
            'displayName': 'HTML Documentor',
            'image': './assets/img/partnerOnboarding/html.jpg',
            'description': 'Create HTML content using WYSIWYG editor'
        }
    ];

    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];


    percentageToOffer: number;
    assistanceNeededFromApiplatform = [];
    selectedVault = {
        'name': 'Default',
        'logo': './assets/img/partnerOnboarding/api.png',
        'description': 'apiplatform\'s encryption mechanism'
    };
    usageList = [];
    selectedModeOfAssistance: any;
    selectedOrganizationType: any;
    selectedAssistance = 'Application Development';
    assistanceObject = [];
    selectedUsageRequirements = [];
    selectedOrganizationPotential: any;
    selectedEnvironment = [];
    customSelectedEnvironment = [];
    selectedInstallationType: any;
    // isOneStepInstallation: boolean;
    isOneStepInstallation = true;

    environmentResponse = [];

    currentEnvironmentBeingConfigured: string;

    tempSettingsPayload: any;
    // settingsPayload = {
    //     partner: '',
    //     account: '',
    //     email: '',
    //     phone_number: '',
    //     configurations: {
    //         databases: [
    //             {
    //                 database_name: '',
    //                 database_type: '',
    //                 region: '',
    //                 database_attributes: ''
    //             }
    //         ],
    //         gateways: [
    //             {
    //                 gateway_name: 'default',
    //                 gateway_type: '',
    //                 gateway_attributes: {}
    //             }
    //         ]
    //     },
    //     partner_settings: {
    //         secretsManager: [
    //             {
    //                 type: 'Default'
    //             }
    //         ],
    //         cloud_infrastructure: [
    //             {
    //                 cloud_provider: 'aws',
    //                 region: 'US-East (N.Virginia)'
    //             }
    //         ],
    //         environment: [
    //             {
    //                 environments: ['admin'],
    //                 is_custom: false,
    //                 custom_environments: []
    //             }
    //         ],
    //         API_gateways: ['default'],
    //         requirements_strategy: {
    //             type: '',
    //             assistance: '',
    //             usages: [],
    //             assistance_by_apiplatform: [],
    //             additional_requirement: '',
    //             offering_percentage: 20
    //         },
    //         organization_potential: '',
    //         devEx_services: ['DevEx Portal', 'API Tester', 'API Documentor', 'HTML Documentor']
    //     },
    //     environments: [],
    //     isEnabled: true
    // };

    settingsPayload = {
        partner_name: '',
        account_name: '',
        environment_type: '',
        partner: '',
        account: '',
        email: '',
        phone_number: '',
        environments: [
            {
                name: '',
                type: 'admin',
                cloud: [
                    {
                        type: 'aws',
                        primary_region: 'US-East (N.Virginia)',
                        regions: ['US-East (N.Virginia)'],
                        'is_default': true,
                        'audit_logs': [
                            {
                                action: 'CREATE',
                                by: this.email,
                                at: Date.now()
                            }
                        ],

                    }
                ],
                display_name: 'Administrator',
                is_validation_complete: false,
                is_creation_complete: false,
                is_enabled: true,
                services: [
                    {
                        name: 'Secrets Manager',
                        type: 'secretsmanager',
                        configurations: [
                            {
                                'name': 'Default',
                                'providerName': 'apiplatform.io',
                                'image': './assets/img/partnerOnboarding/api.png',
                                'description': 'apiplatform\'s encryption mechanism',
                                'owner': 'apiplatform.io',
                                'is_default': true,
                                'audit_logs': [
                                    {
                                        action: 'CREATE',
                                        by: this.email,
                                        at: Date.now()
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        name: 'Databases',
                        type: 'databases',
                        configurations: [
                            {
                                database_name: '',
                                database_type: '',
                                region: '',
                                database_attributes: {},
                                'is_default': true,
                                'audit_logs': [
                                    {
                                        action: 'CREATE',
                                        by: this.email,
                                        at: Date.now()
                                    }
                                ]
                            }
                        ]
                    }
                ],
                'audit_logs': [
                    {
                        action: 'CREATE',
                        by: this.email,
                        at: Date.now()
                    }
                ]
            }
        ],
        subscriptions: {
            providers: [],
            platform_services: [],
            platform_service_categories: []
        },
        is_enabled: true,
        logo: '',
        brand_image: ''
    };

    rolePayload = {
        role: '',
        permission_groups: [],
        permissions: [],
        roles: [],
        exclusions: [],
        partner: '',
        account: '',
        description: '',
        type: 'account'
    };

    userPayload = {
        partner: '',
        user: '',
        email: '',
        created_by: '',
        last_updated_by: '',
        environments: [
            {
                name: '',
                account: '',
                roles: [],
                password: '',
                shash: '',
                ralam: '',
                exclusions: {
                    permissions: [],
                    permission_groups: [],
                    roles: []
                },
                audit_logs: [
                    {
                        action: '',
                        by: ''
                    }
                ]
            }
        ],
        user_token: '',
        status: true,
        user_groups: []
    };

    selectedCloudInfra = this.settingsPayload.environments[0].cloud[0].type;
    URLArray = [];
    dnsValidationArray = [];
    orderOfEnvironments = [];

    URLObject = {};
    timesRan = 0;
    isVerified: boolean;
    tempURLObjectURLArray = [];
    environmentCreationRetries = 0;

    environmentResponseArray = [];
    tempStatusVerification = 'created';
    tempStatusEnvCreation = false;

    organizationSummary = [
        {
            title: 'Organization Name',
            content: ''
        },
        {
            title: 'Organization Size',
            content: ''
        },
        {
            title: 'Organization Type',
            content: ''
        }
    ];

    summary = [
        {
            title: 'Cloud Environment',
            content: this.ciSelected + ' : ' + this.regionSelected
        },
        {
            title: 'Database',
            content: this.databaseSelected
        },
        {
            title: 'API Gateway',
            // content: this.settingsPayload.configurations.gateways[0]['gateway_name']
        }
    ];
    isEnvironmentsCreationComplete = false;
    environmentCreationStart: boolean;

    containsDigit = false;
    containsLowerCase = false;
    containsUpperCase = false;
    containsSpecialCharacter = false;
    adminPkey: string;
    prodPkey: string;
    partnerShortCode: string;
    generatedPkey: any;
    isChecked = true;
    showDefaultEnvironments = true;
    isDirectNavigationToConsole: boolean;
    patchAdminPartnerSettingsRetries = 0;
    directNavigationToConsoleLoading = false;
    directNavigationToConsoleLoading1 = false;
    checkPartnerNameAvailabilityFlag = true;
    previousPartner = '';
    directNavigationEnvCreationComplete = false;
    previousId = 0;
    isPartnerAvailabilityCheckLoading = false;
    isValidPartnerShortcode = false;
    sendMailWhileOnboarding = false;
    iterationCount = 1000;
    keySize = 128;
    passphrase = environment.cipheringPhrase;
    password: string;
    htmlContent = '';

    directNavigationLoading = false;

    envPkeys = {};
    resendToken = false;
    mDialogRef: MatDialogRef<DialogProgressComponent, any>;
    isResendVerificationEmailSuccessful = false;
    resendVerificationRetries = 0;
    apiKeys: any;
    apiKeyData: any;
    apiKey: any;
    DNSValidationRetries = 0;
    envRecreationRetries = 0;

    JWTForThePartnerCreated: any;

    isLoginSet = false;

    constructor(public platform: LeftpanelComponent,
                private appComp: AppComponent,
                private httpClient: HttpClient,
                public dialog: MatDialog,
                private _formBuilder: FormBuilder,
                private confPost: ConfService,
                private kong: KongService,
                private router: Router,
                private Urlroute: ActivatedRoute,
                private emailTemplateInstance: EmailtemplateService,
                private _service: ConnecttocrudService,
                private auth: Loggedin,
                private authService: AuthService,
                private encryptionDecryptionService: PlatformAesService,
                private signupDataService: SignupProgressDataService,
                private envCreatorService: EnvironmentCreatorService) {
    }

    changeClient(data) {
        alert(this.cloudInfrastructure[data].value);
        if (this.cloudInfrastructure[data].value === 'aws') {
            alert('As of now we support only AWS Cloud Infra Structure. We planned to launch our platform in multi cloud Infrastructure by January,2020. Please select Amazon AWS as your cloud Infrastructure.' + data);
        }

    }

    ngOnChanges() {
    }

    async ngOnInit() {

        const that = this;
        $(document).ready(function () {
            for (let i = 0; i < that.listOfUsages.length; i++) {
                const id = 'selectedUsageRequirements' + i;
                $('#' + id).addClass('selectedUsageRequirements');
                // that.settingsPayload.partner_settings.requirements_strategy.usages.push(that.listOfUsages[i]['key']);
            }
        });

        this.keySize = this.keySize / 32;

        this.firstFormGroup = this._formBuilder.group({
            firstCtrl: ['', Validators.required],
            secondCtrl: ['', Validators.required],
            orgSiteNameCtrl1: ['', Validators.required]
        });

        this.orgFormGroup = this._formBuilder.group({
            orgNameCtrl: ['', Validators.required],
            orgSizeCtrl: ['', Validators.required]
        });
        this.secondFormGroup = this._formBuilder.group({
            secondCtrl: ['', Validators.required]
        });
        this.requirementsGroup = this._formBuilder.group({});
        this.orgEnvironmentGroup = this._formBuilder.group({});
        this.orgCloudGroup = this._formBuilder.group({
            orgCloudRegionCtrl: ['', Validators.required],
        });
        this.orgSiteGroup = this._formBuilder.group({
            orgSiteNameCtrl: ['', Validators.required]
        });
        this.orgDataStorageGroup = this._formBuilder.group({
            // orgDSNameCtrl: ['', Validators.required]
        });
        this.orgAPIGroup = this._formBuilder.group({
            orgAPIreqCtrl: ['', Validators.required],
            orgAPIhitsCtrl: ['', Validators.required]
        });


        this.getLanguages();
        this.getCloudRegions();

        // this.content = true;
        // this.pageLoading = false;

        this.Urlroute.queryParams
            .subscribe(params => {
                if (params.emailId && params.token) {
                    this.token = params.token;
                    this.adminPkey = params.token;
                    this.envPkeys['admin'] = this.adminPkey;
                    this.email = params.emailId;
                    this.settingsPayload.environments[0].cloud[0].audit_logs[0].by = this.email;
                    this.settingsPayload.environments[0].services[0].configurations[0].audit_logs[0].by = this.email;
                    this.settingsPayload.environments[0].services[1].configurations[0].audit_logs[0].by = this.email;
                    this.settingsPayload.email = params.emailId;
                    this.settingsPayload.phone_number = params.phoneNumber;
                    this.phoneNumber = params.phoneNumber;
                    this.phoneNumber = this.phoneNumber.replace(/ /gi, '+');
                    this.content = true;
                    this.getItem();

                    // Promise.all([platformServices, platformServiceCategories]).then(resp => {
                    this.confPost.verifyToken(params.emailId, params.token).subscribe(data => {
                        // (data);
                        if (data.status === 200) {
                            this.email = params.emailId;
                            this.content = true;
                            this.getItem();
                        } else if (data.status === 208) {
                            this.content = false;
                            this.errorMessage = 'Token is invalid. Please sign up to continue';
                        } else if (data.status === 401) {
                            this.content = false;
                            this.resendToken = true;
                        }
                        this.pageLoading = false;
                    }, error => {
                        if (error.status === 401) {
                            this.content = false;
                            this.resendToken = true;
                        }
                        this.pageLoading = false;
                        this.errorMessage = 'Token is invalid. Please sign up to continue';
                    });
                    // });
                }
                if (params.couponName) {
                    this.couponName = params.couponName;
                }
            });

    }

    getApiKeyForUser(signInEmail) {
        return new Promise((resolve, reject) => {
            this.kong.getKeyAuthForConsumerInApiGatewayByNameOrId(signInEmail).subscribe(async keys => {
                this.apiKeyData = keys;
                if (this.apiKeyData.data !== null && this.apiKeyData.data !== undefined && this.apiKeyData.data.length !== 0) {
                    this.apiKeys = this.apiKeyData.data;
                    this.apiKey = this.apiKeys[0].key;
                    localStorage.setItem('apikey', this.apiKey);
                    resolve('success');
                } else {
                    resolve('success');
                }
            }, async error => {
                let errorMessage = '';
                if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                    errorMessage = error.error.message;
                } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                    errorMessage = error.error;
                } else {
                    errorMessage = 'Error while getting an API Key for the partner : ' + this.partner + ' with email : ' + this.email + ' while onboarding';
                }
                await this.platform.notifyErrorToAdmins({error: 'Error while getting an API Key for the partner : ' + this.partner + ' with email : ' + this.email + ' while onboarding'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while getting an API Key for the partner : ' + this.partner + ' with email : ' + this.email + ' while onboarding', {email: signInEmail});
                resolve('failed');
            });
        });
    }

    sleep(milliseconds) {
        const date = Date.now();
        let currentDate = null;
        do {
            currentDate = Date.now();
        } while (currentDate - date < milliseconds);
    }

    openSuccess(response: string) {
        const alert: DialogModelSuccess = new DialogModelSuccess(
            response,
            '',
            null,
            null
        );

        this.mDialogRef = this.dialog.open(DialogSuccessComponent, {
            data: alert,
            disableClose: false
        });
    }

    resendVerification(payload) {
        this.confPost.resendVerificationEmail(payload).subscribe(async response => {
            this.isResendVerificationEmailSuccessful = true;
            this.pageLoading = false;
            this.openSuccess('Activation link has been successfully resent to your registered email. Please click on the link to complete the onboarding process.');
        }, async error => {
            this.resendVerificationRetries += 1;
            if (this.resendVerificationRetries <= 5) {
                setTimeout(() => {
                    this.resendVerification(payload);
                }, 5000);
            } else {
                let errorMessage = '';
                if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                    errorMessage = error.error.message;
                } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                    errorMessage = error.error;
                } else {
                    errorMessage = 'Error while resending activation link.';
                }
                await this.platform.notifyErrorToAdmins({error: 'Error while resending activation link for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while checking notify error to admins endpoint.', payload);
                this.platform.openSnackBar('Error while resending activation link. Sorry for the inconvenience. Please try again sometime.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.router.navigateByUrl('/auth/signup');
                this.pageLoading = false;
            }
        });
    }

    resendVerificationLink() {
        this.pageLoading = true;
        const payload = {
            email: this.email,
            phoneNumber: this.phoneNumber,
            token: this.token
        };
        this.resendVerification(payload);
    }

    goBack(stepper: MatStepper) {
        stepper.previous();
    }

    clearPartnerCheckFlag() {
        // if (this.partner !== '') {
        //     this.previousPartner = JSON.parse(JSON.stringify(this.partner));
        // }
    }

    encrypt(salt, iv, passPhrase, plainText, keySize, iterationCount) {
        const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {keySize: keySize, iterations: iterationCount});
        const encrypted = CryptoJS.AES.encrypt(
            plainText,
            key,
            {iv: CryptoJS.enc.Hex.parse(iv)});
        return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    }

    resetFlags() {
        this.isPartnerAvailabilityCheckLoading = false;
        this.isValidPartnerShortcode = false;
    }

    isContainsAlphaNumericInPartner() {
        return new Promise((resolve, reject) => {
            let i = 0;
            let character = '';
            let isContainsAlphabet = false;
            if (this.partner && this.partner !== null && this.partner !== undefined && this.partner !== '') {
                while (i <= this.partner.length) {
                    character = this.partner.charAt(i);
                    if ((character.charCodeAt(0) >= 65 && character.charCodeAt(0) <= 90) || (character.charCodeAt(0) >= 97 && character.charCodeAt(0) <= 122)) {
                        isContainsAlphabet = true;
                    }
                    i++;
                    if (i === this.partner.length) {
                        if (isContainsAlphabet) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    }
                }
            }
        });
    }


    validatePartnerShortcode() {
        this.partner = this.partner.toLowerCase();
        Promise.resolve(this.platform.specialCharAndSpaceValidatorOnPaste(this.partner)).then(resp1 => {
            if (resp1 === true) {
                this.isPartnerAvailabilityCheckLoading = false;
                this.isValidPartnerShortcode = false;
                this.siteValidationStatement = '';
                if (this.previousPartner !== this.partner) {
                    if (this.previousPartner === '') {
                        this.isPartnerAvailabilityCheckLoading = true;
                        // Check partner exist or not
                        this.appComp.reservationCollectionPayload.partner = this.partner;
                        this.confPost.checkPartnerShortcodeExistence(this.appComp.reservationCollectionPayload).subscribe(response => {
                            if (response && response !== undefined && response !== null) {
                                this.isPartnerAvailabilityCheckLoading = false;
                                if (response && response !== null && response !== undefined && response['message'] === false) {
                                    // Throw error partner already exists
                                    this.siteValidationStatement = 'Partner with this name already exists';
                                } else {
                                    Promise.resolve(this.isContainsAlphaNumericInPartner()).then(resp => {
                                        if (resp) {
                                            this.siteValidationStatement = '';
                                            this.isValidPartnerShortcode = true;
                                        } else {
                                            this.siteValidationStatement = 'Partner name should contain atleast one alphabet.';
                                        }
                                    });
                                    // Partner is available
                                    // Entry in services collection
                                    if (this.previousId !== 0) {
                                        const tempPayload = {
                                            forcedExpiration: true
                                        };
                                        this.confPost.patchEntityData('services', 'services', 'v2', 'reservationCollection', this.previousId, tempPayload).subscribe(response1 => {
                                            //assign ID created to previousId
                                            this.previousId = response['id'];
                                        }, async error => {
                                            await this.platform.notifyErrorToAdmins({error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.', {error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'});
                                        });
                                    } else {
                                        //assign ID created to previousId
                                        this.previousId = response['id'];
                                    }
                                    this.previousPartner = JSON.parse(JSON.stringify(this.partner));
                                }
                            }
                        }, async error => {
                            let errorMessage = '';
                            if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                                errorMessage = error.error.message;
                            } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                                errorMessage = error.error;
                            } else {
                                errorMessage = 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.';
                            }
                            await this.platform.notifyErrorToAdmins({error: 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while sending error message to admins while checking partner short code existence during onboarding.', {error: 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.'});
                        });
                    } else {
                        if (this.partner === '') {
                            this.siteValidationStatement = 'Partner name is required';
                            // if (this.previousId !== 0) {
                            const tempPayload = {
                                forcedExpiration: true
                            };
                            this.confPost.patchEntityData('services', 'services', 'v2', 'reservationCollection', this.previousId, tempPayload).subscribe(response1 => {
                                this.previousId = response1['id'];
                            }, async error => {
                                await this.platform.notifyErrorToAdmins({error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.', {error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'});
                            });
                            // } else {
                            //assign ID created to previousId
                            // this.previousId = response['id'];
                            // }
                            this.previousPartner = JSON.parse(JSON.stringify(this.partner));
                        } else {
                            this.isPartnerAvailabilityCheckLoading = true;
                            this.appComp.reservationCollectionPayload.partner = this.partner;
                            this.confPost.checkPartnerShortcodeExistence(this.appComp.reservationCollectionPayload).subscribe(response => {
                                this.isPartnerAvailabilityCheckLoading = false;
                                if (response && response !== null && response !== undefined && response['message'] === false) {
                                    // Throw error partner already exists
                                    this.siteValidationStatement = 'Partner with this name already exists';
                                } else {
                                    Promise.resolve(this.isContainsAlphaNumericInPartner()).then(resp => {
                                        if (resp) {
                                            this.siteValidationStatement = '';
                                            this.isValidPartnerShortcode = true;
                                        } else {
                                            this.siteValidationStatement = 'Partner name should contain atleast one alphabet.';
                                        }
                                    });
                                    // Partner is available
                                    // Entry in services collection
                                    if (this.previousId !== 0) {
                                        const tempPayload = {
                                            forcedExpiration: true
                                        };
                                        this.confPost.patchEntityData('services', 'services', 'v2', 'reservationCollection', this.previousId, tempPayload).subscribe(response1 => {
                                            //assign ID created to previousId
                                            this.previousId = response['id'];
                                        }, async error => {
                                            await this.platform.notifyErrorToAdmins({error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.', {error: 'Error while patching the available partner name ' + ' : ' + this.partner + ' in the reservation collection for the email : ' + this.email + ' while onboarding.'});
                                        });
                                    } else {
                                        //assign ID created to previousId
                                        this.previousId = response['id'];
                                    }
                                    this.previousPartner = JSON.parse(JSON.stringify(this.partner));
                                }
                            }, async error => {
                                let errorMessage = '';
                                if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                                    errorMessage = error.error.message;
                                } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                                    errorMessage = error.error;
                                } else {
                                    errorMessage = 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.';
                                }
                                await this.platform.notifyErrorToAdmins({error: 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while sending error message to admins while checking partner short code existence during onboarding.', {error: 'Error while checking partner shortcode existence for the email : ' + this.email + ' while onboarding.'});
                            });
                        }
                    }

                } else {
                    if (this.partner !== '') {
                        Promise.resolve(this.isContainsAlphaNumericInPartner()).then(resp => {
                            if (resp) {
                                this.siteValidationStatement = '';
                                this.isValidPartnerShortcode = true;
                                this.isPartnerAvailabilityCheckLoading = false;
                            } else {
                                this.siteValidationStatement = 'Partner name should contain atleast one alphabet.';
                            }
                        });
                    } else {
                        this.siteValidationStatement = 'Partner name is required';
                    }

                }
            } else {
                this.platform.openSnackBar('Partner name should not have any special characters or spaces in between', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        });
    }

    goForwardSite(): boolean {
        this.item['partner'] = this.partner;
        if (this.item['partner']) {
            const lent = this.item['partner'];
            this.item['partner'] = this.item['partner'].toLowerCase();
            this.confPost.isPartnerAlreadyExist(this.item['partner']).subscribe(res => {
                this.partnerExists = res;
                if (this.partnerExists === 'true' || this.partnerExists === true) {
                    if (this.siteValidationStatement) {
                        this.siteValidationStatement = 'Partner with this name already exists.';
                    } else {
                        this.siteValidationStatement = 'Partner with this name already exists.';
                    }
                } else {
                    this.siteValidationStatement = '';
                    if (this.item['partner'].length <= 14) {
                        if (/^[a-zA-Z0-9- ]*$/.test(this.item['partner']) === true) {
                            this.validation = true;
                            this.siteValidationStatement = '';
                            this.settingsPayload.account = this.item['partner'];
                            this.settingsPayload.partner = this.item['partner'];
                            // stepper.next();
                        } else {
                            this.siteValidationStatement = 'Sitename should not contain special characters.';
                            this.partnerCheck = false;
                        }
                    } else {
                        this.siteValidationStatement = 'Sitename should not exceed 14 characters.';
                        this.partnerCheck = false;
                    }
                }
            }, error => {
                this.partnerExistsValidation = false;
                if (this.siteValidationStatement) {
                    this.siteValidationStatement = '1.' + 'Partner with this name already exists.';
                }
            });
        } else {
            this.siteValidationStatement = 'Sitename is required.';
            this.partnerCheck = false;
        }

        if (this.siteValidationStatement !== '') {
            return false;
        } else {
            return true;
        }
    }

    selectVault(index) {
        this.selectedVault = this.vaults[index];
        // this.settingsPayload.partner_settings.secretsManager[0].type = this.selectedVault['name'];
        for (let i = 0; i < this.vaults.length; i++) {
            const id = 'vault' + i;
            if (index === i) {
                $('#' + id).css('border', '1px solid #ff672d');
            } else {
                $('#' + id).css('border', 'transparent');
            }
        }
    }

    showWhatsThis() {
        const dialogRef = this.dialog.open(DialogComponent, {
            data: {
                title: 'What is Partner Name?',
                message: 'A Partner Name is a short code used to create an account for the partner being signed up. The entire infrastructure including platform console, gateway manager, developer experience, development environments, file storage and database will be setup based on this name'
            }
        });
    }

    constructOrgSummaryPayload() {
        this.organizationSummary = [
            {
                title: 'Organization Name',
                content: this.orgName
            },
            {
                title: 'Organization Size',
                content: this.orgSize
            },
            {
                title: 'Organization Type',
                content: this.selectedOrganizationType
            }
        ];
    }

    selectOrganizationType(index) {
        // this.settingsPayload.partner_settings.requirements_strategy.usages = [];
        // for (let i = 0; i < this.listOfUsages.length; i++) {
        //     const id = 'selectedUsageRequirements' + i;
        //     if ($('#' + id).hasClass('selectedUsageRequirements')) {
        //         $('#' + id).removeClass('selectedUsageRequirements');
        //     }
        // }
        this.selectedOrganizationType = this.organizationTypes[index]['type'];
        this.organizationSummary[2]['content'] = this.selectedOrganizationType;
        // this.settingsPayload.partner_settings.requirements_strategy.type = this.selectedOrganizationType;
        if (this.selectedOrganizationType === 'Individual') {
            this.orgName = 'Individual';
            this.orgSize = this.organizationSize[0]['value'];
            this.organizationSummary[0].content = this.orgName;
            this.organizationSummary[1].content = this.orgSize;
        } else if (this.selectedOrganizationType === 'Enterprise') {
            this.orgName = '';
            this.orgSize = this.organizationSize[4]['value'];
            this.organizationSummary[0].content = '';
            this.organizationSummary[1].content = this.orgSize;
        } else {
            this.orgName = '';
            this.orgSize = '';
            this.organizationSummary[0].content = '';
            this.organizationSummary[1].content = '';
        }
        for (let i = 0; i < this.organizationTypes.length; i++) {
            const id = 'orgType' + i;
            if (index === i) {
                $('#' + id).css('border', '2px solid #ff672d');
            } else {
                $('#' + id).css('border', 'transparent');
            }
        }
        for (let i = 0; i < this.requirementsStrategy.length; i++) {
            if (this.requirementsStrategy[i]['type'] === this.selectedOrganizationType) {
                this.assistanceObject = this.requirementsStrategy[i]['listOfAssistance'];
            }
        }
    }

    resetSelectionOfInstallation() {
        this.selectedInstallationType = undefined;
    }

    setSelectedAssistance() {
        // this.settingsPayload.partner_settings.requirements_strategy.assistance = this.selectedAssistance;
        if (this.selectedAssistance === 'Co-Develop') {
            // this.settingsPayload.partner_settings.requirements_strategy['is_assistance_required'] = true;
            for (const assistance of this.assistanceByApiplatform) {
                // this.settingsPayload.partner_settings.requirements_strategy.assistance_by_apiplatform.push(assistance.assistance);
            }
        } else {
            // this.settingsPayload.partner_settings.requirements_strategy['is_assistance_required'] = true;
            // this.settingsPayload.partner_settings.requirements_strategy.assistance_by_apiplatform = [];
        }
    }

    selectCloudInfra() {
        this.selectedCloudInfra = this.cloudInfraManager.selectedCloudInfra;
        // this.settingsPayload.partner_settings.cloud_infrastructure[0].cloud_provider = this.cloudInfraManager.selectedCloudInfra['value'];
        // this.settingsPayload.partner_settings.cloud_infrastructure[0].region = this.cloudInfraManager.selectedCloudInfra['region'];
        this.ciSelected = this.cloudInfraManager.selectedCloudInfra['value'];
        this.regionSelected = this.cloudInfraManager.selectedCloudInfra['region'];
        this.summary = [
            {
                title: 'Cloud Environment',
                content: this.ciSelected + ' : ' + this.regionSelected
            },
            {
                title: 'Database',
                content: this.databaseSelected
            },
            {
                title: 'API Gateway',
                // content: this.settingsPayload.configurations.gateways[0]['gateway_name']
            }
        ];
    }

    selectEnvironment(index) {
        // for (let i = 0; i < this.environments.length; i++) {
        //     const id = 'selectedEnvironment' + i;
        //     if (index === i) {
        //         if ($('#' + id).hasClass('selectedEnvironment')) {
        //             $('#' + id).removeClass('selectedEnvironment');
        //             for (let j = 0; j < this.settingsPayload.partner_settings.environment[0].environments.length; j++) {
        //                 if (this.environments[i]['environment'] === this.settingsPayload.partner_settings.environment[0].environments[j]) {
        //                     this.settingsPayload.partner_settings.environment[0].environments.splice(j, 1);
        //                 }
        //             }
        //         } else {
        //             $('#' + id).addClass('selectedEnvironment');
        //             this.settingsPayload.partner_settings.environment[0].environments.push(this.environments[i]['environment']);
        //         }
        //     }
        // }
    }

    selectGateway(index) {
        this.apiSelected = this.APIGateways[index]['value'];
        // this.settingsPayload.partner_settings.API_gateways[0] = this.APIGateways[index]['value'];
        // this.settingsPayload.configurations.gateways[0].gateway_name = this.APIGateways[index]['value'];
        for (let i = 0; i < this.APIGateways.length; i++) {
            const id = 'selectedGateway' + i;
            if (index === i) {
                $('#' + id).css('border', '2px solid #ff672d');
            } else {
                $('#' + id).css('border', 'transparent');
            }
        }
    }

    selectDB() {
        this.databaseSelected = this.databaseManager.databaseSelected;
        this.summary = [
            {
                title: 'Cloud Environment',
                content: this.ciSelected + ' : ' + this.regionSelected
            },
            {
                title: 'Database',
                content: this.databaseSelected
            },
            {
                title: 'API Gateway',
                // content: this.settingsPayload.configurations.gateways[0]['gateway_name']
            }
        ];
        // for (let i = 0; i < this.databaseTypes.length; i++) {
        //     const id = 'selectedDB' + i;
        //     if (index === i) {
        //         $('#' + id).css('border', '2px solid #ff672d');
        //     } else {
        //         $('#' + id).css('border', 'transparent');
        //     }
        // }
    }

    toggleIsAssistanceRequired() {
        // this.settingsPayload.partner_settings.organization_potential = this.selectedOrganizationPotential.key;
        if (this.selectedOrganizationPotential.key === 'Need Assistance') {
            // this.settingsPayload.partner_settings.requirements_strategy['is_assistance_required'] = true;
        } else {
            // this.settingsPayload.partner_settings.requirements_strategy['is_assistance_required'] = false;
        }
    }

    selectRequirements(index) {
        for (let i = 0; i < this.assistanceObject.length; i++) {
            if (i === index) {
                this.selectedAssistance = this.assistanceObject[index]['assistance'];
            }
        }
        for (let i = 0; i < this.requirementsStrategy.length; i++) {
            if (this.requirementsStrategy[i]['type'] === this.selectedOrganizationType) {
                this.assistanceObject = this.requirementsStrategy[i]['listOfAssistance'];
            }
            const id = 'reqType' + i;
            if (index === i) {
                $('#' + id).css('border', '2px solid #ff672d');
            } else {
                $('#' + id).css('border', 'transparent');
            }
        }
    }

    toggle(event: MatCheckboxChange, index): void {
        if (event.checked) {
            // this.settingsPayload.partner_settings.requirements_strategy.assistance_by_apiplatform.push(this.assistanceByApiplatform[index]);
        } else {
            // for (let i = 0; i < this.settingsPayload.partner_settings.requirements_strategy.assistance_by_apiplatform.length; i++) {
            //     if (this.settingsPayload.partner_settings.requirements_strategy.assistance_by_apiplatform[i] === this.assistanceByApiplatform[index]) {
            //         this.settingsPayload.partner_settings.requirements_strategy.assistance_by_apiplatform.splice(i, 1);
            //     }
            //     ;
            // }
        }
    }

    toggleAllServices(event: MatCheckboxChange) {
        for (let i = 0; i < this.listOfUsages.length; i++) {
            const id = 'selectedUsageRequirements' + i;
            if (event.checked) {
                $('#' + id).addClass('selectedUsageRequirements');
                // this.settingsPayload.partner_settings.requirements_strategy.usages.push(this.listOfUsages[i]['key']);
            } else {
                $('#' + id).removeClass('selectedUsageRequirements');
                // this.settingsPayload.partner_settings.requirements_strategy.usages.splice(i, 1);
            }
        }
    }

    selectUsageRequirements(index) {
        for (let i = 0; i < this.listOfUsages.length; i++) {
            const id = 'selectedUsageRequirements' + i;
            if (index === i) {
                if ($('#' + id).hasClass('selectedUsageRequirements')) {
                    $('#' + id).removeClass('selectedUsageRequirements');
                    this.isChecked = false;
                    // for (let j = 0; j < this.settingsPayload.partner_settings.requirements_strategy.usages.length; j++) {
                    //     if (this.listOfUsages[i]['key'] === this.settingsPayload.partner_settings.requirements_strategy.usages[j]) {
                    // this.settingsPayload.partner_settings.requirements_strategy.usages.splice(j, 1);
                    // }
                    // }
                } else {
                    $('#' + id).addClass('selectedUsageRequirements');
                    // this.settingsPayload.partner_settings.requirements_strategy.usages.push(this.listOfUsages[i]['key']);
                }
            }
        }
    }

    selectDevExUtility(index) {
        for (let i = 0; i < this.devExUtilities.length; i++) {
            const id = 'selectedDevExUtility' + i;
            if (index === i) {
                if ($('#' + id).hasClass('selectedUsageRequirements')) {
                    $('#' + id).removeClass('selectedUsageRequirements');
                    // for (let j = 0; j < this.settingsPayload.partner_settings.requirements_strategy.usages.length; j++) {
                    //     if (this.listOfUsages[i]['key'] === this.settingsPayload.partner_settings.requirements_strategy.usages[j]) {
                    //         this.settingsPayload.partner_settings.requirements_strategy.usages.splice(j, 1);
                    //     }
                    // }
                } else {
                    $('#' + id).addClass('selectedUsageRequirements');
                    // this.settingsPayload.partner_settings.requirements_strategy.usages.push(this.listOfUsages[i]['key']);
                }
            }
        }
    }

    passwordPolicyValidator() {
        return new Promise((resolve, reject) => {
            let i = 0;
            let character = '';
            if (this.password.length < 8) {
                resolve(false);
            } else {
                while (i <= this.password.length) {
                    character = this.password.charAt(i);
                    if (character.charCodeAt(0) >= 48 && character.charCodeAt(0) <= 57) {
                        this.containsDigit = true;
                    }
                    if (character.charCodeAt(0) >= 65 && character.charCodeAt(0) <= 90) {
                        this.containsUpperCase = true;
                    }
                    if (character.charCodeAt(0) >= 97 && character.charCodeAt(0) <= 122) {
                        this.containsLowerCase = true;
                    }
                    if (character.charCodeAt(0) >= 32 && character.charCodeAt(0) <= 47 ||
                        character.charCodeAt(0) >= 58 && character.charCodeAt(0) <= 64 ||
                        character.charCodeAt(0) >= 91 && character.charCodeAt(0) <= 96 ||
                        character.charCodeAt(0) >= 123 && character.charCodeAt(0) <= 126) {
                        this.containsSpecialCharacter = true;
                    }
                    i++;
                    if (i === this.password.length) {
                        if (this.containsDigit && this.containsLowerCase && this.containsUpperCase && this.containsSpecialCharacter) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    }
                }
            }
        });
    }

    goToFirstStepInstallation(stepper: MatStepper) {

        this.item['partner'] = this.partner;
        this.partnerShortCode = this.item['partner'];
        this.item['defaultDatabaseType'] = 'mongodb';
        this.ciSelected = 'aws';
        this.apiSelected = 'default';

        // this.settingsPayload.configurations.databases[0].database_name = 'default';
        // this.settingsPayload.configurations.databases[0].database_type = 'mongodb';
        // this.settingsPayload.partner_settings.cloud_infrastructure[0].cloud_provider = 'aws';
        // this.settingsPayload.partner_settings.cloud_infrastructure[0].region = 'US-East (N.Virginia)';
        // this.settingsPayload.partner_settings.vault = this.passwordManager.selectedVault['name'];

        this.isOneStepInstallation = true;
        if (this.password) {
            if (this.password === this.confirmPassword) {
                if (this.selectedVault) {
                    this.passwordCheck = true;
                    this.isPasswordsValid = true;
                    this.passwordValidationStatement = '';
                    this.passwordPolicyValidator().then(response => {
                        if (response) {
                            // if (this.goForwardSite()) {
                            //
                            // }
                            if (this.passwordValidationStatement === '' && this.siteValidationStatement === '') {
                                stepper.next();
                            }
                        } else {
                            this.passwordValidationStatement = 'Please make sure that your password follows our password policy';
                        }
                    });
                } else {
                    this.passwordValidationStatement = 'Please select a vault to proceed';
                }
            } else {
                this.isPasswordsValid = false;
                this.passwordValidationStatement = 'Passwords are not matching - please enter the same password in both Password and Confirm Password fields to proceed further.';
            }
        }
    }

    resetPasswordValidationStatement() {
        this.passwordValidationStatement = '';
    }

    validatePassword() {
        this.passwordPolicyValidator().then(response => {
            if (response) {
                if (this.passwordValidationStatement === '' && this.siteValidationStatement === '') {
                }
            } else {
                this.passwordValidationStatement = 'Please make sure that your password follows our password policy';
            }
        });
    }

    goForward(stepper: MatStepper) {
        this.item['partner'] = this.partner;
        this.partnerShortCode = this.item['partner'];
        this.isOneStepInstallation = false;
        if (this.password) {
            if (this.password === this.confirmPassword) {
                if (this.selectedVault) {
                    this.passwordCheck = true;
                    this.isPasswordsValid = true;
                    this.passwordValidationStatement = '';
                    this.passwordPolicyValidator().then(response => {
                        if (response) {
                            // if (this.goForwardSite()) {
                            //
                            // }
                            if (this.passwordValidationStatement === '' && this.siteValidationStatement === '') {
                                stepper.next();
                            }
                        } else {
                            this.passwordValidationStatement = 'Please make sure that your password follows our password policy';
                        }
                    });
                } else {
                    this.passwordValidationStatement = 'Please select a vault to proceed';
                }
            } else {
                this.isPasswordsValid = false;
                this.passwordValidationStatement = 'Passwords are not matching - please enter the same password in both Password and Confirm Password fields to proceed further.';
            }
        }
    }

    goToReqs(stepper: MatStepper) {
        if (this.orgName !== '' && this.orgSize !== '') {
            stepper.next();
        }
    }

    goToCloud(stepper: MatStepper) {
        // if (this.settingsPayload.partner_settings.requirements_strategy.usages.length > 0) {
        //     if (this.selectedOrganizationType === 'StartUp') {
        //         if (this.selectedAssistance === 'Application Development') {
        //             stepper.next();
        //         } else {
        //             if (this.selectedAssistance === 'Raise fund') {
        //                 if (this.settingsPayload.partner_settings.organization_potential !== '') {
        //                     if (this.settingsPayload.partner_settings.organization_potential === 'Need Assistance') {
        //                         if (this.settingsPayload.partner_settings.requirements_strategy.assistance_by_apiplatform.length > 0) {
        //                             stepper.next();
        //                         } else {
        //                             alert('Please specify your required assistance from apiplatform');
        //                         }
        //                     } else {
        //                         stepper.next();
        //                     }
        //                 } else {
        //                     alert('Please specify whether you need assistance from apiplatform to build and launch your applications');
        //                 }
        //             } else if (this.selectedAssistance === 'Co-Develop') {
        //                 if (this.settingsPayload.partner_settings.requirements_strategy['offering_percentage'] > 0) {
        //                     stepper.next();
        //                 } else {
        //                     alert('Please specify the percentage of revenue that you can offer to apiplatform');
        //                 }
        //             }
        //         }
        //     } else {
        //         stepper.next();
        //     }
        // } else {
        //     alert('Please select atleast one service required from apiplatform');
        // }
    }

    // goToSite(stepper: MatStepper) {
    //     if (this.settingsPayload.partner_settings.environment[0].is_custom) {
    //         if (this.settingsPayload.partner_settings.environment[0].custom_environments.length === 0) {
    //             alert('Please provide a custom environment name');
    //         } else {
    //             for (const environment of this.settingsPayload.partner_settings.environment[0].custom_environments) {
    //                 this.settingsPayload.partner_settings.environment[0].environments.push(environment);
    //             }
    //             stepper.next();
    //         }
    //     } else {
    //         if (this.settingsPayload.partner_settings.environment[0].environments.length > 0) {
    //             stepper.next();
    //         } else {
    //             alert('Please select an environment');
    //         }
    //     }
    // };

    // goToEnvironments(stepper: MatStepper, installationMode) {
    //
    //     this.item['defaultDatabaseType'] = 'mongodb';
    //     this.apiSelected = 'default';
    //
    //     this.settingsPayload.configurations.databases[0].database_name = 'default';
    //     this.settingsPayload.configurations.databases[0].database_type = 'mongodb';
    //     // this.settingsPayload.partner_settings.vault = this.passwordManager.selectedVault['name'];
    //
    //     if (this.selectedCloudInfra) {
    //         this.selectedInstallationType = installationMode;
    //         // this.ciSelected = this.selectedCloudInfra['value'];
    //         stepper.next();
    //         // if (this.selectedInstallationType) {
    //         //     stepper.next();
    //         // } else {
    //         //     alert('Please select in installation type');
    //         // }
    //     } else {
    //         alert('Please select a cloud infrastructure');
    //     }
    // }

    // goToAPI(stepper: MatStepper) {
    //     if (this.databasesPayload.length > 0) {
    //         this.item['databases'] = this.databasesPayload;
    //         this.item['defaultDatabaseType'] = this.databasesPayload[0]['database_type'];
    //         this.settingsPayload.configurations.databases[0].database_type = this.item['databases'][0]['database_type'];
    //         this.settingsPayload.configurations.databases[0].database_name = this.item['databases'][0]['database_name'];
    //         this.settingsPayload.configurations.databases[0].database_attributes = this.item['databases'][0]['database_attributes'];
    //         stepper.next();
    //     } else {
    //         const dbPayload = [{
    //             database_type: this.databaseSelected,
    //             database_name: 'default',
    //             database_attributes: {}
    //         }];
    //         this.item['databases'] = dbPayload;
    //         this.item['defaultDatabaseType'] = this.databaseSelected;
    //         this.settingsPayload.configurations.databases[0].database_type = this.item['defaultDatabaseType'];
    //         this.settingsPayload.configurations.databases[0].database_name = 'default';
    //         stepper.next();
    //     }
    // }

    partnerValidation() {
        this.validation = false;
        this.passwordCheck = false;
        this.partnerCheck = true;
        this.validationMessage = null;

        if (this.password) {
            if (this.password === this.confirmPassword) {
                this.passwordCheck = true;
            } else {
                this.validationMessage = 'Passwords are not matching - please enter the same password in both Password and Confirm Password fields to proceed further.';
            }
        } else {
            this.validationMessage = 'Password is required.';
        }


        // if (!this.orgSize) {
        //     this.validationMessage = 'Enter the size of your organization';
        // }
        // if (!this.reqAPIs) {
        //     this.validationMessage = 'Enter the estimated no of APIs required';
        // }
        // if (!this.hits) {
        //     this.validationMessage = 'Enter the estimated average no of hits';
        // }

        if (this.item['partner']) {
            const lent = this.item['partner'];
            if (this.item['partner'].length < 13) {
                if (/^[a-zA-Z0-9- ]*$/.test(this.item['partner']) === true) {
                    this.validation = true;
                } else {
                    this.validationMessage = 'Partner name should not contain special characters.';
                    this.partnerCheck = false;
                }
            } else {
                this.validationMessage = 'Partner name should not exceed 14 characters.';
                this.partnerCheck = false;
            }
        } else {
            this.validationMessage = 'Partner name is required.';
            this.partnerCheck = false;
        }

    }

    resolveDNSValidation(payload, maxTries, duration) {
        return new Promise(async (resolve, reject) => {
            await setTimeout(() => {
                this.confPost.dnsValidation({domainName: [payload['url']]}).subscribe(response => {
                    if (response) {
                        const responseFromApi = response;
                        if (responseFromApi['body']['response'][0]['status']) {
                            this.tempStatusVerification = 'verified';
                        } else {
                            this.tempStatusVerification = 'not verified';
                        }
                        resolve(this.tempStatusVerification);
                    }
                }, async error => {
                    this.DNSValidationRetries += 1;
                    if (this.DNSValidationRetries !== maxTries) {
                        this.resolveDNSValidation(payload, maxTries, duration).then(response1 => {
                            if (response1) {
                                this.tempStatusVerification = JSON.stringify(response1);
                                resolve(this.tempStatusVerification);
                            }
                        });
                    } else {
                        this.DNSValidationRetries = 0;
                        let errorMessage = '';
                        if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                            errorMessage = error.error.message;
                        } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                            errorMessage = error.error;
                        } else {
                            errorMessage = 'Error while validating DNS for this email : ' + this.email + ' while onboarding.';
                        }
                        await this.platform.notifyErrorToAdmins({error: 'Error while validating DNS for this email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while notifying admins regarding the failure of DNS validation for the email : ' + this.email + ' while onboarding.', {error: 'Error while validating DNS for this email : ' + this.email + ' while onboarding.'});
                    }
                });
            }, duration);
        });
    }

    async validateDNS1(payload, maxTries, duration) {
        for (let i = 0; i < maxTries; i++) {
            if (this.tempStatusVerification !== 'verified') {
                await this.resolveDNSValidation(payload, maxTries, duration).then(response => {
                    if (this.tempStatusVerification === 'verified') {
                        return;
                    }
                });
            }
        }
        // this.tempStatusVerification = 'not verified';
        return this.tempStatusVerification;
    }

    async validateEachEnvironment() {
        let i = 0;
        if (this.environmentResponseArray && this.environmentResponseArray.length > 0) {
            for (const environment of this.environmentResponseArray) {
                environment['isEnabled'] = true;
                i += 1;
                let j = 0;
                for (const URLObject of environment['URLs']) {
                    j += 1;
                    this.tempStatusVerification = 'created';
                    URLObject['isVerified'] = this.tempStatusVerification;
                    if (URLObject['status'] === true) {
                        await this.validateDNS1(URLObject, 3, 10000).then(response => {
                            if (this.tempStatusVerification === 'verified') {
                                URLObject['isVerified'] = this.tempStatusVerification;
                            } else {
                                URLObject['isVerified'] = 'not verified';
                            }
                        });
                    }
                    if (j === environment['URLs'].length) {
                        environment['isValidationComplete'] = true;
                    }
                }
            }
            if (i === this.environmentResponseArray.length) {
                return;
            }
        }
    }


    recreateEnvironment(URLObject, payload, maxTries, duration) {
        return new Promise(async (resolve, reject) => {
            await setTimeout(() => {
                this.confPost.createEnvironment(payload).subscribe(response => {
                    if (response) {
                        const responseFromApi = response;
                        this.tempStatusEnvCreation = responseFromApi['body']['URLs'][0]['status'];
                        if (this.tempStatusEnvCreation === true) {
                            URLObject['url'] = responseFromApi['body']['URLs'][0]['url'];
                        }
                        resolve(this.tempStatusEnvCreation);
                    }
                }, async error => {
                    this.envRecreationRetries += 1;
                    if (this.envRecreationRetries <= maxTries) {
                        this.recreateEnvironment(URLObject, payload, maxTries, duration).then(response1 => {
                            resolve(response1);
                        });
                    } else {
                        this.envRecreationRetries = 0;
                        let errorMessage = '';
                        if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                            errorMessage = error.error.message;
                        } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                            errorMessage = error.error;
                        } else {
                            errorMessage = 'Error while recreating environment for the email : ' + this.email + ' while onboarding.';
                        }
                        await this.platform.notifyErrorToAdmins({error: 'Error while recreating environment for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while notifying admins regarding the failure of environment recreation for the email : ' + this.email + ' while onboarding.', {error: 'Error while recreating environment for the email : ' + this.email + ' while onboarding.'});
                    }
                });
            }, duration);
        });
    }

    async recreateEnvironmentURLObject(URLObject, payload, maxTries, duration) {
        for (let i = 0; i < maxTries; i++) {
            if (!this.tempStatusEnvCreation) {
                await this.recreateEnvironment(URLObject, payload, maxTries, duration).then(response => {
                    if (this.tempStatusEnvCreation) {
                        return response;
                    }
                });
            }
        }
        // this.tempStatusVerification = 'not verified';
        return this.tempStatusEnvCreation;
    }

    async validateEachEnvironmentCreation() {
        return new Promise(async (resolve, reject) => {
            for (const environment of this.environmentResponseArray) {
                for (const URLObject of environment['URLs']) {
                    URLObject['isVerified'] = 'created';
                    URLObject['envCreationStatus'] = 'started';
                    if (URLObject['status'] === false) {
                        const payloadToResend = {
                            partner: '',
                            account: '',
                            configuration: {
                                devex: [''],
                                dashboard: [''],
                                apigateway: [''],
                                storage: ['']
                            }
                        };
                        if (environment['type'] === 'prod') {
                            payloadToResend.partner = this.item['partner'];
                            payloadToResend.account = this.item['partner'];
                        } else {
                            payloadToResend.partner = environment['type'] + '-' + this.partner;
                            payloadToResend.account = environment['type'] + '-' + this.partner;
                        }
                        payloadToResend['configuration'][URLObject['type']] = [this.ciSelected];
                        await this.recreateEnvironmentURLObject(URLObject, payloadToResend, 3, 5000).then(response => {
                            if (this.tempStatusEnvCreation) {
                                URLObject['status'] = this.tempStatusEnvCreation;
                                URLObject['envCreationStatus'] = 'success';
                            } else {
                                URLObject['status'] = false;
                                URLObject['envCreationStatus'] = 'failed';
                            }
                        });
                    } else {
                        URLObject['envCreationStatus'] = 'success';
                    }
                }
                environment['isCreationComplete'] = true;
            }
            resolve(this.environmentResponseArray);
            // }
        });
    }

    patchAdminPartnerSettings(tempPayload, response) {
        return new Promise((resolve, reject) => {
            this.confPost.patchEntityData('services', 'services', 'v2', 'settings', response[0]['id'], tempPayload).subscribe(response3 => {
                this.isEnvironmentsCreationComplete = true;
                resolve('success');
            }, async error => {
                this.patchAdminPartnerSettingsRetries += 1;
                if (this.patchAdminPartnerSettingsRetries <= 3) {
                    setTimeout(() => {
                        this.patchAdminPartnerSettings(tempPayload, response).then(response1 => {
                            resolve(response1);
                        });
                    }, 500);
                } else {
                    this.isEnvironmentsCreationComplete = true;
                    resolve('failure');
                    let errorMessage = '';
                    if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                        errorMessage = error.error.message;
                    } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                        errorMessage = error.error;
                    } else {
                        errorMessage = 'Error while patching of settings of ADMIN-PARTNER account. patchAdminPartnerSettings function failed during onboarding.';
                    }
                    //send an email regarding error in patching of settings of ADMIN-PARTNER account

                    await this.platform.notifyErrorToAdmins({error: 'Error while patching of settings of ADMIN-PARTNER account. patchAdminPartnerSettings function failed during onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while notifying partners when patching the settings of ADMIN-PARTNER account. patchAdminPartnerSettings function failed during onboarding.', {error: 'Error while patching of settings of ADMIN-PARTNER account. patchAdminPartnerSettings function failed during onboarding.'});
                }
            });
        });
    }

    pushEnvironment1(payload, environmentParam, environments) {
        return new Promise((resolve, reject) => {
            this.confPost.createEnvironment(payload).subscribe(async response => {
                this.progressMessage = 'Creating super administration console… - Done';
                this.progress = this.progress + 10;
                // this.sleep(1000);
                const responseFromAPI = response;
                responseFromAPI['body']['isValidationComplete'] = false;
                this.environmentResponseArray.push(responseFromAPI['body']);
                this.environmentCreationStart = true;
                this.progressMessage = 'Validating super administration console…';
                // this.sleep(1000);
                if (this.environmentResponseArray.length === environments.length) {
                    this.validateEachEnvironmentCreation().then(response1 => {
                        this.progressMessage = 'Validating super administration console… - Done';
                        this.progress = this.progress + 25;
                        // this.sleep(1000);
                        this.progressMessage = 'Completing super administration console creation…';
                        // this.sleep(1000);
                        if (this.isDirectNavigationToConsole === true) {
                            this.confPost.getData('services', 'services', 'v2', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(response2 => {
                                for (const env of this.environmentResponseArray) {
                                    if (env['type'] === environmentParam) {
                                        for (const URLObject of env['URLs']) {
                                            const servicePayload = {
                                                configurations: []
                                            };
                                            const serviceConfig = {};
                                            switch (URLObject['type']) {
                                                case 'dashboard':
                                                    servicePayload['name'] = 'Platform Console';
                                                    serviceConfig['name'] = 'Platform Console';
                                                    break;
                                                case 'devex':
                                                    servicePayload['name'] = 'Developer Experience';
                                                    serviceConfig['name'] = 'Developer Experience';
                                                    break;
                                                case 'apigateway':
                                                    servicePayload['name'] = 'API Gateway Manager';
                                                    serviceConfig['name'] = 'default';
                                                    serviceConfig['provider'] = 'apiplatform.io';
                                                    serviceConfig['gateway_configurations'] = [
                                                        {
                                                            'name': 'key-auth',
                                                            'isConfigured': false,
                                                            'img': '/assets/img/key-auth.png',
                                                            'description': 'Configure KeyAuth service..',
                                                            'enabled': true,
                                                            'consumer': {},
                                                            'tagline': 'Add Key Authentication (also referred to as an API key) to your APIs. Consumers then add their key either in a querystring parameter or a header to authenticate their requests.',
                                                            'config': [
                                                                {
                                                                    'displayName': 'Key Names',
                                                                    'parameter': 'key_names',
                                                                    'type': 'array_string',
                                                                    'value': 'apikey',
                                                                    'isRequired': true,
                                                                    'description': 'Describes an array of parameter names where the plugin will look for a key. The client must send the authentication key in one of those key names, and the plugin will try to read the credential from a header, request body, or query string parameter with the same name.\n' +
                                                                        'Note: The key names may only contain [a-z], [A-Z], [0-9], [_] underscore, and [-] hyphen'
                                                                },
                                                                {
                                                                    'displayName': 'Key In Body',
                                                                    'parameter': 'key_in_body',
                                                                    'type': 'boolean',
                                                                    'value': false,
                                                                    'isRequired': false,
                                                                    'description': 'If enabled, the plugin reads the request body (if said request has one and its MIME type is supported) and tries to find the key in it. Supported MIME types: application/www-form-urlencoded, application/json, and multipart/form-data'
                                                                },
                                                                {
                                                                    'displayName': 'Hide Credentials',
                                                                    'parameter': 'hide_credentials',
                                                                    'type': 'boolean',
                                                                    'value': false,
                                                                    'isRequired': false,
                                                                    'description': 'An optional boolean value telling the plugin to show or hide the credential from the upstream service. If true, the plugin strips the credential from the request (i.e., the header, query string, or request body containing the key) before proxying it'
                                                                },
                                                                {
                                                                    'displayName': 'Run On Preflight',
                                                                    'parameter': 'run_on_preflight',
                                                                    'type': 'boolean',
                                                                    'value': true,
                                                                    'isRequired': false,
                                                                    'description': 'A boolean value that indicates whether the plugin should run (and try to authenticate) on OPTIONS preflight requests. If set to false, then OPTIONS requests are always allowed'
                                                                },
                                                                {
                                                                    'displayName': 'Key In Header',
                                                                    'parameter': 'key_in_header',
                                                                    'type': 'boolean',
                                                                    'value': true,
                                                                    'isRequired': false,
                                                                    'description': 'If enabled (default), the plugin reads the request header and tries to find the key in it'
                                                                },
                                                                {
                                                                    'displayName': 'Key In Query',
                                                                    'parameter': 'key_in_query',
                                                                    'type': 'boolean',
                                                                    'value': true,
                                                                    'isRequired': false,
                                                                    'description': 'If enabled (default), the plugin reads the query parameter in the request and tries to find the key in it'
                                                                },
                                                            ],
                                                            'id': 9,
                                                            'itemName': 'key-auth'
                                                        },
                                                        {
                                                            'name': 'cors',
                                                            'isConfigured': false,
                                                            'img': 'assets/img/cors.png',
                                                            'enabled': true,
                                                            'consumer': {},
                                                            'description': 'Configure CORS service.',
                                                            'tagline': 'Allow developers to make requests from the browser. Easily add cross-origin resource sharing (CORS) to a Service and a Route by enabling this plugin',
                                                            'config': [
                                                                // {
                                                                //   'parameter': 'consumerID',
                                                                //   'type': 'string',
                                                                //   'value': '',
                                                                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                                                                // },
                                                                {
                                                                    'displayName': 'Origins',
                                                                    'parameter': 'origins',
                                                                    'type': 'array_string',
                                                                    'value': '*',
                                                                    'isRequired': false,
                                                                    'description': 'List of allowed domains for the Access-Control-Allow-Origin header. If you want to allow all origins, add * as a single value to this configuration field. The accepted values can either be flat strings or PCRE regexes'
                                                                },
                                                                {
                                                                    'displayName': 'Headers',
                                                                    'parameter': 'headers',
                                                                    'type': 'array_string',
                                                                    'value': null,
                                                                    'isRequired': false,
                                                                    'description': 'Tip: Comma separated values for the Access-Control-Allow-Headers header, expects a comma delimited string (e.g. Origin, Authorization).'
                                                                },
                                                                {
                                                                    'displayName': 'Exposed Headers',
                                                                    'parameter': 'exposed_headers',
                                                                    'type': 'array_string',
                                                                    'value': null,
                                                                    'isRequired': false,
                                                                    'description': 'Tip: Comma separated values for the Access-Control-Expose-Headers header, expects a comma delimited string (e.g. Origin, Authorization). If not specified, no custom headers are exposed.'
                                                                },
                                                                {
                                                                    'displayName': 'Methods',
                                                                    'parameter': 'methods',
                                                                    'type': 'array_string',
                                                                    'value': null,
                                                                    'isRequired': false,
                                                                    'description': 'Value for the Access-Control-Allow-Methods header. Available options include GET, HEAD, PUT, PATCH, POST, DELETE, OPTIONS, TRACE, CONNECT. By default, all options are allowed'
                                                                },
                                                                {
                                                                    'displayName': 'Max Age',
                                                                    'parameter': 'max_age',
                                                                    'type': 'number',
                                                                    'value': 300,
                                                                    'isRequired': false,
                                                                    'description': 'Indicates how long the results of the preflight request can be cached, in seconds'
                                                                },
                                                                {
                                                                    'displayName': 'Credentials',
                                                                    'parameter': 'credentials',
                                                                    'type': 'boolean',
                                                                    'value': false,
                                                                    'isRequired': true,
                                                                    'description': 'Flag to determine whether the Access-Control-Allow-Credentials header should be sent with true as the value'
                                                                },
                                                                {
                                                                    'displayName': 'Preflight Continue',
                                                                    'parameter': 'preflight_continue',
                                                                    'type': 'boolean',
                                                                    'value': false,
                                                                    'isRequired': true,
                                                                    'description': 'A boolean value that instructs the plugin to proxy the OPTIONS preflight request to the Upstream service'
                                                                }
                                                            ],
                                                            'itemName': 'cors'
                                                        },
                                                        {
                                                            'name': 'ip-restriction',
                                                            'isConfigured': false,
                                                            'img': 'assets/img/ip-restriction.png',
                                                            'enabled': false,
                                                            'consumer': {},
                                                            'description': 'Configure IP Restriction service.',
                                                            'tagline': 'Restrict access to a Service or a Route by either allowing or denying IP addresses. Single IPs, multiple IPs or ranges in CIDR notation like 10.10.10.0/24 can be used. The plugin supports IPv4 and IPv6 addresses',
                                                            'config': [
                                                                // {
                                                                //   'parameter': 'consumerID',
                                                                //   'type': 'string',
                                                                //   'value': '',
                                                                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                                                                // },
                                                                {
                                                                    'displayName': 'Allow',
                                                                    'parameter': 'allow',
                                                                    'type': 'array_string',
                                                                    'value': '127.0.0.1',
                                                                    'description': 'Tip: Comma separated list of IPs or CIDR ranges to whitelist. At least one between whitelist or blacklist must be specified.'
                                                                },
                                                                {
                                                                    'displayName': 'Deny',
                                                                    'parameter': 'deny',
                                                                    'type': 'array_string',
                                                                    'value': null,
                                                                    'description': 'Tip: Comma separated list of IPs or CIDR ranges to blacklist. At least one between whitelist or blacklist must be specified.'
                                                                }
                                                            ],
                                                            'itemName': 'ip-restriction'
                                                        },
                                                        {
                                                            'name': 'rate-limiting',
                                                            'isConfigured': false,
                                                            'img': '/assets/img/rate-limiting.png',
                                                            'description': 'Configure Rate limiting service.',
                                                            'enabled': true,
                                                            'consumer': {},
                                                            'tagline': 'Rate limit how many HTTP requests a developer can make in a given period of seconds, minutes, hours, days, months or years. If the API has no authentication layer, the Client IP address will be used, otherwise the Consumer will be used if an authentication plugin has been configured',
                                                            'config': [
                                                                {
                                                                    'displayName': 'Second',
                                                                    'parameter': 'second',
                                                                    'type': 'number',
                                                                    'value': null,
                                                                    'isRequired': false,
                                                                    'description': 'The number of HTTP requests that can be made per second'
                                                                },
                                                                {
                                                                    'displayName': 'Minute',
                                                                    'parameter': 'minute',
                                                                    'type': 'number',
                                                                    'value': 5,
                                                                    'isRequired': false,
                                                                    'description': 'The number of HTTP requests that can be made per minute'
                                                                },
                                                                {
                                                                    'displayName': 'Hour',
                                                                    'parameter': 'hour',
                                                                    'type': 'number',
                                                                    'value': null,
                                                                    'isRequired': false,
                                                                    'description': 'The number of HTTP requests that can be made per hour'
                                                                },
                                                                {
                                                                    'displayName': 'Day',
                                                                    'parameter': 'day',
                                                                    'type': 'number',
                                                                    'value': null,
                                                                    'isRequired': false,
                                                                    'description': 'The number of HTTP requests that can be made per day'
                                                                },
                                                                {
                                                                    'displayName': 'Month',
                                                                    'parameter': 'month',
                                                                    'type': 'number',
                                                                    'value': null,
                                                                    'isRequired': false,
                                                                    'description': 'The number of HTTP requests that can be made per month'
                                                                },
                                                                {
                                                                    'displayName': 'Year',
                                                                    'parameter': 'year',
                                                                    'type': 'number',
                                                                    'value': null,
                                                                    'isRequired': false,
                                                                    'description': 'The number of HTTP requests that can be made per year'
                                                                },
                                                                {
                                                                    'displayName': 'Limit By',
                                                                    'parameter': 'limit_by',
                                                                    'type': 'string',
                                                                    'value': 'consumer',
                                                                    'isRequired': false,
                                                                    'description': 'The entity that will be used when aggregating the limits: consumer, credential, ip, service, header, path. If the value for the entity chosen to aggregate the limit cannot be determined, the system will always fallback to ip. If value service is chosen, the service_id configuration must be provided. If value header is chosen, the header_name configuration must be provided. If value path is chosen, the path configuration must be provided'
                                                                },
                                                                {
                                                                    'displayName': 'Policy',
                                                                    'parameter': 'policy',
                                                                    'type': 'string',
                                                                    'value': 'local',
                                                                    'isRequired': false,
                                                                    'description': 'In DB-less and hybrid modes, the cluster config policy is not supported. For DB-less mode, use one of redis or local; for hybrid mode, use redis, or local for data planes only.\n' +
                                                                        '\n' +
                                                                        'In Konnect Cloud, the default policy is redis'
                                                                },
                                                                {
                                                                    'displayName': 'Fault Tolerant',
                                                                    'parameter': 'fault_tolerant',
                                                                    'type': 'boolean',
                                                                    'value': true,
                                                                    'isRequired': false,
                                                                    'description': 'A boolean value that determines if the requests should be proxied even if Kong has troubles connecting a third-party datastore. If true, requests will be proxied anyway, effectively disabling the rate-limiting function until the datastore is working again. If false, then the clients will see 500 errors'
                                                                },
                                                                {
                                                                    'displayName': 'Hide Client Headers',
                                                                    'parameter': 'hide_client_headers',
                                                                    'type': 'boolean',
                                                                    'value': false,
                                                                    'isRequired': false,
                                                                    'description': 'Optionally hide informative response headers'
                                                                },
                                                                {
                                                                    'displayName': 'Redis Host',
                                                                    'parameter': 'redis_host',
                                                                    'type': 'string',
                                                                    'value': 'localhost',
                                                                    'isRequired': false,
                                                                    'description': 'When using the redis policy, this property specifies the address to the Redis server'
                                                                },
                                                                {
                                                                    'displayName': 'Redis Password',
                                                                    'parameter': 'redis_password',
                                                                    'type': 'string',
                                                                    'value': '',
                                                                    'isRequired': false,
                                                                    'description': 'When using the redis policy, this property specifies the password to connect to the Redis server'
                                                                },
                                                                {
                                                                    'displayName': 'Redis Port',
                                                                    'parameter': 'redis_port',
                                                                    'type': 'number',
                                                                    'value': 6379,
                                                                    'isRequired': false,
                                                                    'description': 'When using the redis policy, this property specifies the port of the Redis server. By default is 6379'
                                                                },
                                                                {
                                                                    'displayName': 'Redis Timeout',
                                                                    'parameter': 'redis_timeout',
                                                                    'type': 'number',
                                                                    'value': 2000,
                                                                    'isRequired': false,
                                                                    'description': 'When using the redis policy, this property specifies the timeout in milliseconds of any command submitted to the Redis server'
                                                                },
                                                                {
                                                                    'displayName': 'Redis Database',
                                                                    'parameter': 'redis_database',
                                                                    'type': 'number',
                                                                    'value': 0,
                                                                    'isRequired': false,
                                                                    'description': 'When using the redis policy, this property specifies the Redis database to use'
                                                                },
                                                                // {
                                                                //   'displayName': 'Header Name',
                                                                //   'parameter': 'header_name',
                                                                //   'type': 'string',
                                                                //   'value': '',
                                                                //     'isRequired': false,
                                                                //     'description': 'Header name to be used if limit_by is set to header'
                                                                // },
                                                                // {
                                                                //   'displayName': 'Path',
                                                                //   'parameter': 'path',
                                                                //   'type': 'string',
                                                                //   'value': '',
                                                                //   'isRequired': false,
                                                                //   'description': 'Path to be used if limit_by is set to path'
                                                                // },
                                                            ],
                                                            'itemName': 'rate-limiting'
                                                        },
                                                        {
                                                            'name': 'datadog',
                                                            'isConfigured': false,
                                                            'img': '/assets/img/datadog.png',
                                                            'description': 'Configure Datadog service.',
                                                            'tagline': 'Visualize API metrics on Datadog',
                                                            'enabled': true,
                                                            'consumer': {},
                                                            'config': [

                                                                {
                                                                    'displayName': 'Host',
                                                                    'parameter': 'host',
                                                                    'type': 'string',
                                                                    'value': '127.0.0.1',
                                                                    'isRequired': true,
                                                                    'description': 'The IP address or host name to send data to'
                                                                },
                                                                {
                                                                    'displayName': 'Port',
                                                                    'parameter': 'port',
                                                                    'type': 'number',
                                                                    'value': 8125,
                                                                    'isRequired': true,
                                                                    'description': 'The port to send data to on the upstream server'
                                                                },
                                                                {
                                                                    'displayName': 'Prefix',
                                                                    'parameter': 'prefix',
                                                                    'type': 'string',
                                                                    'value': 'apiplatform',
                                                                    'isRequired': true,
                                                                    'description': 'String to be attached as prefix to metric’s name'
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            'name': 'acl',
                                                            'isConfigured': false,
                                                            'img': '/assets/img/acl.png',
                                                            'description': 'Configure ACL service.',
                                                            'tagline': 'Restrict access to a Service or a Route by adding Consumers to allowed or denied lists using arbitrary ACL group names. This plugin requires an authentication plugin (such as Basic Authentication, Key Authentication, OAuth 2.0, and OpenID Connect) to have been already enabled on the Service or Route',
                                                            'enabled': true,
                                                            'consumer': {},
                                                            'config': [
                                                                // {
                                                                //   'parameter': 'consumerID',
                                                                //   'type': 'string',
                                                                //   'value': '',
                                                                //   'description': 'The CONSUMER ID that this plugin configuration will target. This value can only be used if authentication has been enabled so that the system can identify the user making the request. If left blank, the plugin will be applied to all consumers.'
                                                                // },
                                                                {
                                                                    'displayName': 'Allow',
                                                                    'parameter': 'allow',
                                                                    'type': 'array_string',
                                                                    'value': this.partner,
                                                                    'description': 'Tip: Comma separated list of arbitrary group names that are allowed to consume the API. At least one between whitelist or blacklist must be specified.'
                                                                },
                                                                {
                                                                    'displayName': 'Deny',
                                                                    'parameter': 'deny',
                                                                    'type': 'array_string',
                                                                    'value': null,
                                                                    'description': 'Tip: Comma separated list of arbitrary group names that are not allowed to consume the API. At least one between whitelist or blacklist must be specified.'
                                                                },
                                                                {
                                                                    'displayName': 'Hide Groups Header',
                                                                    'parameter': 'hide_groups_header',
                                                                    'type': 'boolean',
                                                                    'value': false,
                                                                    'isRequired': true,
                                                                    'description': 'Flag that if enabled (true), prevents the X-Consumer-Groups header to be sent in the request to the Upstream service'
                                                                }
                                                            ]
                                                        }
                                                    ];
                                                    serviceConfig['type'] = 'kong';
                                                    serviceConfig['config'] = {
                                                        protocol: 'https',
                                                        host: environment.adminGatewayHost,
                                                        port: environment.adminPort
                                                    };
                                                    break;
                                                case 'storage':
                                                    servicePayload['name'] = 'Storage';
                                                    serviceConfig['name'] = 'Storage';
                                                    serviceConfig['provider'] = 'apiplatform.io';
                                                    break;
                                                default:
                                                    servicePayload['name'] = '';
                                                    serviceConfig['name'] = '';
                                                    break;
                                            }
                                            servicePayload['type'] = URLObject['type'];
                                            if (URLObject['type'] === 'apigateway') {
                                                serviceConfig['url'] = [URLObject['url']];
                                            } else {
                                                serviceConfig['url'] = URLObject['url'];
                                            }
                                            serviceConfig['audit_logs'] = [{
                                                action: 'CREATE',
                                                by: this.email,
                                                at: Date.now()
                                            }];
                                            serviceConfig['status'] = URLObject['status'];
                                            serviceConfig['verification_status'] = URLObject['isVerified'];
                                            serviceConfig['env_creation_status_after_verification'] = URLObject['envCreationStatus'];
                                            serviceConfig['is_default'] = true;
                                            serviceConfig['primary_region'] = 'US-East (N.Virginia)';
                                            serviceConfig['cloud'] = 'aws';
                                            serviceConfig['regions'] = ['US-East (N.Virginia)'];
                                            servicePayload.configurations.push(serviceConfig);
                                            response2[0]['environments'][0]['services'].push(servicePayload);
                                        }
                                    }
                                }
                                const tempPayload = {
                                    environments: this.environmentResponseArray,
                                };
                                // this.patchPayload = tempPayload;
                                this.patchPayload = response2;
                                this.patchAdminPartnerSettings(response2[0], response2).then(response3 => {
                                    this.progressMessage = 'Completing super administration console creation … - Done';
                                    this.progress = this.progress + 5;
                                    resolve('success');
                                });
                            }, async error => {
                                await this.platform.notifyErrorToAdmins({error: 'Error while fetching the admin-partner settings account to patch the environment details during onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while notifying admins regarding error while fetching the admin-partner settings account to patch the environment details for the email : ' + this.email + ' while onboarding.', {error: 'Error while fetching the admin-partner settings account to patch the environment details during onboarding.'});
                            });
                        } else {
                            this.validateEachEnvironment().then(response => {
                                // let i = 0;
                                // for (const env of this.environmentResponseArray) {
                                //     i += 1;
                                // if (i === this.environmentResponseArray.length) {
                                let isAdminPresent = false;
                                for (const environment1 of this.environmentResponseArray) {
                                    environment1['isValidationComplete'] = true;
                                    if (environment1['type'] === 'admin') {
                                        isAdminPresent = true;
                                        for (const URLObject of environment1['URLs']) {
                                            if (URLObject['type'] === 'dashboard' && URLObject['isVerified'] !== 'verified') {
                                                this.validateDNS1(URLObject, 3, 10000).then(response => {
                                                    if (this.tempStatusVerification === 'verified') {
                                                        URLObject['isVerified'] = this.tempStatusVerification;
                                                    } else {
                                                        URLObject['isVerified'] = 'not verified';
                                                    }
                                                    this.confPost.getData('services', 'services', 'v1', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(response2 => {
                                                        const tempPayload = {
                                                            environments: this.environmentResponseArray,
                                                        };
                                                        this.patchPayload = tempPayload;
                                                        // this.patchAdminPartnerSettings(tempPayload, response2).then(response3 => {
                                                        //     resolve('success');
                                                        // });
                                                    }, async error => {
                                                        await this.platform.notifyErrorToAdmins({error: 'Error while fetching the admin-partner settings account to patch the environment details after validating DNS during onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while notifying admins regarding error while fetching the admin-partner settings account to patch the environment details after validating DNS for the email : ' + this.email + ' while onboarding.', {error: 'Error while fetching the admin-partner settings account to patch the environment details after validating DNS during onboarding.'});
                                                    });
                                                });
                                            } else {
                                                this.confPost.getData('services', 'services', 'v1', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(response2 => {
                                                    const tempPayload = {
                                                        environments: this.environmentResponseArray,
                                                    };
                                                    this.patchPayload = tempPayload;
                                                    this.patchAdminPartnerSettings(tempPayload, response2).then(response3 => {
                                                        resolve('success');
                                                    });
                                                });
                                            }
                                        }
                                    }
                                }
                                if (!isAdminPresent) {
                                    this.confPost.getData('services', 'services', 'v1', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(response2 => {
                                        for (const env of this.environmentResponseArray) {
                                            response2[0]['environments'].push(env);
                                        }
                                        this.patchAdminPartnerSettings(response2[0], response2).then(response3 => {
                                            resolve('success');
                                        });
                                        // this.confPost.patchEntity('services', 'services', response2[0], 'settings', response2[0]['id']).subscribe(response3 => {
                                        //     this.isEnvironmentsCreationComplete = true;
                                        // });
                                    }, async error => {
                                        await this.platform.notifyErrorToAdmins({error: 'Error while fetching the admin-partner settings account to patch the environment details if environment if admin is not present during onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while notifying admins regarding error while fetching the admin-partner settings account to patch the environment details if admin is not present for the email : ' + this.email + ' while onboarding.', {error: 'Error while fetching the admin-partner settings account to patch the environment details if environment if admin is not present during onboarding.'});
                                    });
                                }
                                // }
                                // }
                            });
                        }
                    });
                } else {
                    resolve('success');
                }
            }, async error => {
                this.environmentCreationRetries += 1;
                if (this.environmentCreationRetries <= 3) {
                    this.pushEnvironment1(payload, environmentParam, environments).then(response => {
                        resolve(response);
                    });
                }
                await this.platform.notifyErrorToAdmins({error: 'Error while creating environments for the partner : ' + this.partner + ' with email : ' + this.email + ' during onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', {error: 'Error while creating environments for the partner : ' + this.partner + ' with email : ' + this.email + ' during onboarding.'}, payload);
            });
        });
    }


    // pushEnvironment(payload) {
    //     return new Promise((resolve, reject) => {
    //         this.confPost.createEnvironment(payload).subscribe(response => {
    //             if (response.status === 200 && response.body['URLs']) {
    //                 resolve(response['body']);
    //             } else {
    //                 const tempResponse = {};
    //                 this.pushEnvironment(payload).then(response2 => {
    //                     tempResponse['body'] = {'URLs': response2['URLs']};
    //                     resolve(tempResponse['body']);
    //                 });
    //             }
    //         }, error => {
    //             const tempResponse = {};
    //             this.pushEnvironment(payload).then(response1 => {
    //                 tempResponse['body'] = {'URLs': response1['URLs']};
    //                 resolve(tempResponse['body']);
    //             });
    //         });
    //     });
    // }

    // invokePushEnvironment(payload) {
    //     // return new Promise((resolve, reject) => {
    //     Promise.resolve(this.pushEnvironment(payload)).then(response => {
    //         const payloadToResend = {
    //             partner: payload['partner'],
    //             account: payload['account'],
    //             configuration: {
    //                 devex: [''],
    //                 dashboard: [''],
    //                 apigateway: [''],
    //                 storage: ['']
    //             }
    //         };
    //         let statusFalseCount = 0;
    //         for (const urlObject of response['URLs']) {
    //             if (urlObject['status'] === true) {
    //                 this.dnsValidationArray.push(urlObject['url']);
    //                 urlObject['isVerified'] = false;
    //                 this.tempURLObjectURLArray.push(urlObject);
    //             } else if (urlObject['status'] === false && this.environmentCreationRetries === 5) {
    //                 urlObject['isVerified'] = false;
    //                 this.tempURLObjectURLArray.push(urlObject);
    //             } else {
    //                 statusFalseCount = statusFalseCount + 1;
    //                 switch (urlObject['type']) {
    //                     case 'dashboard':
    //                         payloadToResend['configuration']['dashboard'] = [this.ciSelected];
    //                         break;
    //                     case 'devex':
    //                         payloadToResend['configuration']['devex'] = [this.ciSelected];
    //                         break;
    //                     case 'apigateway':
    //                         payloadToResend['configuration']['apigateway'] = [this.ciSelected];
    //                         break;
    //                     case 'storage':
    //                         payloadToResend['configuration']['storage'] = [this.ciSelected];
    //                         break;
    //                 }
    //             }
    //         }
    //         if ((statusFalseCount === 0 || this.environmentCreationRetries === 5)) {
    //             let tempEnvironment: any;
    //             const dashboardURL = this.tempURLObjectURLArray[0]['url'];
    //             tempEnvironment = dashboardURL.split('-');
    //             if (tempEnvironment.length > 1) {
    //                 this.orderOfEnvironments.push(tempEnvironment[0]);
    //             } else {
    //                 this.orderOfEnvironments.push('prod');
    //                 tempEnvironment[0] = 'prod';
    //             }
    //             this.URLObject[tempEnvironment[0]] = this.tempURLObjectURLArray;
    //             this.environmentResponse.push(this.tempURLObjectURLArray);
    //             this.tempURLObjectURLArray = [];
    //             // return this.dnsValidationArray;
    //             // if (error) {
    //             //     reject();
    //             // } else {
    //             //     resolve();
    //             // }
    //         } else {
    //             this.environmentCreationRetries += 1;
    //             setTimeout(() => {
    //                 this.invokePushEnvironment(payloadToResend);
    //             }, 3000);
    //         }
    //     });
    //     // });
    // }

    // async createOneEnvironmentAtATime(payload) {
    //     this.environmentCreationRetries = 0;
    //     return new Promise((resolve, reject) => {
    //         Promise.resolve(this.invokePushEnvironment(payload)).then(response => {
    //             resolve(this.dnsValidationArray);
    //         });
    //     });
    //     // $.when(this.invokePushEnvironment(payload)).then(response => {
    //     //     return this.dnsValidationArray;
    //     // });
    // }

    generateKey(partner, account, key) {
        return new Promise((resolve, reject) => {
            this.confPost.generatePartnerKey(partner, account, key).subscribe(response => {
                resolve(response);
            }, async error => {
                reject('failed');
            });
        });
    }

    async getPartnerKey(partner, account, key, environment) {
        return new Promise(async (resolve, reject) => {
            await this.confPost.generatePartnerKey(partner, account, key).subscribe(response => {
                this.item['partnerKey'] = response['token'];
                this.generatedPkey = response['token'];
                this.envPkeys[environment] = response['token'];
                if (environment === 'prod') {
                    this.prodPkey = response['token'];
                }
                resolve('success');
            }, async error => {
                let errorMessage = '';
                if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                    errorMessage = error.error.message;
                } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                    errorMessage = error.error;
                } else {
                    errorMessage = 'Error while fetching partner key for the email : ' + this.email + ' while onboarding.';
                }
                await this.platform.notifyErrorToAdmins({error: 'Error while fetching partner key for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while fetching partner key for the email : ' + this.email + ' while onboarding.', {error: 'Error while fetching partner key for the email : ' + this.email + ' while onboarding.'});
            });
        });
    }

    createAdminRole() {
        return new Promise((resolve, reject) => {
            this._service.addItem(this.rolePayload, 'v1', 'access', 'access', 'roles').subscribe(async resp => {
                this.userPayload.environments[0].roles.push(resp['upsertedId']);
                resolve('success');
            }, async error1 => {
                const error = error1;
                let errorMessage = '';
                if (error && error.error && error.error.message && error.error.message !== '') {
                    errorMessage = error.error.message;
                } else if (error && error.error && error.error !== '') {
                    errorMessage = error.error;
                } else {
                    errorMessage = 'Error while creating role for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.';
                }
                await this.platform.notifyErrorToAdmins({error: 'Error while creating role for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while creating role for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.', {error: 'Error while creating role for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.'});
                resolve('failed');
            });
        });
    }

    addUser() {
        return new Promise((resolve, reject) => {
            this._service.addItem(this.userPayload, 'v1', 'access', 'access', 'users').subscribe(async resp => {
                resolve('success');
            }, async error1 => {
                const error = error1;
                let errorMessage = '';
                if (error && error.error && error.error.message && error.error.message !== '') {
                    errorMessage = error.error.message;
                } else if (error && error.error && error.error !== '') {
                    errorMessage = error.error;
                } else {
                    errorMessage = 'Error while creating user for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.';
                }
                await this.platform.notifyErrorToAdmins({error: 'Error while creating user for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while creating user for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.', {error: 'Error while creating user for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.'});
                resolve('failed');
            });
        });
    }

    retrieveTokenAndPermissions(item) {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.authService.generateAuthenticatorToken(item['partner'],
                this.encryptionDecryptionService.decrypt(item['shash'], item['ralam'], item['account_password']), item['primary_email'])).then(response => {
                    let tokenObj: any;
                    tokenObj = response;
                    this.JWTForThePartnerCreated = tokenObj['token'];
                    resolve('success');
            }, error => {
                resolve('failed');
            });
        });
    }

    // remove this code
    retrieveTokenAndPermissionsOld(item) {
        return new Promise((resolve, reject) => {
            const payload = {
                emailId: item['primary_email'],
                environment: item['partner'],
                password: item['account_password'],
                shash: item['shash'],
                ralam: item['ralam']
            };
            const dt = new Date();
            dt.setMinutes(dt.getMinutes() + 15);
            payload['expiry'] = this.platform.toTimestamp(dt) * 1000;
            this.confPost.validateLogin(payload).subscribe(resp => {
                if (resp.status === 200) {
                    if (resp.body != null) {
                        this.confPost.createJWTToken(payload.environment, payload.environment, item['partnerKey'], {
                            claims: payload,
                            consumedBy: 'apiplatform'
                        }).subscribe(response2 => {
                            if (response2 && response2['body']) {
                                this.JWTForThePartnerCreated = response2['body'];
                                resolve('success');
                            } else {
                                resolve('failed');
                            }
                        }, error1 => {
                            resolve('failed');
                        });
                    } else {
                        resolve('failed');
                    }
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
            });
        });
    }

    async createEnvironmentWithAccount(environmentObject, environmentPayload, environments) {
        const environmentType = environmentObject['type'];
        let partnerCreated = false;
        return new Promise(async (resolve, reject) => {
            this.progressMessage = 'Configuring super administrator user…';
            this.item['environment_type'] = environmentType;
            // await this.sleep(1000);
            if (environmentType === 'admin') {
                this.item['primary'] = true;
                this.item['partner'] = 'admin-' + this.partner;
                this.item['accounts'][0]['account_id'] = this.item['partner'];

                this.userPayload.user = 'admin-' + this.partner;
                this.userPayload.environments[0].name = 'admin-' + this.partner;
                this.userPayload.environments[0].account = 'admin-' + this.partner;

                const consumerData = {
                    'username': this.item['primary_email'],
                    'custom_id': this.item['primary_email'],
                    // 'custom_id': this.item['partner'],
                    'tags': [this.item['partner']]
                };

                this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'initial', info: 'Creating gateway consumer for admin Email'});

                this.kong.createConsumerInApiGateway(consumerData).subscribe(async cons => {
                    this.kong.postKongGatewayAPIkeyDetails(cons['id'], {group: this.partner}, 'acls').subscribe(async cons1 => {
                        this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'success', info: 'Creating gateway consumer for admin Email'});
                    }, async error => {
                        this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'error', info: 'Creating gateway consumer for admin Email'});
                        let errorMessage = '';
                        if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                            errorMessage = error.error.message;
                        } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                            errorMessage = error.error;
                        } else {
                            errorMessage = 'Error while creating consumer group ' + this.item['partner'] + '_default' + ' in api gateway while onboarding.';
                        }
                        await this.platform.notifyErrorToAdmins({error: 'Error while creating consumer group ' + this.item['partner'] + '_default' + ' in api gateway while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while creating consumer in api gateway for the email : ' + this.email + ' while onboarding.', {error: 'Error while creating consumer in api gateway for the email : ' + this.email + ' while onboarding.'});
                    });
                    this.progressMessage = 'Configuring super administrator user… Done';
                    this.progress = this.progress + 3;
                    // await this.sleep(2000);
                    this.consumerCreated = cons;
                    const key = {
                        value: ''
                    };

                    const body = key.value ? {key: key.value} : {};
                    this.progressMessage = 'Configuring API Key Authentication to super admin user… ';
                    this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'initial', info: 'Generating API key for created consumer'});
                    this.kong.provisionKeyAuthToConsumerInApiGatewayByNameOrId(this.consumerCreated.id, body).subscribe(async res => {
                        this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'success', info: 'Generating API key for created consumer'});

                        this.progressMessage = 'Configuring API Key Authentication to super admin user… Done';
                        this.progress = this.progress + 2;
                        // await this.sleep(2000);
                    }, async error => {
                        this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'error', info: 'Generating API key for created consumer'});
                        let errorMessage = '';
                        if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                            errorMessage = error.error.message;
                        } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                            errorMessage = error.error;
                        } else {
                            errorMessage = 'Error while configuring API Key Authentication for the email : ' + this.email + ' while onboarding.';
                        }
                        await this.platform.notifyErrorToAdmins({error: 'Error while configuring API Key Authentication for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while configuring API Key Authentication for the email : ' + this.email + ' while onboarding.', {error: 'Error while configuring API Key Authentication for the email : ' + this.email + ' while onboarding.'});
                    });
                }, async error => {
                    let errorMessage = '';
                    if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                        errorMessage = error.error.message;
                    } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                        errorMessage = error.error;
                    } else {
                        errorMessage = 'Error while creating consumer in api gateway while onboarding.';
                    }
                    await this.platform.notifyErrorToAdmins({error: 'Error while creating consumer in api gateway for the email : ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while creating consumer in api gateway for the email : ' + this.email + ' while onboarding.', {error: 'Error while creating consumer in api gateway for the email : ' + this.email + ' while onboarding.'});
                });

            } else {
                this.item['primary'] = false;
                if (this.adminPkey) {
                    await this.getPartnerKey('admin-' + this.partner, 'admin-' + this.partner, this.adminPkey, environmentType).then(response => {
                    });
                }
                if (environmentType === 'prod') {
                    this.item['partner'] = this.partner;
                    this.item['accounts'][0]['account_id'] = this.partner;
                    this.userPayload.user = this.partner;
                    this.userPayload.environments[0].name = this.partner;
                    this.userPayload.environments[0].account = this.partner;
                } else {
                    this.item['partner'] = environmentType + '-' + this.partner;
                    this.item['accounts'][0]['account_id'] = environmentType + '-' + this.partner;
                    this.userPayload.user = environmentType + this.partner;
                    this.userPayload.environments[0].name = environmentType + this.partner;
                    this.userPayload.environments[0].account = this.partner;
                }
            }
            this.progressMessage = 'Creating partner account…';
            // await this.sleep(1000);

            this.rolePayload.role = this.item['partner'] + '=>' + this.item['partner'] + '=>' + this.email;
            this.rolePayload.partner = this.item['partner'];
            this.rolePayload.account = this.item['partner'];

            await this.confPost.insertPartner(this.item).subscribe(async data => {

                this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'success', info: 'Setting up partner account'});

                this.progressMessage = 'Creating partner account… - Done';

                this.progress = this.progress + 5;

                this.progressMessage = 'Creating user…';

                this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'initial', info: 'Creating user account'});

                await this.createAdminRole();

                await this.addUser();

                await this.retrieveTokenAndPermissions(this.item);

                this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'success', info: 'Creating user account'});


                this.progressMessage = 'Creating user… - Done';

                this.progress = this.progress + 5;
                // await this.sleep(2000);
                this.progressMessage = 'Completing registration process…';
                // await this.sleep(1000);
                await this.confPost.updateOnboardingToken(this.email, this.token).subscribe(async res => {
                    this.progressMessage = 'Completing registration process… - Done';
                }, async error => {
                    let errorMessage = '';
                    if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                        errorMessage = error.error.message;
                    } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                        errorMessage = error.error;
                    } else {
                        errorMessage = 'Error while updating the status of the token for the email : ' + this.email + ' and token : ' + this.token + ' while onboarding.';
                    }
                    await this.platform.notifyErrorToAdmins({error: 'Error while updating the status of the token for the email : ' + this.email + ' and token : ' + this.token + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while updating the status of the token for the email : ' + this.email + ' and token : ' + this.token + ' while onboarding.', {
                        email: this.email,
                        token: this.token
                    });
                });
                // await this.sleep(2000);
                this.progress = this.progress + 2;
                this.emailTemplateInstance.notifyPartnerOnboarding.to.value[0].partner = this.item['partner'];
                // this.confPost.executeEmail(this.emailTemplateInstance.notifyPartnerOnboarding).subscribe(response => {});
                this.progressMessage = 'Configuring super administrator privileges…';
                // await this.sleep(1000);
                this.settingsPayload.environments[0].name = environmentPayload['partner'];

                // Inserted below statement to adher to implementation of database creation separation
                this.settingsPayload.environments[0].services[1].configurations = [];

                this.settingsPayload.partner_name = this.partnerShortCode;
                this.settingsPayload.account_name = this.partnerShortCode;
                this.settingsPayload.environment_type = environmentType;
                this.settingsPayload.environments[0]['partner_name'] = this.partnerShortCode;
                this.settingsPayload.environments[0]['account_name'] = this.partnerShortCode;

                this.tempSettingsPayload = this.settingsPayload;
                this.tempSettingsPayload.partner = this.item['partner'];
                this.tempSettingsPayload.account = this.item['accounts'][0]['account_id'];
                // this.tempSettingsPayload['configurations']['databases'] = this.item['databases'];
                if (environmentType === 'admin') {
                    localStorage.setItem('partnerId', data['id']);
                }
                this.signupDataService.addMessage(environment.signupTitles.ADMIN_ACCOUNT_CREATION, {icon: 'fa fa-user-secret', type: 'initial', info: 'Creating admin environment'});
                await this._service.addItem(this.tempSettingsPayload, 'v2', 'services', 'services', 'settings').subscribe(
                    async data1 => {
                        this.signupDataService.addMessage(environment.signupTitles.ADMIN_ACCOUNT_CREATION, {icon: 'fa fa-user-secret', type: 'success', info: 'Creating admin environment'});

                        this.progressMessage = 'Configuring super administrator privileges… - Done';
                        this.progress = this.progress + 7;
                        // await this.sleep(1000);
                        this.progressMessage = 'Creating super administration console…';
                        // await this.sleep(1000);


                        this.signupDataService.addMessage(environment.signupTitles.ADMIN_ACCOUNT_CREATION, {icon: 'fa fa-user-secret', type: 'initial', info: 'Setting up admin environment console dashboard'});

                        await this.pushEnvironment1(environmentPayload, environmentType, environments).then(async response1 => {
                            await this.confPost.getData('services', 'services', 'v2', 'settings', 'partner=' + environmentPayload['partner'] + '&account=' + environmentPayload['account']).subscribe(response2 => {
                                const s3BucketConnectors = [];
                                for (const env of this.environmentResponseArray) {
                                    if (env['type'] === environmentType) {
                                        // const s3Payload = {};
                                        const servicePayload = {
                                            configurations: []
                                        };
                                        for (const URLObject1 of env['URLs']) {
                                            if (URLObject1['type'] === 'storage') {
                                                const temp = URLObject1['url'].split('/');
                                                // s3Payload['bucketName'] = temp[temp.length - 1];
                                                // s3Payload['defaultBucket'] = true;
                                                const serviceConfig = {};
                                                servicePayload['name'] = 'S3 Bucket Connectors';
                                                servicePayload['type'] = 's3BucketConnectors';
                                                serviceConfig['name'] = 'S3 Bucket Connectors';
                                                serviceConfig['audit_logs'] = [{
                                                    action: 'CREATE',
                                                    by: this.email,
                                                    at: Date.now()
                                                }];
                                                serviceConfig['is_default'] = true,
                                                    serviceConfig['provider'] = 'apiplatform.io';
                                                serviceConfig['bucketName'] = temp[temp.length - 1];
                                                serviceConfig['defaultBucket'] = true;

                                                servicePayload.configurations.push(serviceConfig);
                                                response2[0]['environments'][0]['services'].push(servicePayload);
                                            }
                                        }
                                        // s3BucketConnectors.push(s3Payload);
                                    }
                                }
                                // response2[0]['configurations']['s3BucketConnectors'] = s3BucketConnectors;
                                Promise.resolve(this.patchAdminPartnerSettings(response2[0], response2)).then(response3 => {
                                    partnerCreated = true;
                                    resolve(partnerCreated);
                                });
                            }, async error => {
                                await this.platform.notifyErrorToAdmins({error: 'Error while fetching the admin-partner settings account to patch the s3 connector details environment during onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while fetching the admin-partner settings account to patch the s3 connector details environment during onboarding.', {error: 'Error while fetching the admin-partner settings account to patch the s3 connector details environment during onboarding.'});
                                resolve(partnerCreated);
                            });
                            this.signupDataService.addMessage(environment.signupTitles.ADMIN_ACCOUNT_CREATION, {icon: 'fa fa-user-secret', type: 'success', info: 'Setting up admin environment console dashboard'});
                        });
                        this.patchId = data1['upsertedId'];
                    }, async error => {
                        let errorMessage = '';
                        if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                            errorMessage = error.error.message;
                        } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                            errorMessage = error.error;
                        } else {
                            errorMessage = 'Error while creating a settings record for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.';
                        }
                        await this.platform.notifyErrorToAdmins({error: 'Error while creating a settings record for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while creating a settings record for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.', {error: 'Error while creating a settings record for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.'});
                        resolve(partnerCreated);
                    }
                );

                const appClientData = {
                    'clientName': this.item['partner']
                };
                // const appClientData = {
                //     "clientName": this.item['partner'],
                //     "providerNames": [
                //         "apiplatform-lab"
                //     ]
                // };

                // this.confPost.createAppClientIdForPartner(appClientData).subscribe(appclient => {
                //     this.appClient = appclient;
                //     this.appClientId = this.appClient.customerId;
                // });

                // this.confPost.createRoute53S3Bucket({
                //     'partner': this.item['partner'],
                //     'type': 'dnsInsert'
                // }).subscribe(response => {
                // }, error => {
                // });
            }, async error1 => {
                const error = error1;
                let errorMessage = '';
                if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                    errorMessage = error.error.message;
                } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                    errorMessage = error.error;
                } else {
                    errorMessage = 'Error while creating partner account for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.';
                }
                await this.platform.notifyErrorToAdmins({error: 'Error while creating partner account for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while creating partner account for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.', {error: 'Error while creating partner account for the partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.'});
                // const engagementObject = {
                //     partnerOnboardingStatus: false,
                //     adminEmailPayload: this.emailTemplateInstance.notifyAdmins,
                //     message: 'Partner ' + this.partner + ' with email ' + this.email + ' creation has failed. ' + error1.error.message ? error1.error.message : error1.error
                // };
                // this.confPost.sendEngagementMailDuringOnboarding(engagementObject).subscribe();
                this.showProgressInSummary = false;
                if (partnerCreated === true) {
                    resolve(partnerCreated);
                }
                // alert(this.validationMessage != null ? this.validationMessage : 'Error while creating Partner Account. Please try after sometime or contact support@apiplatform.io');
                this.platform.openSnackBar(this.validationMessage != null ? this.validationMessage : 'Error while creating Partner Account. Please try after sometime or contact support@apiplatform.io', 'error', {
                    duration: 20000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });

                setTimeout(() => {
                    this.router.navigateByUrl('/auth/signup');
                }, 4000);
            });
            if (partnerCreated === true) {
                resolve(partnerCreated);
            }
        });
    }

    createEnvironment(environments, ciSelected) {
        return new Promise(async (resolve, reject) => {
            let i = 0;
            for (const environment of environments) {
                i = i + 1;
                const payload = {
                    partner: '',
                    account: '',
                    configuration: {
                        devex: [ciSelected],
                        dashboard: [ciSelected],
                        apigateway: [ciSelected],
                        storage: [ciSelected]
                    }
                };

                if (environment['type'] === 'prod') {
                    payload.partner = this.partner;
                    payload.account = this.partner;
                } else {
                    payload.partner = environment['type'] + '-' + this.partner;
                    payload.account = environment['type'] + '-' + this.partner;
                }
                await Promise.resolve(this.createEnvironmentWithAccount(environment, payload, environments)).then(async response => {
                    if (i === environments.length) {
                        this.progressMessage = 'Notifying super administrator…';
                        // await this.sleep(1000);
                        this.emailTemplateInstance.welcomeEmail.to.value[0].name = this.partner;
                        this.emailTemplateInstance.welcomeEmail.to.value[0].email = this.email;
                        const engagementObject = {
                            partnerOnboardingStatus: true,
                            partnerEmailPayload: this.emailTemplateInstance.welcomeEmail,
                            adminEmailPayload: this.emailTemplateInstance.notifyAdmins,
                            message: 'Partner ' + this.partner + ' with email ' + this.email + ' has successfully onboarded'
                        };
                        await this.confPost.sendEngagementMailDuringOnboarding(engagementObject).subscribe(res => {
                            // this.progressMessage = 'Notifying super administrator… - Done';
                            this.progressMessage = 'White labeling super administrator account…';
                            this.progress = this.progress + 3;
                        }, async error => {
                            await this.platform.notifyErrorToAdmins({error: 'Error while sending engagement mail to partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while sending engagement mail to partner : ' + this.partner + ' with email ' + this.email + ' while onboarding.', engagementObject);
                        });
                        resolve('success');
                    }

                    // await this.createOneEnvironmentAtATime(payload).then(response1 => {
                    //     // if (this.environmentResponse.length === this.settingsPayload.partner_settings.environment[0].environments.length) {
                    //     if (this.environmentResponse.length > 0) {
                    //         resolve(this.dnsValidationArray);
                    //     } else {
                    //     }
                    // });
                });
            }
        });
    }

    constructItemOnNonSignUp(environments, ciSelected, account_password) {
        return new Promise(async (resolve, reject) => {
            const code = localStorage.getItem('partner');
            const temp = code.split('-');
            if (temp.length > 1) {
                this.partner = temp[temp.length - 1];
            } else {
                this.partner = code;
            }
            await this.confPost.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data => {
                Promise.resolve(this.getPartnerKey(localStorage.getItem('partner'), localStorage.getItem('account'), data['partnerKey'], environments[0])).then(response1 => {
                    this.environmentCreationStart = false;

                    const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                    const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

                    this.item['partner'] = localStorage.getItem('partner');
                    this.item['primary_email'] = data['primary_email'];
                    this.item['primary_phone'] = data['primary_phone'];
                    this.item['primaryRegion'] = data['primaryRegion'];
                    this.item['primaryLanguage'] = data['primaryLanguage'];
                    this.item['partnerKey'] = this.generatedPkey;
                    // this.item['ciSelected'] = data['ciSelected'];
                    // this.item['apiSelected'] = data['apiSelected'];

                    this.item['ralam'] = iv;
                    this.item['shash'] = salt;
                    this.item['account_password'] = this.encrypt(salt, iv, this.passphrase, account_password, this.keySize, this.iterationCount);

                    this.item['partner_organization_type'] = data['partner_organization_type'];
                    this.item['partner_organization_size'] = data['partner_organization_size'];
                    this.item['anticipated_api_count'] = data['anticipated_api_count'];
                    this.item['expected_api_hits'] = data['expected_api_hits'];
                    this.item['partner_organization'] = data['partner_organization'];
                    this.item['currentPlan'] = 'Enterprise';
                    this.item['planHistory'] = [
                        {
                            planName: 'Enterprise',
                            createdDate: Date.now(),
                            removedDate: ''
                        }
                    ]
                    ;
                    this.item['accounts'] = [
                        {
                            account_id: this.item['partner'],
                            account_desc: 'default',
                            account_email: this.item['primary_email'],
                            account_phone: this.item['primary_phone'],
                            account_password: this.encrypt(salt, iv, this.passphrase, account_password, this.keySize, this.iterationCount),
                            account_roles: [],
                            entities: [],
                            operations: []
                        }
                    ];
                    this.item['isActive'] = true;
                    if (data['databases'].length > 0) {
                        this.item['databases'] = data['databases'];
                        this.item['defaultDatabaseType'] = data['defaultDatabaseType'];
                    } else {
                        this.item['databases'] = [];
                        this.item['defaultDatabaseType'] = data['defaultDatabaseType'];
                    }

                    this.createEnvironment(environments, ciSelected).then(response => {
                        if (!(this.router.url.includes('signup'))) {
                            localStorage.setItem('Auth', 'true');
                            localStorage.setItem('currentPlan', this.item['currentPlan']);
                        } else {
                            localStorage.setItem('Auth', 'true');
                            localStorage.setItem('partner', 'admin-' + this.partner);
                            localStorage.setItem('partnerKey', this.adminPkey);
                            localStorage.setItem('currentPlan', this.item['currentPlan']);
                            localStorage.setItem('account', 'admin-' + this.partner);
                        }
                        const dnsValidationPayload = {};
                        dnsValidationPayload['domainName'] = this.dnsValidationArray;
                        this.timesRan = 0;
                        this.validateDNS(dnsValidationPayload);
                        resolve('success');
                    });

                });
            });
        });
    }

    async createInfra(environments, ciSelected, account_password, onboarding = false) {
        if (!(this.router.url.includes('signup'))) {
            await this.constructItemOnNonSignUp(environments, ciSelected, account_password).then(response => {
            });
        } else {
            this.sendMailWhileOnboarding = true;
            await this.createEnvironment(environments, ciSelected).then(async response => {
                if (!(this.router.url.includes('signup'))) {
                    localStorage.setItem('Auth', 'true');
                    localStorage.setItem('currentPlan', this.item['currentPlan']);
                }
                // else {
                //     localStorage.setItem('Auth', 'true');
                //     localStorage.setItem('partner', 'admin-' + this.item['partner']);
                //     localStorage.setItem('partnerKey', this.adminPkey);
                //     localStorage.setItem('currentPlan', this.item['currentPlan']);
                //     localStorage.setItem('account', 'admin-' + this.item['partner']);
                // }

                // await this.sleep(1000);
                this.directNavigationEnvCreationComplete = true;
                const dnsValidationPayload = {};
                dnsValidationPayload['domainName'] = this.dnsValidationArray;
                this.timesRan = 0;
                // this.validateDNS(dnsValidationPayload);

                if (onboarding) {
                    this.progressMessage = 'Creating Development environment…';
                    this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Creating Development environment'});

                    await this.envCreatorService.setUpEnvironment('dev', this.partner, account_password, account_password, [], 'mongodb', this.envPkeys['admin']).then(async response1 => {
                        this.signupDataService.addMessage(environment.signupTitles.DEV_ACCOUNT_CREATION, {icon: 'fa fa-code', type: 'initial', info: 'Validating development environment'});

                        this.item['partner'] = 'dev-' + this.partner;
                        this.item['partnerKey'] = response1['partnerKey'];
                        await this.retrieveTokenAndPermissions(this.item);
                        this.envPkeys['dev'] = response1['partnerKey'];
                        this.progress = this.progress + 30;
                        this.isDirectNavigationToConsole = true;

                        this.navigateToDashboardDirectly('dev', response1['environmentResponseArray']);
                    }, error => {
                        if (this.isDirectNavigationToConsole === true) {
                            this.navigateToDashboardDirectly('admin');
                        }
                    });
                } else {
                    if (this.isDirectNavigationToConsole === true) {
                        this.navigateToDashboardDirectly('admin');
                    }
                }


                if (this.isDirectNavigationToConsole === true) {
                    // this.navigateToDashboardDirectly('admin');
                }
            });
        }
    }

    validateDNS(payload) {
        this.timesRan += 1;
        const payloadToSend = payload;
        this.confPost.dnsValidation(payloadToSend).subscribe(response => {
            if (response.status === 200 && response.body['response']) {
                const responseFromAPI = response.body['response'];
                for (let i = 0; i < responseFromAPI.length; i++) {
                    if (responseFromAPI[i]['status'] === true) {
                        let tempEnvironment = '';
                        const environment = responseFromAPI[i]['hostName'].split('-');
                        if (environment.length > 1) {
                            tempEnvironment = environment[0];
                        } else {
                            tempEnvironment = 'prod';
                        }
                        for (let j = 0; j < this.URLObject[tempEnvironment].length; j++) {
                            if (responseFromAPI[i]['hostName'] === this.URLObject[tempEnvironment][j]['url']) {
                                this.URLObject[tempEnvironment][j]['isVerified'] = true;
                                responseFromAPI.splice(i, 1);
                            }
                        }
                    }
                }
                if (responseFromAPI.length > 0) {
                    if (this.timesRan <= 20) {
                        const dnsPayloadToSend = {};
                        const dnsPayload = [];
                        for (let i = 0; i < responseFromAPI.length; i++) {
                            dnsPayload.push(responseFromAPI[i]['hostName']);
                        }
                        dnsPayloadToSend['domainName'] = dnsPayload;
                        setTimeout(() => {
                            this.validateDNS(payloadToSend);
                        }, 3000);
                    } else {
                        this.isVerified = false;
                    }
                }
            } else {
                if (this.timesRan <= 20) {
                    setTimeout(() => {
                        this.validateDNS(payloadToSend);
                    }, 3000);
                } else {
                    this.isVerified = false;
                }
            }
        }, error => {
            if (this.timesRan <= 20) {
                setTimeout(() => {
                    this.validateDNS(payloadToSend);
                }, 3000);
            } else {
                this.isVerified = false;
            }
        });
    }

    omit_special_char(event) {

        this.partner = this.partner.toLowerCase();
        let k;
        k = event.charCode;  //         k = event.keyCode;  (Both can be used)
        // if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || k === 32 || (k >= 48 && k <= 57)) {
        //     this.item['partner'] = this.partner;
        // }
        return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57));
        // if (k !== 45) {
        //     this.item['partner'] = this.partner;
        // }
        // return (k !== 45);
    }

    manageProgress() {

        if (this.progress === 0) {
            this.createInfra(this.settingsPayload.environments, this.ciSelected, this.password, true);
        }

        // if (this.progress === 100) {
        //     // this.progress = 0;
        // } else {
        //     // this.progress = this.progress + incr;
        // }
        //
        // if (this.progress <= 2) {
        //     // this.progressMessage = 'Setting up Partner Account';
        // } else if (this.progress > 2 && this.progress <= 20) {
        //     // this.progressMessage = 'Setting up cloud infrastructure for your account';
        //     // this.progressStart = false;
        //     // this.progressOver = true;
        // } else if (this.progress > 20 && this.progress <= 45) {
        //     // this.progressMessage = 'Configuring API Gateway for your account';
        //     // this.progressStart2 = false;
        //     // this.progressOver2 = true;
        //     // this.progress2Start = false;
        // } else if (this.progress > 45 && this.progress <= 75) {
        //     // this.progressMessage = 'Configuring DevEx for your account';
        //     // this.progressStart3 = false;
        //     // this.progressOver3 = true;
        //     // this.progress3Start = false;
        // } else if (this.progress > 75 && this.progress <= 90) {
        //     // this.progressMessage = 'Configuring dedicated file Storage for your account';
        //     // this.progressStart4 = false;
        //     // this.progressOver4 = true;
        //     // this.progress4Start = false;
        // } else if (this.progress > 90 && this.progress <= 97) {
        //     // this.progressMessage = 'Creating dedicated data Storage for your account';
        //     // this.progressStart5 = false;
        //     // this.progressOver5 = true;
        //     // this.progress5Start = false;
        // } else if (this.progress > 97 && this.progress <= 100) {
        //     // this.progressMessage = 'Congratulations! You have been on-boarded successfully. If you encounter any issue on accessing aforementioned links, please try after 1 - 2 minutes as it can take sometime for these changes to get reflected on cloud.';
        //     // this.progressStart6 = false;
        //     // this.progressOver6 = true;
        // }
    }

    manageProgress1() {
        if (this.progress === 100) {
            // this.progress = 0;
        } else {
            // let ping = true;
            // if(this.progress == 20){
            //     ping = false;
            // }
            // if (ping) { this.progress = this.progress + incr; } else {
            //     if(ping()) {
            //         this.progress = this.progress + incr;
            //     }
            // }

        }
        if (this.progress <= 2) {
            this.progressMessage = 'Setting up Partner Account';
            this.progressStart = false;
            this.progressOver = true;
        } else if (this.progress > 2 && this.progress <= 20) {
            this.progressMessage = 'Setting up cloud infrastructure for your account';
            this.progressStart2 = false;
            this.progressOver2 = true;
            this.progress2Start = false;
        } else if (this.progress > 20 && this.progress <= 45) {
            this.progressMessage = 'Configuring API Gateway for your account';
            this.progressStart3 = false;
            this.progressOver3 = true;
            this.progress3Start = false;
        } else if (this.progress > 45 && this.progress <= 75) {
            this.progressMessage = 'Configuring DevEx for your account';
            this.progressStart4 = false;
            this.progressOver4 = true;
            this.progress4Start = false;
        } else if (this.progress > 75 && this.progress <= 90) {
            this.progressMessage = 'Configuring dedicated file storage for your account';
            this.progressStart5 = false;
            this.progressOver5 = true;
            this.progress5Start = false;
        } else if (this.progress > 90 && this.progress <= 97) {
            this.progressMessage = 'Creating dedicated data storage for your account';
            this.progressStart6 = false;
            this.progressOver6 = true;
        } else if (this.progress > 97 && this.progress <= 100) {
            this.progressMessage = 'Congratulations! You have been on-boarded successfully.';
            this.progressStart7 = false;
            this.progressOver7 = true;
        }
    }

    getItem() {
        this.confPost.getPartnerOnboard().subscribe(
            items => {
                const itemunit = items[0];
                this.columns = [];
                for (const itemval in itemunit) {
                    this.columns.push(itemval);
                }
            },
            error => {
                // this.platform.openSnackBar('Error while getting item' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                //     duration: 5000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            }
        );
    }

    getLanguages() {
        this.confPost.getLanguages().subscribe(
            items => {
                this.languages = items;
            },
            error => {
                this.platform.openSnackBar('Error while getting list of languages' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        );
    }

    getCloudRegions() {
        this.confPost.getCloudRegions().subscribe(
            items => {
                this.regions = items;
            },
            error => {
                this.platform.openSnackBar('Error while getting list of cloud regions' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        );
    }

    setUserPayload(salt, iv) {
        this.userPayload.partner = this.partner;
        this.userPayload['created_at'] = Date.now();
        this.userPayload.created_by = this.email;
        this.userPayload.email = this.email;
        this.userPayload['last_updated_at'] = Date.now();
        this.userPayload.last_updated_by = this.email;
        this.userPayload.status = true;
        this.userPayload.user_token = this.token;
        this.userPayload.environments[0].audit_logs[0].action = 'CREATE';
        this.userPayload.environments[0].audit_logs[0]['at'] = Date.now();
        this.userPayload.environments[0].audit_logs[0].by = this.email;
        this.userPayload.environments[0].password = this.encrypt(salt, iv, this.passphrase, this.password, this.keySize, this.iterationCount);
        this.userPayload.environments[0].ralam = iv;
        this.userPayload.environments[0].shash = salt;
        this.userPayload.environments[0].roles = [1];
    }

    async sendPartnerData(isDirectNavigationToConsole) {

        //This snippet has been included while refining the partner onboarding flow to have only partner shortcode and passwords section.
        this.partner = this.partner.toLowerCase();
        this.item['partner'] = this.partner;
        this.partnerShortCode = this.item['partner'];
        this.item['defaultDatabaseType'] = 'mongodb';
        this.ciSelected = 'aws';
        this.apiSelected = 'default';

        for (const service of this.settingsPayload.environments[0].services) {
            if (service.type === 'databases') {
                service.configurations[0]['database_name'] = 'default';
                service.configurations[0]['database_type'] = 'mongodb';
            }
        }
        this.settingsPayload.environments[0].cloud[0].type = 'aws';
        this.settingsPayload.environments[0].cloud[0].primary_region = 'US-East (N.Virginia)';
        // this.settingsPayload.partner_settings.vault = this.passwordManager.selectedVault['name'];

        if (this.password && this.password !== null && this.password !== undefined && this.password !== '') {
            if (this.password === this.confirmPassword) {
                if (this.selectedVault) {
                    this.passwordCheck = true;
                    this.isPasswordsValid = true;
                    this.passwordValidationStatement = '';
                    this.passwordPolicyValidator().then(async response => {
                        if (response) {
                            if (this.passwordValidationStatement === '' && this.siteValidationStatement === '') {
                                this.directNavigationLoading = true;


                                this.isDirectNavigationToConsole = isDirectNavigationToConsole;
                                this.showDefaultEnvironments = false;
                                this.environmentCreationStart = false;

                                const iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
                                const salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

                                // this.item['id'] = '';
                                this.item['partner'] = this.partner;
                                this.item['partner_name'] = this.partnerShortCode;
                                this.item['account_name'] = this.partnerShortCode;
                                this.item['partnerKey'] = this.token;
                                this.item['primary_email'] = this.email;
                                this.item['primary_phone'] = this.phoneNumber;
                                this.item['primaryRegion'] = this.regionSelected;
                                this.item['primaryLanguage'] = this.languageSelected;
                                this.item['ciSelected'] = this.ciSelected;
                                this.item['apiSelected'] = this.apiSelected;
                                this.item['partner_organization_type'] = this.selectedOrganizationType;
                                this.item['partner_organization_size'] = this.orgSize;
                                this.item['anticipated_api_count'] = this.reqAPIs;
                                this.item['expected_api_hits'] = this.expectedHits;
                                this.item['partner_organization'] = this.orgName;
                                this.item['currentPlan'] = 'Enterprise';
                                this.item['planHistory'] = [
                                    {
                                        planName: 'Enterprise',
                                        createdDate: Date.now(),
                                        removedDate: ''
                                    }
                                ]
                                ;
                                this.item['accounts'] = [
                                    {
                                        account_id: this.item['partner'],
                                        account_desc: 'default',
                                        account_email: this.email,
                                        account_phone: this.phoneNumber,
                                        // account_password: this.item['account_password'],
                                        account_roles: [],
                                        entities: [],
                                        operations: []
                                    }
                                ];
                                this.item['isActive'] = true;

                                this.signupDataService.addMessage(environment.signupTitles.PARTNER_CREATION, {icon: 'fa fa-user-plus', type: 'initial', info: 'Setting up partner account'});

                                this.setUserPayload(salt, iv);

                                await Promise.resolve(this.generateKey('confap', 'confap', '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc')).then(resp => {
                                    if (resp) {
                                        this.userPayload.user_token = resp['token'];
                                    }
                                });

                                for (const service of this.settingsPayload.environments[0].services) {
                                    if (service['type'] === 'secretsmanager') {
                                        if (service['configurations'][0]['providerName'] === 'Default' || service['configurations'][0]['providerName'] === 'apiplatform.io') {
                                            this.item['ralam'] = iv;
                                            this.item['shash'] = salt;
                                            this.item['account_password'] = this.encrypt(salt, iv, this.passphrase, this.password, this.keySize, this.iterationCount);
                                            this.item['accounts'][0]['account_password'] = this.encrypt(salt, iv, this.passphrase, this.password, this.keySize, this.iterationCount);
                                        } else {
                                            this.item['account_password'] = '';
                                            this.item['accounts'][0]['account_password'] = '';
                                        }
                                    }
                                }

                                //Commented Databases snippet in the partner collection

                                // if (this.databasesPayload.length > 0) {
                                //     // this.item['databases'] = this.databasesPayload;
                                //     this.item['databases'] = [];
                                //     this.item['defaultDatabaseType'] = this.databasesPayload[0]['database_type'];
                                // } else {
                                //     const dbName = 'admin' + this.partner;
                                //     const dbPayload = [{
                                //         database_type: this.databaseSelected,
                                //         database_name: 'default',
                                //         database_attributes: {
                                //             dbName: dbName
                                //         },
                                //         region: '',
                                //         connection_provider: 'apiplatform',
                                //         is_default: true
                                //     }];
                                //     // this.item['databases'] = dbPayload;
                                //     this.item['databases'] = [];
                                //     this.item['defaultDatabaseType'] = this.databaseSelected;
                                // }

                                // Need to get the coupon details from coupon repository
                                if (this.couponName) {
                                    this.listCoupons = [{
                                        'name': this.couponName,
                                        'displayName': this.couponName,
                                        'description': this.couponName
                                    }];
                                    this.item['coupons'] = this.listCoupons;
                                }

                                this.startProgress = true;
                                setInterval(() => this.manageProgress(), 2000);

                                // await this.confPost.isPartnerAlreadyExist(this.item['partner']).subscribe(res => {
                                //     this.partnerExists = res;
                                //     if (this.partnerExists === 'true' || this.partnerExists === true) {
                                //         this.partnerExistsValidation = false;
                                //         //Validate this code whether we need this here or not
                                //         if (this.validationMessage) {
                                //             this.validationMessage = '1.' + this.validationMessage + '. 2. ' + 'Partner with this name already exists.';
                                //         } else {
                                //             this.validationMessage = 'Partner with this name already exists.';
                                //         }
                                //     } else {
                                //         this.partnerExistsValidation = true;
                                //     }
                                //     // this.partnerValidation();
                                //     if (this.partnerCheck && this.passwordCheck) {
                                //         this.progressStart = true;
                                //         this.progressStart3 = true;
                                //         this.progressStart2 = true;
                                //         this.progressStart4 = true;
                                //         this.progressStart5 = true;
                                //         this.progressStart6 = true;
                                //     }
                                //     if (this.validation && this.passwordCheck && this.partnerCheck && this.partnerExistsValidation) {
                                //
                                //         this.showProgressInSummary = true;
                                //
                                //         this.startProgress = true;
                                //         // setInterval(() => this.manageProgress(), 2000);
                                //
                                //         // this.confPost.insertPartner(this.item).subscribe(data => {
                                //         //     this._service.addItem(this.settingsPayload, 'v1', 'services', 'services', 'settings').subscribe();
                                //         //     this.emailTemplateInstance.notifyPartnerOnboarding.to.value[0].partner = this.item['partner'];
                                //         //     // this.confPost.executeEmail(this.emailTemplateInstance.notifyPartnerOnboarding).subscribe(response => {});
                                //         //     localStorage.setItem('Auth', 'true');
                                //         //     localStorage.setItem('partnerId', data['id']);
                                //         //     localStorage.setItem('partner', this.item['partner']);
                                //         //     localStorage.setItem('partnerKey', this.item['partnerKey']);
                                //         //     localStorage.setItem('currentPlan', this.item['currentPlan']);
                                //         //     localStorage.setItem('account', this.item['partner']);
                                //         //
                                //         //     const consumerData = {
                                //         //         'username': this.email,
                                //         //         'custom_id': this.item['partner']
                                //         //     };
                                //         //
                                //         //     this.kong.createConsumerInApiGateway(consumerData).subscribe(cons => {
                                //         //         this.consumerCreated = cons;
                                //         //         const key = {
                                //         //             value: ''
                                //         //         };
                                //         //
                                //         //         const body = key.value ? { key: key.value } : {};
                                //         //         this.kong.provisionKeyAuthToConsumerInApiGatewayByNameOrId(this.consumerCreated.id, body).subscribe();
                                //         //     });
                                //         //
                                //         //
                                //         //
                                //         //     const appClientData = {
                                //         //         'clientName': this.item['partner']
                                //         //     };
                                //         //     // const appClientData = {
                                //         //     //     "clientName": this.item['partner'],
                                //         //     //     "providerNames": [
                                //         //     //         "apiplatform-lab"
                                //         //     //     ]
                                //         //     // };
                                //         //
                                //         //     this.confPost.createAppClientIdForPartner(appClientData).subscribe(appclient => {
                                //         //         this.appClient = appclient;
                                //         //         this.appClientId = this.appClient.customerId;
                                //         //     });
                                //         //     this.confPost.createRoute53S3Bucket({
                                //         //         'partner': this.item['partner'],
                                //         //         'type': 'dnsInsert'
                                //         //     }).subscribe(response => {
                                //         //     }, error => {
                                //         //     });
                                //         //
                                //         // }, error => {
                                //         //     this.showProgressInSummary = false;
                                //         //     this.platform.openSnackBar(this.validationMessage != null ? this.validationMessage : 'Error while creating Partner Account. Please try after sometime or contact support@apiplatform.io', 'error', {
                                //         //         duration: 5000,
                                //         //         verticalPosition: 'top',
                                //         //         horizontalPosition: 'center'
                                //         //     });
                                //         // });
                                //
                                //     } else {
                                //         this.environmentCreationStart = true;
                                //         this.partnerExistsValidation = false;
                                //         this.platform.openSnackBar(this.validationMessage != null ? this.validationMessage : 'Partner with this name already exists.', 'Error', {
                                //             duration: 5000,
                                //             verticalPosition: 'top',
                                //             horizontalPosition: 'center'
                                //         });
                                //         if (this.validationMessage) {
                                //             // this.validationMessage = '1.' + this.validationMessage + '. 2. ' + 'Partner with this name already exists.';
                                //             this.validationMessage = '1.' + this.validationMessage;
                                //         } else {
                                //             this.validationMessage = '1.' + 'Partner with this name already exists.';
                                //         }
                                //     }
                                //
                                // }, error => {
                                //     this.environmentCreationStart = true;
                                //     this.partnerExistsValidation = false;
                                //     if (this.validationMessage) {
                                //         // this.validationMessage = '1.' + this.validationMessage + '. 2. ' + 'Partner with this name already exists.';
                                //         this.validationMessage = '1.' + this.validationMessage;
                                //     } else {
                                //         // this.validationMessage = '1.' + 'Error while validating the existence of Partner.';
                                //         this.validationMessage = '1.' + 'Partner with this name already exists.';
                                //     }
                                // });
                            }
                        } else {
                            this.passwordValidationStatement = 'Please make sure that your password follows our password policy';
                        }
                    });
                } else {
                    this.passwordValidationStatement = 'Please select a vault to proceed';
                }
            } else {
                this.isPasswordsValid = false;
                this.passwordValidationStatement = 'Passwords are not matching - please enter the same password in both Password and Confirm Password fields to proceed further.';
            }
        } else {
            this.passwordValidationStatement = 'Please provide a valid password to get started.';
        }
    }

    async navigateToDashboardDirectly(environmentParam, currentEnvironmentResponseArray = null) {
        this.progressMessage = 'White labeling super administrator account…';
        if (this.JWTForThePartnerCreated) {
            this.directNavigationLoading = true;
            let partner = '';
            if (environmentParam !== 'prod') {
                partner = environmentParam + '-' + this.partner;
            } else {
                partner = this.partner;
            }
            // this.auth.clearLocalStorage();
            // localStorage.setItem('Auth', 'true');
            // localStorage.setItem('partner', partner);
            // localStorage.setItem('partnerKey', this.envPkeys[environmentParam]);
            // localStorage.setItem('currentPlan', this.item['currentPlan']);
            // localStorage.setItem('signInEmail', this.email);
            // localStorage.setItem('account', partner);
            // localStorage.setItem('JWTToken', this.JWTForThePartnerCreated);
            Promise.resolve(this.getApiKeyForUser(this.email)).then(async resp => {
                this.htmlContent = '';
                this.htmlContent += '<div>\n' +
                    '    <table width="100%" align="center">\n' +
                    '        <tbody>\n' +
                    '        <tr>\n' +
                    '            <td bgcolor="#F0F0F0">\n' +
                    '                <table width="90%" align="center" style="max-width: 1150px">\n' +
                    '                    <tbody>\n' +
                    '                    <tr>\n' +
                    '                        <td height="32"></td>\n' +
                    '                    </tr>\n' +
                    '                    <tr>\n' +
                    '                        <td align="left" bgcolor="#FFFFFF" style="border-radius: 2rem;">\n' +
                    '                            <div style="box-shadow: 1px 1px 20px #aaaaaa;border-radius: inherit;">\n' +
                    '                                <table width="100%" align="center">\n' +
                    '                                    <tbody>\n' +
                    '                                    <tr>\n' +
                    '                                        <td></td>\n' +
                    '                                        <td>\n' +
                    '                                            <div style="float:right;padding: 5px 20px 5px 5px;">\n' +
                    '                                                <span style="vertical-align: middle;display: table-cell;"><img style="height:30px;vertical-align:middle;" src="https://console.apiplatform.io/assets/logo/logo.png"></span>\n' +
                    '                                                <span style="vertical-align: middle;display: table-cell;font-family: poppins,sans-serif!important;font-size: 17px;font-weight: 500;padding-left: 4px;"> apiplatform<span>.</span>io</span>\n' +
                    '                                            </div>\n' +
                    '                                        </td>\n' +
                    '                                    </tr>\n' +
                    '                                    <tr>\n' +
                    '                                        <td width="200">\n' +
                    '                                            <span style="vertical-align: middle;display: table-cell;"><img style="height:150px;vertical-align:middle;" src="https://console.apiplatform.io/assets/cover/create-banner-img.jpg"></span>\n' +
                    '                                        </td>\n' +
                    '                                        <td width="100%" style="padding-right: 20px; min-width: 550px; padding-left: 30px" >\n' +
                    '                                            <div style="font-family: poppins,sans-serif!important;word-break: break-word;" >\n' +
                    '\n' +
                    '\n' +
                    '                                                <p>\n' +
                    '                                                    Thank you for choosing apiplatform<span>.</span>io - the future of API Development. We are excited to have you onboard with us.\n' +
                    '                                                </p>\n' +
                    '                                                <p>apiplatform<span>.</span>io offers an end-to-end engineering, integration and management platform for APIs -  consisting the right blend of capabilities and intelligence to develop and deliver your applications instantly. You do not need to look for multiple tools and services installed and configured in silos, as apiplatform<span>.</span>io enables you to get started with your development right away.\n' +
                    '                                                </p>\n' +
                    '                                                <p>\n' +
                    '                                                    We are happy to share the environments created successfully to administer and develop your applications as listed below.\n' +
                    '                                                </p>\n' +
                    '                                                <br>';

                for (const environment1 of this.environmentResponseArray) {

                    this.htmlContent += '<table width="100%" style="border: 1px solid black;max-width: 700px;">\n' +
                        '    <tbody style="background-color: rgb(240,235,235);">\n' +
                        '    <tr align="center" style="background-color: black">\n' +
                        '        <th colspan="2" style="color: white">Environment : ' + environment1['type'] + '-' + this.partner + '</th>\n' +
                        '    </tr>\n' +
                        '    <tr align="left">\n' +
                        '        <th width="30%">Tools and Services</th>\n' +
                        '        <th>URL</th>\n' +
                        '    </tr>';


                    for (const URLObject of environment1['URLs']) {

                        this.htmlContent += '<tr>\n' +
                            '        <td>' + URLObject['type'] + '</td>\n' +
                            '        <td><a href=' + URLObject['url'] + '>' + URLObject['url'] + '</a></td>\n' +
                            '    </tr>';


                    }
                    this.htmlContent += '</tbody>'
                        + '</table><br>';
                }

                this.htmlContent += '<p>We are eager to see you use apiplatform.io that takes you from IDEA to PRODUCT <span style="color: orange;">in half the time, at half the cost.</span> Please feel free to reply to this email if you need any help. </p><br>\n' +
                    '\n' +
                    '                                                <p>\n' +
                    '                                                    Your apiplatform<span>.</span>io team\n' +
                    '                                                </p>\n' +
                    '                                                <p>\n' +
                    '                                                    <a href="mailto:experience@apiplatform.io">experience@apiplatform.io</a>\n' +
                    '                                                </p>';

                this.htmlContent += '</div>\n' +
                    '                                        </td>\n' +
                    '                                    </tr>\n' +
                    '                                    <tr>\n' +
                    '                                        <td height="22" colspan="3"></td>\n' +
                    '                                    </tr>\n' +
                    '                                    </tbody>\n' +
                    '                                </table>\n' +
                    '                            </div>\n' +
                    '                        </td>\n' +
                    '                    </tr>\n' +
                    '                    <tr>\n' +
                    '                        <td height="32"></td>\n' +
                    '                    </tr>\n' +
                    '\n' +
                    '                    </tbody>\n' +
                    '                </table>\n' +
                    '            </td>\n' +
                    '        </tr>\n' +
                    '        </tbody>\n' +
                    '    </table>\n' +
                    '</div>';
                if (this.isDirectNavigationToConsole === true) {
                    if (currentEnvironmentResponseArray === null) {
                        currentEnvironmentResponseArray = this.environmentResponseArray;
                    }
                    for (const environment1 of currentEnvironmentResponseArray) {
                        // environment1['isValidationComplete'] = true;
                        if (environment1['type'] === environmentParam) {
                            for (const URLObject of environment1['URLs']) {
                                if (URLObject['type'] === 'dashboard' && URLObject['isVerified'] !== 'verified') {
                                    await this.validateDNS1(URLObject, 3, 10000).then(async response1 => {
                                        this.progressMessage = 'White labeling super administrator account… - Done';
                                        this.progress = this.progress + 30;
                                        // await this.sleep(2000);
                                        if (this.tempStatusVerification === 'verified') {
                                            URLObject['isVerified'] = this.tempStatusVerification;
                                        } else {
                                            URLObject['isVerified'] = 'not verified';
                                        }
                                        this.progressMessage = 'Redirecting to platform console…';
                                        // this.sleep(1000);
                                        //     this.patchPayload = response2;
                                        this.emailTemplateInstance.environmentURLs.to.value[0].email = this.email;
                                        this.emailTemplateInstance.environmentURLs.body.value = this.htmlContent;
                                        this.confPost.executeEmail(this.emailTemplateInstance.environmentURLs).subscribe(async resp => {
                                        }, async error => {
                                            let errorMessage = '';
                                            if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                                                errorMessage = error.error.message;
                                            } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                                                errorMessage = error.error;
                                            } else {
                                                errorMessage = 'Error while sending the environment URLs for the partner : ' + this.partner + ' while onboarding.';
                                            }
                                            await this.platform.notifyErrorToAdmins({error: 'Error while sending the environment URLs for the partner : ' + this.partner + ' while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while sending the environment URLs for the partner : ' + this.partner + ' while onboarding.', this.emailTemplateInstance.environmentURLs);
                                        });
                                        this.confPost.getData('services', 'services', 'v2', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(resp => {
                                            const platformServices = new Promise((resolve, reject) => {
                                                this.confPost.getData('services', 'services', 'v1', 'platformServices', '').subscribe(response => {
                                                    const iterator = response[Symbol.iterator]();
                                                    while (true) {
                                                        const tempObject = iterator.next();
                                                        if (tempObject.done) {
                                                            break;
                                                        }
                                                        resp[0].subscriptions.platform_services.push(tempObject.value.id);
                                                    }
                                                    resolve('success');
                                                }, async error => {
                                                    await this.platform.notifyErrorToAdmins({error: 'Error while fetching platform services for the partner : ' + this.partner + ' during onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while fetching platform services for the partner : ' + this.partner + ' during onboarding.', {error: 'Error while fetching platform services for the partner : ' + this.partner + ' during onboarding.'});
                                                    resolve('failed');
                                                });
                                            });

                                            const platformServiceCategories = new Promise((resolve, reject) => {
                                                this.confPost.getData('services', 'services', 'v1', 'platformServiceCategories', '').subscribe(response => {
                                                    const iterator = response[Symbol.iterator]();
                                                    while (true) {
                                                        const tempObject = iterator.next();
                                                        if (tempObject.done) {
                                                            break;
                                                        }
                                                        resp[0].subscriptions.platform_service_categories.push(tempObject.value.id);
                                                    }
                                                    resolve('success');
                                                }, async error => {
                                                    await this.platform.notifyErrorToAdmins({error: 'Error while fetching platform services categories for the partner : ' + this.partner + ' during onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while fetching platform services categories for the partner : ' + this.partner + ' during onboarding.', {error: 'Error while fetching platform services categories for the partner : ' + this.partner + ' during onboarding.'});
                                                    resolve('failed');
                                                });
                                            });

                                            Promise.all([platformServices, platformServiceCategories]).then(response4 => {
                                                this.patchAdminPartnerSettings(resp[0], resp).then(response5 => {
                                                    this.progressMessage = 'Redirecting to platform console… - Done';
                                                    this.progress = this.progress + 2;
                                                    // await this.sleep(500);
                                                    // let redirectURL = '';
                                                    // if (URLObject['status'] === true && URLObject['isVerified'] === 'verified') {
                                                    //     if (environment.isOnPremise === false) {
                                                    //         redirectURL = 'https://' + URLObject['url'] + '/authenticator?token=' + this.JWTForThePartnerCreated + '&partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&pk=' + localStorage.getItem('partnerKey');
                                                    //     } else {
                                                    //         redirectURL = environment.platformRedirectURL + '/authenticator?token=' + this.JWTForThePartnerCreated + '&partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&pk=' + localStorage.getItem('partnerKey');
                                                    //     }
                                                    // } else {
                                                    //     redirectURL = environment.platformRedirectURL + '/authenticator?token=' + this.JWTForThePartnerCreated + '&partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&pk=' + localStorage.getItem('partnerKey');
                                                    // }
                                                    // window.location.href = redirectURL;

                                                    Promise.resolve(this.authService.redirectWithAuthenticatorToken(URLObject['status'] === true && URLObject['isVerified'] === 'verified', partner, this.JWTForThePartnerCreated)).then(async resp1 => {
                                                    }, error => {});
                                                });
                                            });
                                        }, async error => {
                                            await this.platform.notifyErrorToAdmins({error: 'Error while fetching admin settings data for the partner : ' + this.partner + ' to patch platform services and categories while onboarding.'}, 'signup_onboarding_notifyerrortoadmins_success', 'signup_onboarding_notifyerrortoadmins_failed', 'Error while fetching admin settings data for the partner : ' + this.partner + ' to patch platform sevices and catgories while onboarding.', {error: 'Error while fetching admin settings data for the partner : ' + this.partner + ' to patch platform sevices and catgories while onboarding.'});
                                            this.progressMessage = 'Redirecting to platform console… - Done';
                                            this.progress = this.progress + 2;
                                            // await this.sleep(500);
                                            let redirectURL = '';
                                            if (URLObject['status'] === true && URLObject['isVerified'] === 'verified') {
                                                if (environment.isOnPremise === false) {
                                                    redirectURL = 'https://' + URLObject['url'] + '/authenticator?token=' + this.JWTForThePartnerCreated + '&partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&pk=' + localStorage.getItem('partnerKey');
                                                } else {
                                                    redirectURL = environment.platformRedirectURL + '/authenticator?token=' + this.JWTForThePartnerCreated + '&partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&pk=' + localStorage.getItem('partnerKey');
                                                }
                                            } else {
                                                redirectURL = environment.platformRedirectURL + '/authenticator?token=' + this.JWTForThePartnerCreated + '&partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&pk=' + localStorage.getItem('partnerKey');
                                            }
                                            window.location.href = redirectURL;
                                        });
                                    });
                                }
                            }
                        }
                    }
                }
            });
        } else {
            this.platform.openSnackBar('Error while retrieving permissions for your partner account. Sorry for the inconvenience. Please login manually.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            // setTimeout(() => {
            //     window.location.href = environment.platformRedirectURL + '/auth/login';
            // }, 5000);
        }
    }

    // navigateToDashboardDirectly(environment) {
    //     if (environment === 'admin') {
    //         this.directNavigationToConsoleLoading = true;
    //         localStorage.setItem('Auth', 'true');
    //         localStorage.setItem('partner', 'admin-' + this.partner);
    //         localStorage.setItem('partnerKey', this.adminPkey);
    //         localStorage.setItem('currentPlan', this.item['currentPlan']);
    //         localStorage.setItem('account', 'admin-' + this.partner);
    //         if (this.isDirectNavigationToConsole === true) {
    //             for (const environment1 of this.environmentResponseArray) {
    //                 // environment1['isValidationComplete'] = true;
    //                 if (environment1['type'] === 'admin') {
    //                     for (const URLObject of environment1['URLs']) {
    //                         if (URLObject['type'] === 'dashboard' && URLObject['isVerified'] !== 'verified') {
    //                             this.validateDNS1(URLObject, 3, 10000).then(response => {
    //                                 if (this.tempStatusVerification === 'verified') {
    //                                     URLObject['isVerified'] = this.tempStatusVerification;
    //                                 } else {
    //                                     URLObject['isVerified'] = 'not verified';
    //                                 }
    //                                 this.confPost.getData('services', 'services', 'v1', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(response2 => {
    //                                     const tempPayload = {
    //                                         environments: this.environmentResponseArray
    //                                     };
    //                                     this.patchPayload = tempPayload;
    //                                     this.patchAdminPartnerSettings(tempPayload, response2).then(response3 => {
    //                                         if (URLObject['status'] === true && URLObject['isVerified'] === 'verified') {
    //                                             window.location.href = 'https://' + URLObject['url'] + '/console';
    //                                         } else {
    //                                             window.location.href = 'https://apiplatform.io/console';
    //                                         }
    //                                     });
    //                                 });
    //                             });
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     } else if (environment === 'prod') {
    //         this.directNavigationToConsoleLoading1 = true;
    //         localStorage.setItem('Auth', 'true');
    //         localStorage.setItem('partner', this.partner);
    //         localStorage.setItem('partnerKey', this.prodPkey);
    //         localStorage.setItem('currentPlan', this.item['currentPlan']);
    //         localStorage.setItem('account', this.partner);
    //         if (this.isDirectNavigationToConsole === true) {
    //             for (const environment1 of this.environmentResponseArray) {
    //                 // environment1['isValidationComplete'] = true;
    //                 if (environment1['type'] === 'prod') {
    //                     for (const URLObject of environment1['URLs']) {
    //                         if (URLObject['type'] === 'dashboard' && URLObject['isVerified'] !== 'verified') {
    //                             this.validateDNS1(URLObject, 3, 10000).then(response => {
    //                                 if (this.tempStatusVerification === 'verified') {
    //                                     URLObject['isVerified'] = this.tempStatusVerification;
    //                                 } else {
    //                                     URLObject['isVerified'] = 'not verified';
    //                                 }
    //                                 this.confPost.getData('services', 'services', 'v1', 'settings', 'partner=' + 'admin-' + this.partner + '&account=' + 'admin-' + this.partner).subscribe(response2 => {
    //                                     const tempPayload = {
    //                                         environments: this.environmentResponseArray
    //                                     };
    //                                     this.patchPayload = tempPayload;
    //                                     this.patchAdminPartnerSettings(tempPayload, response2).then(response3 => {
    //                                         if (URLObject['status'] === true && URLObject['isVerified'] === 'verified') {
    //                                             window.location.href = 'https://' + URLObject['url'] + '/console';
    //                                         } else {
    //                                             window.location.href = 'https://apiplatform.io/console';
    //                                         }
    //                                     });
    //                                 });
    //                             });
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }
    // }


    navigateTODashboard() {
        for (const environment of this.environmentResponseArray) {
            if (environment['type'] === 'admin') {
                for (const URLObject of environment['URLs']) {
                    if (URLObject['type'] === 'dashboard') {
                        if (URLObject['status'] === true && URLObject['isVerified'] === 'verified') {
                            window.location.href = 'https://' + URLObject['url'] + '/console';
                        } else {
                            window.location.href = environment.platformRedirectURL + '/console';
                        }
                    }
                }
            }
        }
        // window.location.href = '/console';
        // this.router.navigate(['/controlplane']);
    }

    gatewaySelected(event) {
        this.summary = [
            {
                title: 'Cloud Environment',
                content: this.ciSelected + ' : ' + this.regionSelected
            },
            {
                title: 'Database',
                content: this.databaseSelected
            },
            {
                title: 'API Gateway',
                content: event
            }
        ];
    };

    // resetDatabaseView(event: MatCheckboxChange) {
    //     if (confirm('This action will remove all your configurations. Do you still want to continue?')) {
    //         this.showDefaultView = true;
    //         this.databasesPayload = [];
    //         this.databaseSelected = 'mongodb';
    //         this.summary = [
    //             {
    //                 title: 'Cloud Environment',
    //                 content: this.ciSelected + ' : ' + this.regionSelected
    //             },
    //             {
    //                 title: 'Database',
    //                 content: this.databaseSelected
    //             },
    //             {
    //                 title: 'API Gateway',
    //                 content: this.settingsPayload.configurations.gateways[0]['gateway_name']
    //             }
    //         ];
    //         this.myCheckbox1.checked = false;
    //     } else {
    //         this.myCheckbox1.checked = false;
    //     }
    // }

    openDialog(event: MatCheckboxChange) {
        if (event.checked) {
            this.databaseSelected = 'mongodb';
            for (let i = 0; i < this.APIGateways.length; i++) {
                const id = 'selectedDB' + i;
                $('#' + id).css('border', 'transparent');
            }
            const dialogRef = this.dialog.open(CreateDatabaseDuringSignUpComponent, {
                disableClose: true,
                width: '50%',
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result !== undefined) {
                    this.databaseSelected = result['database_type'];
                    this.summary = [
                        {
                            title: 'Cloud Environment',
                            content: this.ciSelected + ' : ' + this.regionSelected
                        },
                        {
                            title: 'Database',
                            content: this.databaseSelected
                        },
                        {
                            title: 'API Gateway',
                            // content: this.settingsPayload.configurations.gateways[0]['gateway_name']
                        }
                    ];
                    this.databasesPayload[0] = result;
                    this.myCheckbox.checked = false;
                    this.showDefaultView = false;
                } else {
                    this.databaseSelected = 'mongodb';
                    this.summary = [
                        {
                            title: 'Cloud Environment',
                            content: this.ciSelected + ' : ' + this.regionSelected
                        },
                        {
                            title: 'Database',
                            content: this.databaseSelected
                        },
                        {
                            title: 'API Gateway',
                            // content: this.settingsPayload.configurations.gateways[0]['gateway_name']
                        }
                    ];
                    $('#selectedDB0').css('border', 'transparent');
                    this.myCheckbox.checked = false;
                }
            });
        }
    }

    setDatabaseConnectionPayload(payload) {
        this.databasesPayload[0] = payload;
    }

    editDialog() {
        const dialogRef = this.dialog.open(EditDatabaseDuringSignUpComponent, {
            disableClose: true,
            width: '50%',
            data: this.databasesPayload
        });

        dialogRef.afterClosed().subscribe(result => {
            this.databasesPayload[0] = result;
            this.showDefaultView = false;
        });
    }

}

export interface Task {
    name: string;
    completed: boolean;
    subtasks?: Task[];
}

@Component({
    selector: 'app-create-database-dialog',
    templateUrl: 'database-add.component.html',
    styleUrls: ['database-add.component.css']
})
export class CreateDatabaseDuringSignUpComponent implements OnInit {

    @ViewChild('myForm', {static: false}) public MyForm: NgForm;
    @ViewChild('myForm1', {static: false}) public MyForm1: NgModel;
    @ViewChild('ngModelControl1', {static: false}) public selectDBCtrl: NgModel;

    dbTestLoading = false;
    apiplatformDBConfigurations: any;

    // @ViewChild('myForm2', {static: false}) public MyForm2: NgModel;

    constructor(
        private confPost: ConfService,
        public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<CreateDatabaseDuringSignUpComponent>,
        @Inject(MAT_DIALOG_DATA) public data1: any, public databasesListenerInstance: DatabasesListenerService, public router: Router,
        private parentClass: SignupComponent) {
    }

    disableDbTypeSelector = false;
    disableDbNameInput = false;
    isConfigDb = false;

    item = {
        database_type: '',
        database_name: 'default',
        database_attributes: {}
    };
    showConnectionStringForMongo: boolean;
    back: boolean;
    keys = [];
    connectionTypes = [];
    dataBaseData: any;
    listOfDatabases: any;
    // listOfDatabases = JSON.parse(JSON.stringify(this.platform.databasesMeta)); //['mongodb', 'dynamodb', 'mysql', 'postgresql', 'sqlserver', 'cosmosdb',  'aurora-mysql', 'aurora-postgresql', 'snowflake'];
    defaultDB = 'mongodb';
    dbColumns = [];
    data: any;
    previousSelectedItem: any;
    previousData: any;
    previousSelectedDatabase: any;
    @Input() partner = '';
    @Input() account = '';
    connectionName = '';

    dbConfigurations = [
        {
            database_type: 'mongodb',
            host: 'confap-kgpmn.mongodb.net',
            port: ''
        },
        {
            database_type: 'mysql',
            host: 'apiplatform.cdcoq6gqdomd.us-east-1.rds.amazonaws.com',
            port: '3306'
        },
        {
            database_type: 'postgresql',
            host: 'postgres.cdcoq6gqdomd.us-east-1.rds.amazonaws.com',
            port: '5428'
        },
        {
            database_type: 'sqlserver',
            host: 'apiplatformio.cdcoq6gqdomd.us-east-1.rds.amazonaws.com',
            port: '1433'
        },
        {
            database_type: 'cosmosdb',
            host: '',
            port: ''
        }
    ];
    @Input() configType = '';
    partnerShortcode: any;
    environment = '';
    hasConnectionString = false;
    connectors = ['S3', 'Azure blob storage', 'Dropbox'];
    selectedConnector: any;
    filesInFolder: any;
    task: Task = {
        name: 'CSV',
        completed: true,
        subtasks: [],
    };
    allComplete = true;
    filesSelection = 'selectAll';
    @Input() fromDataCatalog = false;

    omit_special_char(event) {
        if (this.data1 && this.data1['configType'] === 'apiplatform') {
            let k;
            k = event.charCode;
            return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57));
        }
    }

    validatePort(event, value) {
        setTimeout(() => {
            if (this.item['database_attributes']['port'] && this.item['database_attributes']['port'].length > 5) {
                this.item['database_attributes']['port'] = this.item['database_attributes']['port'].substring(0, this.item['database_attributes']['port'].length - 1);
            }
        }, 100);
    }

    async ngOnInit() {
        if (this.partner && this.account && this.configType) {
            this.data1 = {
                partner: this.partner,
                account: this.account,
                configType: this.configType
            };
        }
        if (this.data1) {
            this.defaultDB = localStorage.getItem('selectDB') ? localStorage.getItem('selectDB') : 'mongodb';
            if (this.data1.disableDbTypeSelector) {
                this.disableDbTypeSelector = true;
            }
            if (this.data1.disableDbNameInput) {
                this.disableDbNameInput = true;
            }

            if (this.data1.isConfigDb) {
                this.isConfigDb = true;
            }
        }

        // this.connectionName = this.defaultDB + '-' + this.partner;
        if (this.platform.databasesMeta && this.platform.databasesMeta !== null && this.platform.databasesMeta !== undefined) {
            this.listOfDatabases = JSON.parse(JSON.stringify(this.platform.databasesMeta));
        } else {
            await this.getDatabasesMeta();
        }

        // if data1 === null || undefined -> remove csv from listofdatabases
        if ((this.data1 === null || this.data1 === undefined || (this.data1 && this.data1['configType'] === 'apiplatform'))) {

            this.listOfDatabases = this.listOfDatabases.filter((element) => element['database_type'] !== ('csv'));

        }
        this.item['database_attributes'] = {};
        if (this.data1 && !this.data1.isConfigDb) {
            if (this.data1['partner'] && this.data1['account'] && this.data1['partner'] !== undefined && this.data1['account'] !== undefined && this.data1['partner'] !== null && this.data1['account'] !== null && this.data1['partner'] !== '' && this.data1['account'] !== '') {
                this.partner = this.data1['partner'];
                this.account = this.data1['account'];
            } else {
                this.partner = localStorage.getItem('partner');
                this.account = localStorage.getItem('account');
            }
            const temp = this.partner.split('-');
            if (temp.length > 1) {
                this.partnerShortcode = temp[temp.length - 1];
                this.environment = temp[0];
            } else {
                this.partnerShortcode = temp[0];
            }
            this.connectionName = this.defaultDB + this.environment + this.partnerShortcode;
            this.item['database_name'] = this.connectionName;
            this.configType = this.data1['configType'];
            if (this.defaultDB === 'csv') {
                this.item['database_attributes']['connectionType'] = 'http';
                this.item['database_attributes']['connectTo'] = 'file';
                this.item['database_attributes']['separator'] = '';
            }
            for (let i = 0; i < this.listOfDatabases.length; i++) {
                if (this.data1['configType'] === 'apiplatform' && (this.listOfDatabases[i]['database_type'] === 'cosmosdb' || this.listOfDatabases[i]['database_type'] === 'snowflake')) {
                    this.listOfDatabases.splice(i, 1);
                }
            }
            this.item['database_attributes']['dbName'] = this.environment + this.partnerShortcode;
            if (this.data1['configType'] === 'apiplatform') {
                this.item['database_attributes']['host'] = '';
                this.item['database_attributes']['port'] = '';
            }
        } else {
            this.partner = localStorage.getItem('partner');
            this.account = localStorage.getItem('account');
            this.item['database_name'] = 'default';
        }
        this.previousSelectedItem = this.item;
        this.previousData = this.data;
        this.previousSelectedDatabase = this.defaultDB;
        // this.item['standardConnection'] = false;
        // this.item['srvConnection'] = false;
        this.showConnectionStringForMongo = false;
        this.back = false;
        this.connectionTypes = ['DNS Seedlist Connection', 'Standard Connection'];
        this.getSelectedDBColumn(this.defaultDB);
    }

    updateAllComplete() {
        this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
    }

    someComplete(): boolean {
        if (this.task.subtasks == null) {
            return false;
        }
        return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
    }

    setAll(completed: boolean) {
        this.allComplete = completed;
        if (this.task.subtasks == null) {
            return;
        }
        this.task.subtasks.forEach(t => (t.completed = completed));
    }

    getS3Files(directory) {
        if (directory && directory !== '') {
            directory += '/';
            this.confPost.getS3bucketFiles(this.partner, directory, true).subscribe(response => {
                let resp: any;
                resp = response;
                if (resp && resp.filePaths && resp.filePaths.length) {
                    this.filesInFolder = resp.filePaths;
                    this.task.subtasks = [];
                    for (let i = 1; i < this.filesInFolder.length; i++) {
                        let tempFileName = this.filesInFolder[i].split('/');
                        this.task.subtasks.push({
                            name: tempFileName[1],
                            completed: true,
                        });
                    }
                } else {
                    this.platform.openSnackBar('No files found', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error while fetching files');
            });
        }
    }


    getDatabasesMeta() {
        return new Promise((resolve, reject) => {
            this.confPost.getData('services', 'services', 'v1', 'databaseConfigurations', null).subscribe(response => {
                if (response && response[0]) {
                    this.platform.databasesMeta = response;
                    this.listOfDatabases = JSON.parse(JSON.stringify(this.platform.databasesMeta));
                    resolve('success');
                } else {

                    this.platform.databasesMeta = this.platform.databasesMetaDefault;
                    this.listOfDatabases = JSON.parse(JSON.stringify(this.platform.databasesMeta));
                    resolve('success');
                }
            }, error => {
                this.platform.databasesMeta = this.platform.databasesMetaDefault;
                this.listOfDatabases = JSON.parse(JSON.stringify(this.platform.databasesMeta));
                resolve('success');
            });
        });
    }

    showConnectionString() {
        this.showConnectionStringForMongo = true;
        this.back = true;
    }

    goBackToConnectionType() {
        if (confirm('Navigating back will reset your connection string. Do you still want to continue?')) {
            this.item['database_attributes']['connectionString'] = '';
            this.showConnectionStringForMongo = false;
            this.back = false;
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    toJSON(val) {
        return JSON.stringify(val);
    }

    getSelectedDB(val) {
        if (confirm('Changing the database type will remove all the configuration made so far. Do you still want to continue? ')) {
            this.getSelectedDBColumn(val);
            this.dataBaseData = [];
            if (this.data1) {
                this.item = {
                    database_type: val,
                    database_name: this.defaultDB + this.environment + this.partnerShortcode,
                    database_attributes: {
                        dbName: this.environment + this.partnerShortcode,
                    }
                };
                // if (this.data1['configType'] === 'apiplatform') {
                //     for (const config of this.dbConfigurations) {
                //         if (config.database_type === val) {
                //             this.item['database_attributes']['host'] = config.host;
                //             this.item['database_attributes']['port'] = config.port;
                //         }
                //     }
                // }
                if (val === 'csv') {
                    this.item['database_attributes']['connectionType'] = 'http';
                    this.item['database_attributes']['connectTo'] = 'file';
                    this.item['database_attributes']['separator'] = ',';
                }
            } else {
                this.item = {
                    database_type: val,
                    database_name: 'default',
                    database_attributes: {}
                };
            }
            this.previousSelectedItem = this.item;
            this.previousSelectedDatabase = val;
            // this.previousData = this.data;
        } else {
            this.selectDBCtrl.control.setValue(this.previousSelectedDatabase);
            this.item = this.previousSelectedItem;
            // this.data = this.previousData;
        }
    }


    getSelectedDBColumn(val) {
        this.hasConnectionString = false;
        // const dbColumnsJSON =
        //     [
        //         {
        //             'database_name': '',
        //             'database_type': 'mongodb',
        //             // 'standardConnection': false,
        //             // 'srvConnection': false,
        //             'database_attributes': {
        //                 'username': '',
        //                 'password': '',
        //                 'host': '',
        //                 'port': '',
        //                 'dbName': '',
        //                 'connectionString': ''
        //             }
        //         },
        //         {
        //             'database_name': '',
        //             'database_type': 'dynamodb',
        //             'database_attributes': {
        //                 'access_key': '',
        //                 'secret_key': '',
        //                 'region': ''
        //             }
        //         },
        //         {
        //             'database_name': '',
        //             'database_type': 'oracle',
        //             'database_attributes': {
        //                 'username': '',
        //                 'password': '',
        //                 'host': '',
        //                 'port': '',
        //                 'dbName': '',
        //                 'connectionString': ''
        //             }
        //         },
        //         {
        //             'database_name': '',
        //             'database_type': 'mysql',
        //             'database_attributes': {
        //                 'username': '',
        //                 'password': '',
        //                 'host': '',
        //                 'port': '',
        //                 'dbName': '',
        //                 'connectionString': ''
        //             }
        //         },
        //         {
        //             'database_name': '',
        //             'database_type': 'sqlserver',
        //             'database_attributes': {
        //                 'username': '',
        //                 'password': '',
        //                 'host': '',
        //                 'port': '',
        //                 'dbName': '',
        //                 'connectionString': ''
        //             }
        //         },
        //         {
        //             'database_name': '',
        //             'database_type': 'postgresql',
        //             'database_attributes': {
        //                 'username': '',
        //                 'password': '',
        //                 'host': '',
        //                 'port': '',
        //                 'dbName': '',
        //                 'connectionString': ''
        //             }
        //         },
        //         {
        //             'database_name': '',
        //             'database_type': 'cosmosdb',
        //             'database_attributes': {
        //                 'accountName': '',
        //                 'accountKey': '',
        //                 'tableEndpoint': '',
        //                 'endpointProtocol': ''
        //             }
        //         },
        //         {
        //             'database_name': '',
        //             'database_type': 'aurora-mysql',
        //             'database_attributes': {
        //                 'username': '',
        //                 'password': '',
        //                 'host': '',
        //                 'port': '',
        //                 'dbName': '',
        //                 'connectionString': ''
        //             }
        //         },
        //         {
        //             'database_name': '',
        //             'database_type': 'aurora-postgresql',
        //             'database_attributes': {
        //                 'username': '',
        //                 'password': '',
        //                 'host': '',
        //                 'port': '',
        //                 'dbName': '',
        //                 'connectionString': ''
        //             }
        //         },
        //         {
        //             'database_name': '',
        //             'database_type': 'snowflake',
        //             'database_attributes': {
        //                 'account_name': '',
        //                 'user': '',
        //                 'password': '',
        //                 'authenticator': '',
        //                 'token': '',
        //                 'role': '',
        //                 'dbName': '',
        //                 'schema': '',
        //                 'warehouse': '',
        //                 'tracing': '',
        //                 'passcode': '',
        //                 'passcodeInPassword': '',
        //                 'loginTimeout': '',
        //                 'networkTimeout': '',
        //                 'queryTimeout': '',
        //                 'application': '',
        //                 'disableSocksProxy': '',
        //                 'stringsQuotedForColumnDef': '',
        //                 'CLIENT_SESSION_KEEP_ALIVE': '',
        //                 'connectionString': ''
        //             }
        //         }
        //     ];
        const dataColumn = [];
        this.platform.databasesMeta.filter(items => {
            if (items.database_type === val) {
                dataColumn.push(items);
            }
        });
        this.dbColumns = [];
        const db_type = {};
        db_type['database_type'] = this.defaultDB;
        this.dbColumns.push(db_type);
        for (const item of dataColumn) {
            /*for (const itemval in item) {
                if (itemval != 'database_attribute') {
                    this.dbColumns.push(itemval);
                }
            }*/
            for (const itemval of item.database_attributes) {
                if (itemval['display_name'] === 'Connection String') {
                    this.hasConnectionString = true;
                }
                this.dbColumns.push({display_name: itemval['display_name'], name: itemval['name']});
                this.data = this.dbColumns;
            }
        }
    }

    async testDbConnection(database, db, configType) {

        let val = JSON.parse(JSON.stringify(database));
        val['database_type'] = db;
        if (val['database_type'] === 'csv') {
            // val['database_attributes'] = {
            //     'connectionType': val['database_attributes']['connectionType'],
            //     'connectTo': this.item['database_attributes']['connectTo'],
            //     'connector': this.selectedConnector,
            //     'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom'
            // };
            if (this.item['database_attributes']['connectTo'] === 'file') {
                val['database_attributes'] = {
                    'files': [
                        {
                            'url': val['database_attributes']['url'],
                            'name': val['database_attributes']['name']
                        }
                    ],
                    'connectionType': val['database_attributes']['connectionType'],
                    'connectTo': this.item['database_attributes']['connectTo'],
                    'connector': this.selectedConnector,
                    'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom',
                };
                // val['database_attributes']['files'].push({
                //     'url': val['database_attributes']['url'],
                //     'name': val['database_attributes']['name']
                // });

            } else if (this.item['database_attributes']['connectTo'] !== 'file') {
                val['database_attributes'] = {
                    'files': [],
                    'connectionType': val['database_attributes']['connectionType'],
                    'connectTo': this.item['database_attributes']['connectTo'],
                    'connector': this.selectedConnector,
                    'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom',
                    'URL': this.item['database_attributes']['url']
                };
                for (let i = 0; i < this.task.subtasks.length; i++) {
                    if (this.task.subtasks[i].completed) {
                        val['database_attributes']['files'].push({
                            'url': this.item['database_attributes']['url'] + '/' + this.task.subtasks[i].name,
                            'name': this.task.subtasks[i].name
                        });
                    }
                }
            }
        }
        await (this.platform.encryptDatabaseAttributes(val)).then(resp => {
            val = JSON.parse(JSON.stringify(resp));
            if (val.hasOwnProperty('database')) {
                val = resp['database'];
            }
        });
        if (val['database_type'] === 'mongodb' || val['database_type'] === 'dynamodb') {
            val['is_nosql'] = true;
        } else {
            val['is_nosql'] = false;
        }
        val['connection_provider'] = configType;
        val['is_default'] = true;
        const databases = [];
        if (val['database_type'] === 'mongodb' || val['database_type'] === 'mysql' || val['database_type'] === 'sqlserver' || val['database_type'] === 'postgresql' || val['database_type'] === 'aurora-mysql' || val['database_type'] === 'aurora-postgresql' || val['database_type'] === 'db2') {
            if (val['database_type'] === 'mongodb') {
                if (!this.back) {
                    if (this.data1 && this.data1['configType'] === 'apiplatform') {
                        if (this.MyForm.valid) {
                            val['database_attributes']['connectionString'] = '';
                            this.testConnection(db, val);
                        } else {
                            alert('Please choose one of the connection types');
                        }
                    } else {
                        if (this.MyForm1.valid) {
                            if (this.MyForm.valid) {
                                val['database_attributes']['connectionString'] = '';
                                this.testConnection(db, val);
                            } else {
                                alert('Please choose one of the connection types');
                            }
                        } else {
                            alert('Please provide the database host');
                        }
                    }
                } else {
                    // if (this.MyForm2.valid) {
                    if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                        alert('Please provide a valid connection string');
                    } else {
                        this.testConnection(db, val);
                    }
                    // } else {
                    //     alert('Please provide database_name');
                    // }
                }
            } else {
                if (this.data1 && this.data1['configType'] === 'apiplatform') {
                    this.testConnection(db, val);
                } else {
                    if (!this.back) {
                        if (this.MyForm1.valid) {
                            this.testConnection(db, val);
                        } else {
                            alert('Please provide the database host');
                        }
                    } else {
                        if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                            alert('Please provide a valid connection string');
                        } else {
                            this.testConnection(db, val);
                        }
                    }
                }
            }
        } else if (val['database_type'] === 'snowflake') {
            if (!this.back) {
                this.testConnection(db, val);
            } else {
                if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                    alert('Please provide a valid connection string');
                } else {
                    this.testConnection(db, val);
                }
            }
        } else if (val['database_type'] === 'cosmosdb') {
            // if (this.MyForm2.valid) {
            this.testConnection(db, val);
            // } else {
            //     alert('Please provide database_name');
            // }
        } else {
            this.testConnection(db, val);
        }
    }

    async testDbConnectionOnNonSignUp(database, db, configType) {

        let val = JSON.parse(JSON.stringify(database));

        val['database_type'] = db;
        if (val['database_type'] === 'csv') {
            // val['database_attributes'] = {
            //     'files': [],
            //     'connectionType': val['database_attributes']['connectionType'],
            //     'connectTo': this.item['database_attributes']['connectTo'],
            //     'connector': this.selectedConnector,
            //     'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom',
            // };
            if (this.item['database_attributes']['connectTo'] === 'file') {
                val['database_attributes'] = {
                    'files': [
                        {
                            'url': val['database_attributes']['url'],
                            'name': val['database_attributes']['name']
                        }
                    ],
                    'connectionType': val['database_attributes']['connectionType'],
                    'connectTo': this.item['database_attributes']['connectTo'],
                    'connector': this.selectedConnector,
                    'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom',
                };
                // val['database_attributes']['files'].push({
                //     'url': val['database_attributes']['url'],
                //     'name': val['database_attributes']['name']
                // });
            } else if (this.item['database_attributes']['connectTo'] !== 'file') {
                val['database_attributes'] = {
                    'files': [],
                    'connectionType': val['database_attributes']['connectionType'],
                    'connectTo': this.item['database_attributes']['connectTo'],
                    'connector': this.selectedConnector,
                    'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom',
                    'URL': this.item['database_attributes']['url']
                };
                for (let i = 0; i < this.task.subtasks.length; i++) {
                    if (this.task.subtasks[i].completed) {
                        val['database_attributes']['files'].push({
                            'url': this.item['database_attributes']['url'] + '/' + this.task.subtasks[i].name,
                            'name': this.task.subtasks[i].name
                        });
                    }
                }
            }
        }
        await (this.platform.encryptDatabaseAttributes(val)).then(resp => {
            val = JSON.parse(JSON.stringify(resp));
            if (val.hasOwnProperty('database')) {
                val = resp['database'];
            }
        });
        if (val['database_type'] === 'mongodb' || val['database_type'] === 'dynamodb') {
            val['is_nosql'] = true;
        } else {
            val['is_nosql'] = false;
        }
        val['connection_provider'] = configType;
        val['is_default'] = false;

        const databases = [];
        this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(data => {
            const response = JSON.parse(JSON.stringify(data));
            let DBDetails: any;
            if (response.hasOwnProperty('databaseDetails')) {
                DBDetails = response['databaseDetails'];
            } else {
                DBDetails = response;
            }
            const iterator = DBDetails[Symbol.iterator]();
            while (true) {
                const tempObject = iterator.next();
                if (tempObject.done) {
                    break;
                }
                databases.push(tempObject.value);
            }
            if ((databases.filter(element => element.database_name.toLowerCase() === val.database_name.toLowerCase())).length === 0) {
                if (val['database_type'] === 'mongodb' || val['database_type'] === 'mysql' || val['database_type'] === 'sqlserver' || val['database_type'] === 'postgresql' || val['database_type'] === 'aurora-mysql' || val['database_type'] === 'aurora-postgresql') {
                    if (val['database_type'] === 'mongodb') {
                        if (!this.back) {
                            if (this.data1 && this.data1['configType'] === 'apiplatform') {
                                if (this.MyForm.valid) {
                                    val['database_attributes']['connectionString'] = '';
                                    this.testConnection(db, val);
                                } else {
                                    alert('Please choose one of the connection types');
                                }
                            } else {
                                if (this.MyForm1.valid) {
                                    if (this.MyForm.valid) {
                                        val['database_attributes']['connectionString'] = '';
                                        this.testConnection(db, val);
                                    } else {
                                        alert('Please choose one of the connection types');
                                    }
                                } else {
                                    alert('Please provide the database host');
                                }
                            }
                        } else {
                            // if (this.MyForm2.valid) {
                            if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                                alert('Please provide a valid connection string');
                            } else {
                                this.testConnection(db, val);
                            }
                            // } else {
                            //     alert('Please provide database_name');
                            // }
                        }
                    } else {
                        if (this.data1 && this.data1['configType'] === 'apiplatform') {
                            this.testConnection(db, val);
                        } else {
                            if (!this.back) {
                                if (this.MyForm1.valid) {
                                    this.testConnection(db, val);
                                } else {
                                    alert('Please provide the database host');
                                }
                            } else {
                                if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                                    alert('Please provide a valid connection string');
                                } else {
                                    this.testConnection(db, val);
                                }
                            }
                        }
                    }
                } else if (val['database_type'] === 'snowflake') {
                    if (!this.back) {
                        this.testConnection(db, val);
                    } else {
                        if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                            alert('Please provide a valid connection string');
                        } else {
                            this.testConnection(db, val);
                        }
                    }
                } else if (val['database_type'] === 'cosmosdb') {
                    // if (this.MyForm2.valid) {
                    this.testConnection(db, val);
                    // } else {
                    //     alert('Please provide database_name');
                    // }
                } else if (val['database_type'] === 'csv') {
                    if (!val['database_attributes']['files'][0]['name'] || !val['database_attributes']['connectionType'] || !val['database_attributes']['files'][0]['url']) {
                        alert('please enter valid input');
                    } else {
                        // const payload = {
                        //     'database_name': val['database_name'],
                        //     'database_type': val['database_type'],
                        //     'database_attributes': {
                        //         'files': [
                        //             {
                        //                 'url': val['database_attributes']['files'][0]['url'],
                        //                 'name': val['database_attributes']['files'][0]['name']
                        //             }
                        //         ],
                        //         'connectionType': val['database_attributes']['files'][0]['connectionType']
                        //     },
                        // };
                        this.testConnection(db, val);
                    }
                } else {
                    this.testConnection(db, val);
                }
            } else {
                alert('Database connector with name ' + val.database_name + ' already exists');
            }
        });
    }

    testConnection(db, result) {
        const val = {
            shash: result.hasOwnProperty('shash') ? result['shash'] : '',
            ralam: result.hasOwnProperty('ralam') ? result['ralam'] : '',
        };
        if (result.hasOwnProperty('shash')) {
            delete result['shash'];
        }
        if (result.hasOwnProperty('ralam')) {
            delete result['ralam'];
        }
        val['databaseDetails'] = result;
        this.dbTestLoading = true;
        this.confPost.testConnectionDatabase(val).subscribe(data => {
            this.dbTestLoading = false;
            this.platform.openSnackBar('Connection Successful', 'Success', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.dbTestLoading = false;
            this.platform.handleErrorGracefully(error, 'Connection Failed.');
        });
    }

    createDatabaseInApiplatform(partner, payload) {
        return new Promise((resolve, reject) => {
            this.confPost.addDatabase(partner, payload).subscribe(response => {
                resolve('success');
            }, error => {
                this.platform.handleErrorGracefully(error, 'Error occurred while creating the Database. Please try again after sometime');
                reject('failed');
            });
        });
    }

    createDatabaseOnNonSignup(partner, configType, val, db) {

        if (val['database_name'] === '' || val['database_name'] === null) {
            alert('Please provide a valid database connection name');
        } else if ((val['database_attributes']['dbName'] === '' || val['database_attributes']['dbName'] === null || val['database_attributes']['dbName'] === undefined) && !this.back) {
            alert('Please provide a valid database name');
        } else {
            val['database_type'] = db;
            const databases = [];
            this.confPost.getDatabases(localStorage.getItem('partner')).subscribe(data => {
                const response = JSON.parse(JSON.stringify(data));
                let DBDetails: any;
                if (response.hasOwnProperty('databaseDetails')) {
                    DBDetails = response['databaseDetails'];
                } else {
                    DBDetails = response;
                }
                const iterator = DBDetails[Symbol.iterator]();
                while (true) {
                    const tempObject = iterator.next();
                    if (tempObject.done) {
                        break;
                    }
                    databases.push(tempObject.value);
                }
                if ((databases.filter(element => element.database_name.toLowerCase() === val.database_name.toLowerCase())).length === 0) {
                    if (val['database_type'] === 'mongodb' || val['database_type'] === 'mysql' || val['database_type'] === 'sqlserver' || val['database_type'] === 'postgresql' || val['database_type'] === 'aurora-mysql' || val['database_type'] === 'aurora-postgresql') {
                        if (val['database_type'] === 'mongodb') {
                            if (!this.back) {
                                if (this.data1 && this.data1['configType'] === 'apiplatform') {
                                    // if (this.MyForm.valid) {
                                    val['database_attributes'] = {
                                        dbName: val['database_attributes']['dbName']
                                    };
                                    Promise.resolve(this.createDatabaseInApiplatform(partner, {
                                        databaseType: val['database_type'],
                                        databaseName: val['database_attributes']['dbName']
                                    })).then(resp => {
                                        // val['database_attributes']['connectionString'] = '';
                                        // this.createConnection(db, val);
                                        this.parentClass.setDatabaseConnectionPayload(val);
                                        this.dialogRef.close(val);
                                    }, error => {
                                        this.dialogRef.close();
                                    });
                                    // } else {
                                    //     alert('Please choose one of the connection types');
                                    // }
                                } else {
                                    if (this.MyForm1.valid) {
                                        if (this.MyForm.valid) {
                                            val['database_attributes']['connectionString'] = '';
                                            // this.createConnection(db, val);
                                            this.parentClass.setDatabaseConnectionPayload(val);
                                            this.dialogRef.close(val);
                                        } else {
                                            alert('Please choose one of the connection types');
                                        }
                                    } else {
                                        alert('Please make sure you have provided the database host');
                                    }
                                }
                            } else {
                                // if (this.MyForm2.valid) {
                                if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                                    alert('Please provide a valid connection string');
                                } else {
                                    // this.createConnection(db, val);
                                    this.parentClass.setDatabaseConnectionPayload(val);
                                    this.dialogRef.close(val);
                                }
                                // } else {
                                //     alert('Please provide a database_name');
                                // }
                            }
                        } else {
                            if (this.data1 && this.data1['configType'] === 'apiplatform') {
                                val['database_attributes'] = {
                                    dbName: val['database_attributes']['dbName']
                                };
                                Promise.resolve(this.createDatabaseInApiplatform(partner, {
                                    databaseType: val['database_type'],
                                    databaseName: val['database_attributes']['dbName']
                                })).then(resp => {
                                    // val['database_attributes']['connectionString'] = '';
                                    // this.createConnection(db, val);
                                    this.parentClass.setDatabaseConnectionPayload(val);
                                    this.dialogRef.close(val);
                                }, error => {
                                    this.dialogRef.close();
                                });
                            } else {
                                if (!this.back) {
                                    if (this.MyForm1.valid) {
                                        // this.createConnection(db, val);
                                        this.parentClass.setDatabaseConnectionPayload(val);
                                        this.dialogRef.close(val);
                                    } else {
                                        alert('Please make sure you have provided the database host');
                                    }
                                } else {
                                    if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                                        alert('Please provide a valid connection string');
                                    } else {
                                        // this.createConnection(db, val);
                                        this.parentClass.setDatabaseConnectionPayload(val);
                                        this.dialogRef.close(val);
                                    }
                                }
                            }
                        }
                    } else if (val['database_type'] === 'snowflake') {
                        if (!this.back) {
                            this.parentClass.setDatabaseConnectionPayload(val);
                            this.dialogRef.close(val);
                        } else {
                            if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                                alert('Please provide a valid connection string');
                            } else {
                                // this.createConnection(db, val);
                                this.parentClass.setDatabaseConnectionPayload(val);
                                this.dialogRef.close(val);
                            }
                        }
                    } else if (val['database_type'] === 'cosmosdb') {
                        // if (this.MyForm2.valid) {
                        this.parentClass.setDatabaseConnectionPayload(val);
                        this.dialogRef.close(val);
                        // } else {
                        //     alert('Please provide a database_name');
                        // }
                    } else if (val['database_type'] === 'csv') {
                        if (!val['database_attributes']['name'] || !val['database_attributes']['connectionType'] || !val['database_attributes']['url']) {
                            alert('please enter valid input');
                        } else {
                            let payload = {};
                            payload = {
                                'database_name': val['database_name'],
                                'database_type': val['database_type'],
                                'is_default': false,
                                'is_nosql': false,
                                'database_attributes': {
                                    'files': [],
                                    'connectionType': val['database_attributes']['connectionType'],
                                    'connectTo': this.item['database_attributes']['connectTo'],
                                    'connector': this.selectedConnector,
                                    'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom'
                                }
                            };

                            if (val['database_attributes']['separator'] && val['database_attributes']['separator'] !== '') {
                                payload['database_attributes']['separator'] = val['database_attributes']['separator'];
                            }
                            if (this.item['database_attributes']['connectTo'] === 'file') {
                                // payload = {
                                //     'database_name': val['database_name'],
                                //     'database_type': val['database_type'],
                                //     'is_default': false,
                                //     'is_nosql': false,
                                //     'database_attributes': {
                                //         'files': [
                                //             {
                                //                 'url': val['database_attributes']['url'],
                                //                 'name': val['database_attributes']['name']
                                //             }
                                //         ],
                                //         'connectionType': val['database_attributes']['connectionType']
                                //     }
                                // };
                                payload['database_attributes']['files'].push({
                                    'url': val['database_attributes']['url'],
                                    'name': val['database_attributes']['name']
                                });

                            } else if (this.item['database_attributes']['connectTo'] !== 'file') {
                                // payload = {
                                //     'database_name': val['database_name'],
                                //     'database_type': val['database_type'],
                                //     'is_default': false,
                                //     'is_nosql': false,
                                //     'database_attributes': {}
                                // };
                                // payload['database_attributes'] = {
                                //     'files': [],
                                //     'connectionType': val['database_attributes']['connectionType'],
                                //     'connectTo': this.item['database_attributes']['connectTo'],
                                //     'connector': this.selectedConnector,
                                //     'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom',
                                //     'URL': this.item['database_attributes']['url']
                                // };
                                payload['database_attributes']['URL'] = this.item['database_attributes']['url'];
                                for (let i = 0; i < this.task.subtasks.length; i++) {
                                    if (this.task.subtasks[i].completed) {
                                        payload['database_attributes']['files'].push({
                                            'url': this.item['database_attributes']['url'] + '/' + this.task.subtasks[i].name,
                                            'name': this.task.subtasks[i].name
                                        });
                                    }
                                }
                            }
                            this.parentClass.setDatabaseConnectionPayload(payload);
                            this.dialogRef.close(payload);
                        }
                    } else {
                        val['region'] = val['database_attributes']['region'];
                        this.parentClass.setDatabaseConnectionPayload(val);
                        this.dialogRef.close(val);
                    }
                } else {
                    alert('Database connector with name ' + val.database_name + ' already exists');
                }

            });
        }
    }


    createDatabase(val, db) {
        if (this.fromDataCatalog) {
            if (this.data1) {
                this.data1['configType'] = 'external';
            } else {
                this.data1 = {};
                this.data1['configType'] = 'external';
            }
            this.createDatabaseOnNonSignup(this.partner, 'external', val, db);
        } else {
            if (val['database_name'] === '' || val['database_name'] === null) {
                alert('Please provide a valid database connection name');
            } else if ((val['database_attributes']['dbName'] === '' || val['database_attributes']['dbName'] === null || val['database_attributes']['dbName'] === undefined) && !this.back) {
                alert('Please provide a valid database name');
            } else {
                val['database_type'] = db;
                if (val['database_type'] === 'mongodb' || val['database_type'] === 'mysql' || val['database_type'] === 'sqlserver' || val['database_type'] === 'postgresql' || val['database_type'] === 'aurora-mysql' || val['database_type'] === 'aurora-postgresql' || val['database_type'] === 'db2') {
                    if (val['database_type'] === 'mongodb') {
                        if (!this.back) {
                            if (this.data1 && this.data1['configType'] === 'apiplatform') {
                                if (this.MyForm.valid) {
                                    val['database_attributes']['connectionString'] = '';
                                    // this.createConnection(db, val);
                                    this.parentClass.setDatabaseConnectionPayload(val);
                                    this.dialogRef.close(val);
                                } else {
                                    alert('Please choose one of the connection types');
                                }
                            } else {
                                if (this.MyForm1.valid) {
                                    if (this.MyForm.valid) {
                                        val['database_attributes']['connectionString'] = '';
                                        // this.createConnection(db, val);
                                        this.parentClass.setDatabaseConnectionPayload(val);
                                        this.dialogRef.close(val);
                                    } else {
                                        alert('Please choose one of the connection types');
                                    }
                                } else {
                                    alert('Please make sure you have provided the database host');
                                }
                            }
                        } else {
                            // if (this.MyForm2.valid) {
                            if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                                alert('Please provide a valid connection string');
                            } else {
                                // this.createConnection(db, val);
                                this.parentClass.setDatabaseConnectionPayload(val);
                                this.dialogRef.close(val);
                            }
                            // } else {
                            //     alert('Please provide a database_name');
                            // }
                        }
                    } else {
                        if (this.data1 && this.data1['configType'] === 'apiplatform') {
                            this.parentClass.setDatabaseConnectionPayload(val);
                            this.dialogRef.close(val);
                        } else {
                            if (!this.back) {
                                if (this.MyForm1.valid) {
                                    // this.createConnection(db, val);
                                    this.parentClass.setDatabaseConnectionPayload(val);
                                    this.dialogRef.close(val);
                                } else {
                                    alert('Please make sure you have provided the database host');
                                }
                            } else {
                                if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                                    alert('Please provide a valid connection string');
                                } else {
                                    // this.createConnection(db, val);
                                    this.parentClass.setDatabaseConnectionPayload(val);
                                    this.dialogRef.close(val);
                                }
                            }
                        }
                    }
                } else if (val['database_type'] === 'snowflake') {
                    if (!this.back) {
                        this.parentClass.setDatabaseConnectionPayload(val);
                        this.dialogRef.close(val);
                    } else {
                        if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                            alert('Please provide a valid connection string');
                        } else {
                            // this.createConnection(db, val);
                            this.parentClass.setDatabaseConnectionPayload(val);
                            this.dialogRef.close(val);
                        }
                    }
                } else if (val['database_type'] === 'cosmosdb') {
                    // if (this.MyForm2.valid) {
                    this.parentClass.setDatabaseConnectionPayload(val);
                    this.dialogRef.close(val);
                    // } else {
                    //     alert('Please provide a database_name');
                    // }
                } else if (val['database_type'] === 'cosmosdb') {
                    // if (this.MyForm2.valid) {
                    this.testConnection(db, val);
                    // } else {
                    //     alert('Please provide database_name');
                    // }
                } else if (val['database_type'] === 'csv') {
                    if (!val['database_attributes']['name'] || !val['database_attributes']['connectionType'] || !val['database_attributes']['url']) {
                        alert('please enter valid input');
                    } else {
                        // const payload = {
                        //     'database_name': val['database_name'],
                        //     'database_type': val['database_type'],
                        //     'is_default': false,
                        //     'is_nosql': false,
                        //     'database_attributes': {
                        //         'files': [
                        //             {
                        //                 'url': val['database_attributes']['url'],
                        //                 'name': val['database_attributes']['name']
                        //             }
                        //         ],
                        //         'connectionType': val['database_attributes']['connectionType']
                        //     }
                        // };

                        let payload = {};
                        payload = {
                            'database_name': val['database_name'],
                            'database_type': val['database_type'],
                            'is_default': false,
                            'is_nosql': false,
                            'database_attributes': {
                                'files': [],
                                'connectionType': val['database_attributes']['connectionType'],
                                'connectTo': this.item['database_attributes']['connectTo'],
                                'connector': this.selectedConnector,
                                'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom',
                                'separator': val['database_attributes']['separator'] && val['database_attributes']['separator'] !== '' ? val['database_attributes']['separator'] : null
                            }
                        };
                        if (this.item['database_attributes']['connectTo'] === 'file') {
                            // payload = {
                            //     'database_name': val['database_name'],
                            //     'database_type': val['database_type'],
                            //     'is_default': false,
                            //     'is_nosql': false,
                            //     'database_attributes': {
                            //         'files': [
                            //             {
                            //                 'url': val['database_attributes']['url'],
                            //                 'name': val['database_attributes']['name']
                            //             }
                            //         ],
                            //         'connectionType': val['database_attributes']['connectionType']
                            //     }
                            // };
                            payload['database_attributes']['files'].push({
                                'url': val['database_attributes']['url'],
                                'name': val['database_attributes']['name']
                            });

                        } else if (this.item['database_attributes']['connectTo'] !== 'file') {
                            // payload = {
                            //     'database_name': val['database_name'],
                            //     'database_type': val['database_type'],
                            //     'is_default': false,
                            //     'is_nosql': false,
                            //     'database_attributes': {}
                            // };
                            // payload['database_attributes'] = {
                            //     'files': [],
                            //     'connectionType': val['database_attributes']['connectionType'],
                            //     'connectTo': this.item['database_attributes']['connectTo'],
                            //     'connector': this.selectedConnector,
                            //     'file_selector': this.filesSelection === 'selectAll' ? 'all' : 'custom',
                            //     'URL': this.item['database_attributes']['url']
                            // };
                            payload['database_attributes']['URL'] = this.item['database_attributes']['url'];
                            for (let i = 0; i < this.task.subtasks.length; i++) {
                                if (this.task.subtasks[i].completed) {
                                    payload['database_attributes']['files'].push({
                                        'url': this.item['database_attributes']['url'] + '/' + this.task.subtasks[i].name,
                                        'name': this.task.subtasks[i].name
                                    });
                                }
                            }
                        }
                        this.parentClass.setDatabaseConnectionPayload(payload);
                        this.dialogRef.close(payload);
                    }
                } else {
                    val['region'] = val['database_attributes']['region'];
                    this.parentClass.setDatabaseConnectionPayload(val);
                    this.dialogRef.close(val);
                }
            }
        }
    }

    createConnection(db, result) {
        this.confPost.insertDatabase(localStorage.getItem('partner'), result).subscribe(data => {
            this.platform.openSnackBar('Database created successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.openSnackBar('Error while creating database' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }
}

@Component({
    selector: 'edit-database-dialog',
    templateUrl: 'database-edit.component.html',
    styleUrls: ['database-edit.component.css']
})

export class EditDatabaseDuringSignUpComponent implements OnInit {

    @ViewChild('myform', {static: false}) public MyForm: NgForm;
    @ViewChild('myform1', {static: false}) public MyForm1: NgModel;
    @ViewChild('ngModelControl', {static: false}) public selectDBCtrl: NgModel;

    // @ViewChild('myForm2', {static: false}) public MyForm2: NgModel;

    constructor(
        private confPost: ConfService,
        public platform: LeftpanelComponent,
        public dialogRef: MatDialogRef<EditDatabaseDuringSignUpComponent>,
        @Inject(MAT_DIALOG_DATA) public data,
        private parentClass: SignupComponent) {
    }

    isConfigDb = false;

    item = {};
    showConnectionStringForMongo: boolean;
    back: boolean;
    keys = [];
    connectionTypes = [];
    dataBaseData: any;
    listOfDatabases = ['mongodb', 'dynamodb', 'mysql', 'postgresql', 'sqlserver', 'cosmosdb'];
    defaultDB: any;
    dbColumns = [];
    previousSelecteditem: any;
    alreadyExistingItem: any;

    ngOnInit() {
        let databaseType: any;
        if (this.data) {
            if (Array.isArray(this.data)) {
                this.item = this.data[0];
                databaseType = this.data[0]['database_type'];
            } else {
                this.item = this.data['config'];
                this.isConfigDb = this.data['isConfigDb'];
                databaseType = this.data['database_type'];
            }
        }
        this.defaultDB = this.item['database_type'];
        this.previousSelecteditem = this.item;
        this.alreadyExistingItem = this.item;
        this.showConnectionStringForMongo = false;
        this.back = false;
        this.connectionTypes = ['DNS Seedlist Connection', 'Standard Connection'];
        this.getSelectedDBColumn(databaseType);
    }

    showConnectionString() {
        this.showConnectionStringForMongo = true;
        this.back = true;
    }

    goBackToConnectionType() {
        if (confirm('Navigating back will reset your connection string. Do you still want to continue?')) {
            this.item['database_attributes']['connectionString'] = '';
            this.showConnectionStringForMongo = false;
            this.back = false;
        }
    }

    onNoClick(): void {
        this.dialogRef.close(this.alreadyExistingItem);
    }

    getSelectedDB(value: any) {
        if (confirm('This action is irreversible, Are you sure you want to delete this record?')) {
            this.getSelectedDBColumn(value);
            this.dataBaseData = [];
            this.item = {
                database_type: value,
                database_name: 'default',
                database_attributes: {}
            };
            this.previousSelecteditem = this.item;
        } else {
            this.selectDBCtrl.control.setValue(this.previousSelecteditem['database_type']);
            this.item = this.previousSelecteditem;
        }
    }


    getSelectedDBColumn(val) {
        const dbColumnsJSON =
            [
                {
                    'database_name': '',
                    'database_type': 'mongodb',
                    // 'standardConnection': false,
                    // 'srvConnection': false,
                    'database_attributes': {
                        'username': '',
                        'password': '',
                        'host': '',
                        'port': '',
                        'dbName': '',
                        'connectionString': ''
                    }
                },
                {
                    'database_name': '',
                    'database_type': 'dynamodb',
                    'database_attributes': {
                        'access_key': '',
                        'secret_key': '',
                        'region': ''
                    }
                },
                {
                    'database_name': '',
                    'database_type': 'oracle',
                    'database_attributes': {
                        'username': '',
                        'password': '',
                        'host': '',
                        'port': '',
                        'dbName': '',
                        'connectionString': ''
                    }
                },
                {
                    'database_name': '',
                    'database_type': 'mysql',
                    'database_attributes': {
                        'username': '',
                        'password': '',
                        'host': '',
                        'port': '',
                        'dbName': '',
                        'connectionString': ''
                    }
                },
                {
                    'database_name': '',
                    'database_type': 'sqlserver',
                    'database_attributes': {
                        'username': '',
                        'password': '',
                        'host': '',
                        'port': '',
                        'dbName': '',
                        'connectionString': ''
                    }
                },
                {
                    'database_name': '',
                    'database_type': 'postgresql',
                    'database_attributes': {
                        'username': '',
                        'password': '',
                        'host': '',
                        'port': '',
                        'dbName': '',
                        'connectionString': ''
                    }
                },
                {
                    'database_name': '',
                    'database_type': 'cosmosdb',
                    'database_attributes': {
                        'accountName': '',
                        'accountKey': '',
                        'tableEndpoint': '',
                        'endpointProtocol': ''
                    }
                }
            ];
        const dataColumn = [];
        dbColumnsJSON.filter(items => {
            if (items.database_type === val) {
                dataColumn.push(items);
            }
        });
        this.dbColumns = [];
        const db_type = {};
        db_type['database_type'] = this.defaultDB;
        this.dbColumns.push(db_type);
        for (const item of dataColumn) {
            /*for (const itemval in item) {
                if (itemval != 'database_attribute') {
                    this.dbColumns.push(itemval);
                }
            }*/
            for (const itemval in item.database_attributes) {
                this.dbColumns.push(itemval);
                this.data = this.dbColumns;
            }
        }
    }

    async testDbConnection(database, db, configType) {
        let val = JSON.parse(JSON.stringify(database));
        val['database_type'] = db;
        // if (val['database_type'] === 'csv') {
        //     val['database_attributes'] = {
        //         'files': [
        //             {
        //                 'url': val['database_attributes']['url'],
        //                 'name': val['database_attributes']['name']
        //             }
        //         ],
        //         'connectionType': val['database_attributes']['connectionType']
        //     };
        // }
        await (this.platform.encryptDatabaseAttributes(val)).then(resp => {
            val = JSON.parse(JSON.stringify(resp));
            if (val.hasOwnProperty('database')) {
                val = resp['database'];
            }
        });
        if (val['database_type'] === 'mongodb' || val['database_type'] === 'dynamodb') {
            val['is_nosql'] = true;
        } else {
            val['is_nosql'] = false;
        }
        val['connection_provider'] = configType;
        val['is_default'] = false;

        if (val['database_type'] === 'mongodb' || val['database_type'] === 'mysql' || val['database_type'] === 'sqlserver' || val['database_type'] === 'postgresql') {
            if (val['database_type'] === 'mongodb') {
                if (!this.back) {
                    if (this.MyForm1.valid) {
                        if (this.MyForm.valid) {
                            val['database_attributes']['connectionString'] = '';
                            this.testConnection(db, val);
                        } else {
                            alert('Please choose one of the connection types');
                        }
                    } else {
                        alert('Please provide the database host');
                    }
                } else {
                    // if (this.MyForm2.valid) {
                    if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                        alert('Please provide a valid connection string');
                    } else {
                        this.testConnection(db, val);
                    }
                    // } else {
                    //     alert('Please provide database_name');
                    // }
                }
            } else {
                if (this.MyForm1.valid) {
                    this.testConnection(db, val);
                } else {
                    alert('Please provide the database host');
                }
            }
        } else if (val['database_type'] === 'cosmosdb') {
            // if (this.MyForm2.valid) {
            this.testConnection(db, val);
            // } else {
            //     alert('Please provide database_name');
            // }
        } else {
            this.testConnection(db, val);
        }
    }

    testConnection(db, result) {
        const val = {
            shash: result.hasOwnProperty('shash') ? result['shash'] : '',
            ralam: result.hasOwnProperty('ralam') ? result['ralam'] : '',
        };
        if (result.hasOwnProperty('shash')) {
            delete result['shash'];
        }
        if (result.hasOwnProperty('ralam')) {
            delete result['ralam'];
        }
        val['databaseDetails'] = result;
        this.confPost.testConnectionDatabase(val).subscribe(data => {
            this.platform.openSnackBar('Connection Successful', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while testing database connection');
        });
    }

    createDatabase(val, db) {

        val['database_type'] = db;
        if (val['database_type'] === 'mongodb' || val['database_type'] === 'mysql' || val['database_type'] === 'sqlserver' || val['database_type'] === 'postgresql') {
            if (val['database_type'] === 'mongodb') {
                if (!this.back) {
                    if (this.MyForm1.valid) {
                        if (this.MyForm.valid) {
                            val['database_attributes']['connectionString'] = '';
                            // this.createConnection(db, val);
                            this.parentClass.setDatabaseConnectionPayload(val);
                            this.dialogRef.close(val);
                        } else {
                            alert('Please choose one of the connection types');
                        }
                    } else {
                        alert('Please make sure you have provided the database host');
                    }
                } else {
                    // if (this.MyForm2.valid) {
                    if (val['database_attributes']['connectionString'] === '' || val['database_attributes']['connectionString'] == null) {
                        alert('Please provide a valid connection string');
                    } else {
                        // this.createConnection(db, val);
                        this.parentClass.setDatabaseConnectionPayload(val);
                        this.dialogRef.close(val);
                    }
                    // } else {
                    //     alert('Please provide a database_name');
                    // }
                }
            } else {
                if (this.MyForm1.valid) {
                    // this.createConnection(db, val);
                    this.parentClass.setDatabaseConnectionPayload(val);
                    this.dialogRef.close(val);
                } else {
                    alert('Please make sure you have provided the database host');
                }
            }
        } else if (val['database_type'] === 'cosmosdb') {
            // if (this.MyForm2.valid) {
            this.parentClass.setDatabaseConnectionPayload(val);
            this.dialogRef.close(val);
            // } else {
            //     alert('Please provide a database_name');
            // }
        } else {
            val['region'] = val['database_attributes']['region'];
            this.parentClass.setDatabaseConnectionPayload(val);
            this.dialogRef.close(val);
        }
    }

    createConnection(db, result) {
        this.confPost.insertDatabase(localStorage.getItem('partner'), result).subscribe(data => {
            this.platform.openSnackBar('Database created successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }, error => {
            this.platform.openSnackBar('Error while creating database' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }
}
